/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AccountCreate } from '../models/accountCreate';

import type { AccountResponse } from '../models/accountResponse';

import type { AccountUpdate } from '../models/accountUpdate';

import type { AccountantExportBatchResponse } from '../models/accountantExportBatchResponse';

import type { AccountantExportHistoryResponse } from '../models/accountantExportHistoryResponse';

import type { AccountantExportPreviewResponse } from '../models/accountantExportPreviewResponse';

import type { AccountantExportRequest } from '../models/accountantExportRequest';

import type { AccountantReportScheduleListResponse } from '../models/accountantReportScheduleListResponse';

import type { AccountantReportScheduleResponse } from '../models/accountantReportScheduleResponse';

import type { AccountantReportScheduleUpdate } from '../models/accountantReportScheduleUpdate';

import type { AccountingDashboard } from '../models/accountingDashboard';

import type { ApproveBillApiV1AccountingBillsBillIdApprovePostBody } from '../models/approveBillApiV1AccountingBillsBillIdApprovePostBody';

import type { BankAccountCreateRequest } from '../models/bankAccountCreateRequest';

import type { BankAccountUpdateRequest } from '../models/bankAccountUpdateRequest';

import type { BillCreateRequest } from '../models/billCreateRequest';

import type { BillFilterFacets } from '../models/billFilterFacets';

import type { BillFromReceiptRequest } from '../models/billFromReceiptRequest';

import type { BillFromReceiptsRequest } from '../models/billFromReceiptsRequest';

import type { BillLineCategoriesRequest } from '../models/billLineCategoriesRequest';

import type { BillLinkPoRequest } from '../models/billLinkPoRequest';

import type { BillListResponse } from '../models/billListResponse';

import type { BillReclassificationPreviewResponse } from '../models/billReclassificationPreviewResponse';

import type { BillReclassificationResponse } from '../models/billReclassificationResponse';

import type { BillReclassifyRequest } from '../models/billReclassifyRequest';

import type { BillResponse } from '../models/billResponse';

import type { BillRollupShipmentLinkRequest } from '../models/billRollupShipmentLinkRequest';

import type { BillShipmentLinkRequest } from '../models/billShipmentLinkRequest';

import type { BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams } from '../models/billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams';

import type { BillThreeWayMatchResponse } from '../models/billThreeWayMatchResponse';

import type { BillUpdateRequest } from '../models/billUpdateRequest';

import type { BodyImportAccountsApiV1AccountingAccountsImportPost } from '../models/bodyImportAccountsApiV1AccountingAccountsImportPost';

import type { BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost } from '../models/bodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost';

import type { BulkBillActionRequest } from '../models/bulkBillActionRequest';

import type { BulkInvoiceActionRequest } from '../models/bulkInvoiceActionRequest';

import type { BulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost201 } from '../models/bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost201';

import type { BulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost201 } from '../models/bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost201';

import type { CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams } from '../models/cashFlowStatementReportApiV1AccountingReportsCashFlowGetParams';

import type { CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams } from '../models/cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams';

import type { ChartResetAllRequest } from '../models/chartResetAllRequest';

import type { ChartStatusResponse } from '../models/chartStatusResponse';

import type { CollectionReportApiV1AccountingReportsCollectionGetParams } from '../models/collectionReportApiV1AccountingReportsCollectionGetParams';

import type { ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams } from '../models/comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams';

import type { ConsolidationEliminationReport } from '../models/consolidationEliminationReport';

import type { ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams } from '../models/convertCurrencyApiV1AccountingExchangeRatesConvertGetParams';

import type { CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody } from '../models/createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody';

import type { CreateCurrencyApiV1AccountingCurrenciesPostBody } from '../models/createCurrencyApiV1AccountingCurrenciesPostBody';

import type { CreateExchangeRateApiV1AccountingExchangeRatesPostBody } from '../models/createExchangeRateApiV1AccountingExchangeRatesPostBody';

import type { CreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost201 } from '../models/createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost201';

import type { CreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost201 } from '../models/createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost201';

import type { CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody } from '../models/createVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody';

import type { DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams } from '../models/deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams';

import type { DeleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete200 } from '../models/deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete200';

import type { DeleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete200 } from '../models/deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete200';

import type { DimensionCreate } from '../models/dimensionCreate';

import type { DimensionDefaultRuleCreate } from '../models/dimensionDefaultRuleCreate';

import type { DimensionDefaultRuleUpdate } from '../models/dimensionDefaultRuleUpdate';

import type { DimensionUpdate } from '../models/dimensionUpdate';

import type { DimensionValueCreate } from '../models/dimensionValueCreate';

import type { DimensionValueUpdate } from '../models/dimensionValueUpdate';

import type { DocumentDistributeRequest } from '../models/documentDistributeRequest';

import type { DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams } from '../models/downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams';

import type { ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams } from '../models/expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams';

import type { ExpenseCategoryBulkRequest } from '../models/expenseCategoryBulkRequest';

import type { ExpenseCategoryRuleRequest } from '../models/expenseCategoryRuleRequest';

import type { ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams } from '../models/expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams';

import type { ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams } from '../models/expensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams';

import type { ExportAccountsApiV1AccountingAccountsExportGetParams } from '../models/exportAccountsApiV1AccountingAccountsExportGetParams';

import type { ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams } from '../models/exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams';

import type { ExportBkmvApiV1AccountingExportBkmvGetParams } from '../models/exportBkmvApiV1AccountingExportBkmvGetParams';

import type { ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams } from '../models/exportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams';

import type { ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams } from '../models/exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams';

import type { ExportReportApiV1AccountingReportsReportNameExportGetParams } from '../models/exportReportApiV1AccountingReportsReportNameExportGetParams';

import type { ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams } from '../models/exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams';

import type { FiscalPeriodCreate } from '../models/fiscalPeriodCreate';

import type { FiscalPeriodListResponse } from '../models/fiscalPeriodListResponse';

import type { FiscalPeriodResponse } from '../models/fiscalPeriodResponse';

import type { FxDefaultMarkupResponse } from '../models/fxDefaultMarkupResponse';

import type { FxDefaultMarkupUpdate } from '../models/fxDefaultMarkupUpdate';

import type { FxRatePolicyListResponse } from '../models/fxRatePolicyListResponse';

import type { FxRatePolicyResponse } from '../models/fxRatePolicyResponse';

import type { FxRatePolicyUpsert } from '../models/fxRatePolicyUpsert';

import type { FxRevaluationListResponse } from '../models/fxRevaluationListResponse';

import type { FxRevaluationResponse } from '../models/fxRevaluationResponse';

import type { FxRevaluationRunRequest } from '../models/fxRevaluationRunRequest';

import type { FxRevaluationVoidRequest } from '../models/fxRevaluationVoidRequest';

import type { GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody } from '../models/generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody';

import type { GetAccountApiV1AccountingAccountsAccountIdGetParams } from '../models/getAccountApiV1AccountingAccountsAccountIdGetParams';

import type { GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams } from '../models/getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams';

import type { GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams } from '../models/getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams';

import type { GetAccountingDashboardApiV1AccountingDashboardGetParams } from '../models/getAccountingDashboardApiV1AccountingDashboardGetParams';

import type { GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams } from '../models/getBalanceSheetApiV1AccountingReportsBalanceSheetGetParams';

import type { GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams } from '../models/getBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams';

import type { GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams } from '../models/getGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams';

import type { GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams } from '../models/getIncomeStatementApiV1AccountingReportsIncomeStatementGetParams';

import type { GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams } from '../models/getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams';

import type { GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams } from '../models/getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams';

import type { GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams } from '../models/getPnlByOfficeApiV1AccountingPnlByOfficeGetParams';

import type { GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams } from '../models/getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams';

import type { GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams } from '../models/getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams';

import type { GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams } from '../models/getTrialBalanceApiV1AccountingReportsTrialBalanceGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams } from '../models/incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams';

import type { InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody } from '../models/inheritChartOfAccountsApiV1AccountingAccountsInheritPostBody';

import type { InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody } from '../models/initializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody';

import type { InvoiceAggregatesResponse } from '../models/invoiceAggregatesResponse';

import type { InvoiceCreateRequest } from '../models/invoiceCreateRequest';

import type { InvoiceListResponse } from '../models/invoiceListResponse';

import type { InvoiceResponse } from '../models/invoiceResponse';

import type { InvoiceShipmentLinkRequest } from '../models/invoiceShipmentLinkRequest';

import type { InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams } from '../models/invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams';

import type { InvoiceUpdateRequest } from '../models/invoiceUpdateRequest';

import type { JournalEntryCreate } from '../models/journalEntryCreate';

import type { JournalEntryFilterFacets } from '../models/journalEntryFilterFacets';

import type { JournalEntryResponse } from '../models/journalEntryResponse';

import type { JournalEntryReverseRequest } from '../models/journalEntryReverseRequest';

import type { JournalEntryUpdate } from '../models/journalEntryUpdate';

import type { ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams } from '../models/listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams';

import type { ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams } from '../models/listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams';

import type { ListAccountsApiV1AccountingAccountsGetParams } from '../models/listAccountsApiV1AccountingAccountsGetParams';

import type { ListBankAccountsApiV1AccountingBankAccountsGetParams } from '../models/listBankAccountsApiV1AccountingBankAccountsGetParams';

import type { ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams } from '../models/listBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams';

import type { ListBillsApiV1AccountingBillsGetParams } from '../models/listBillsApiV1AccountingBillsGetParams';

import type { ListCurrenciesApiV1AccountingCurrenciesGetParams } from '../models/listCurrenciesApiV1AccountingCurrenciesGetParams';

import type { ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams } from '../models/listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams';

import type { ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams } from '../models/listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams';

import type { ListDimensionsApiV1AccountingDimensionsGetParams } from '../models/listDimensionsApiV1AccountingDimensionsGetParams';

import type { ListExchangeRatesApiV1AccountingExchangeRatesGetParams } from '../models/listExchangeRatesApiV1AccountingExchangeRatesGetParams';

import type { ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet200 } from '../models/listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet200';

import type { ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams } from '../models/listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams';

import type { ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams } from '../models/listFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams';

import type { ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams } from '../models/listFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams';

import type { ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams } from '../models/listFxRevaluationsApiV1AccountingFxRevaluationsGetParams';

import type { ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams } from '../models/listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams';

import type { ListInvoicesApiV1AccountingInvoicesGetParams } from '../models/listInvoicesApiV1AccountingInvoicesGetParams';

import type { ListJournalEntriesApiV1AccountingJournalEntriesGetParams } from '../models/listJournalEntriesApiV1AccountingJournalEntriesGetParams';

import type { ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams } from '../models/listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams';

import type { ListPaymentTermsApiV1AccountingPaymentTermsGetParams } from '../models/listPaymentTermsApiV1AccountingPaymentTermsGetParams';

import type { ListPaymentsApiV1AccountingPaymentsGetParams } from '../models/listPaymentsApiV1AccountingPaymentsGetParams';

import type { ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams } from '../models/listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams';

import type { ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams } from '../models/listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams';

import type { ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet200 } from '../models/listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet200';

import type { ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams } from '../models/listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams';

import type { ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams } from '../models/listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams';

import type { ListTaxRatesApiV1AccountingTaxRatesGetParams } from '../models/listTaxRatesApiV1AccountingTaxRatesGetParams';

import type { ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams } from '../models/listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams';

import type { ListVendorRulesApiV1AccountingVendorRulesGetParams } from '../models/listVendorRulesApiV1AccountingVendorRulesGetParams';

import type { PaymentAllocateRequest } from '../models/paymentAllocateRequest';

import type { PaymentCreateRequest } from '../models/paymentCreateRequest';

import type { PaymentDistributeResponse } from '../models/paymentDistributeResponse';

import type { PaymentTermCreate } from '../models/paymentTermCreate';

import type { PaymentTermLineListResponse } from '../models/paymentTermLineListResponse';

import type { PaymentTermLinesReplace } from '../models/paymentTermLinesReplace';

import type { PaymentTermListResponse } from '../models/paymentTermListResponse';

import type { PaymentTermResponse } from '../models/paymentTermResponse';

import type { PaymentTermUpdate } from '../models/paymentTermUpdate';

import type { PnlByOfficeResponse } from '../models/pnlByOfficeResponse';

import type { PnlOfficeDetailsResponse } from '../models/pnlOfficeDetailsResponse';

import type { PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams } from '../models/previewAccountantExportApiV1AccountingAccountantExportPreviewGetParams';

import type { ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams } from '../models/profitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams';

import type { ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams } from '../models/profitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams';

import type { ReimbursementClearBatchRequest } from '../models/reimbursementClearBatchRequest';

import type { ReimbursementClearBatchResponse } from '../models/reimbursementClearBatchResponse';

import type { ReimbursementClearRequest } from '../models/reimbursementClearRequest';

import type { ReimbursementClearResponse } from '../models/reimbursementClearResponse';

import type { ReimbursementPayerBalanceListResponse } from '../models/reimbursementPayerBalanceListResponse';

import type { ReimbursementPayerTransactionsResponse } from '../models/reimbursementPayerTransactionsResponse';

import type { ReportTrendApiV1AccountingFriendlyReportsTrendGetParams } from '../models/reportTrendApiV1AccountingFriendlyReportsTrendGetParams';

import type { ResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost200 } from '../models/resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost200';

import type { ResolveExpenseAccountRequest } from '../models/resolveExpenseAccountRequest';

import type { ResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost200 } from '../models/resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost200';

import type { ResolveRevenueAccountRequest } from '../models/resolveRevenueAccountRequest';

import type { RevenueCategoryBulkRequest } from '../models/revenueCategoryBulkRequest';

import type { RevenueCategoryRuleRequest } from '../models/revenueCategoryRuleRequest';

import type { SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams } from '../models/suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams';

import type { SuggestAccountRequest } from '../models/suggestAccountRequest';

import type { SuggestExpenseAccountRequest } from '../models/suggestExpenseAccountRequest';

import type { SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams } from '../models/summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams';

import type { SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams } from '../models/summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams';

import type { TaxDeterminationResolveRequest } from '../models/taxDeterminationResolveRequest';

import type { TaxDeterminationRuleCreateRequest } from '../models/taxDeterminationRuleCreateRequest';

import type { TaxDeterminationRuleUpdateRequest } from '../models/taxDeterminationRuleUpdateRequest';

import type { TaxRateCreateRequest } from '../models/taxRateCreateRequest';

import type { TaxRateUpdateRequest } from '../models/taxRateUpdateRequest';

import type { VatReportApiV1AccountingReportsVatGetParams } from '../models/vatReportApiV1AccountingReportsVatGetParams';

import type { VendorRuleCreateRequest } from '../models/vendorRuleCreateRequest';

import type { VendorRuleUpdateRequest } from '../models/vendorRuleUpdateRequest';

import type { WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams } from '../models/withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams';

import type { WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams } from '../models/withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams';

import type { WriteOffRequest } from '../models/writeOffRequest';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List all accounts.

``company_id`` narrows the chart to one legal entity (resolved through CoA
inheritance by the repository). A document-driven consumer — the
record-payment dialog's bank-account picker — must pass the source
document's company: with no app-bar scope selected the unscoped read
aggregates every accessible company's chart, offering another company's bank
accounts and duplicating account numbers shared across charts (ACC-J3/J5).
Falls back to the app-bar scope when omitted; an inaccessible company is
rejected 403 by the resolver.

``postable_only`` narrows the chart to the account types a *document line* may
be posted to (``POSTABLE_LINE_ACCOUNT_TYPES``). The bill-line override picker
asks for it by intent rather than naming the types, so it cannot drift from
the extractor's own candidate roster the way ``account_type=expense`` did —
that hid every ``direct_cost`` and ``asset`` account the AI had just matched
lines to (ACC-J2). Mutually exclusive with an explicit ``account_type``.
 * @summary List Accounts
 */
export const listAccountsApiV1AccountingAccountsGet = (
  params?: ListAccountsApiV1AccountingAccountsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAccountsApiV1AccountingAccountsGetQueryKey = (
  params?: ListAccountsApiV1AccountingAccountsGetParams
) => {
  return [`/api/v1/accounting/accounts`, ...(params ? [params] : [])] as const;
};

export const getListAccountsApiV1AccountingAccountsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAccountsApiV1AccountingAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAccountsApiV1AccountingAccountsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>
  > = ({ signal }) => listAccountsApiV1AccountingAccountsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAccountsApiV1AccountingAccountsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>
>;
export type ListAccountsApiV1AccountingAccountsGetQueryError =
  HTTPValidationError;

export function useListAccountsApiV1AccountingAccountsGet<
  TData = Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListAccountsApiV1AccountingAccountsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAccountsApiV1AccountingAccountsGet<
  TData = Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAccountsApiV1AccountingAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAccountsApiV1AccountingAccountsGet<
  TData = Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAccountsApiV1AccountingAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Accounts
 */

export function useListAccountsApiV1AccountingAccountsGet<
  TData = Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAccountsApiV1AccountingAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAccountsApiV1AccountingAccountsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListAccountsApiV1AccountingAccountsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new account.

Refused for a company whose ``coa_mode`` is ``inherit``: it posts against its
parent's chart and owns no account rows of its own (``inherit_chart_of_accounts``
refuses to set ``inherit`` on a company that has any), so there is no chart of
its own to add one to. Writing under the raw id would put the row on NO effective
chart at all — invisible in the company's CoA list and refused by
``CompanyChart.excludes()`` at every posting seam — and silently writing onto the
RESOLVED parent's chart would add an account every sibling subsidiary sees, from a
dialog naming only the subsidiary. The CoA page already renders an inherited chart
read-only with "Create separate chart" as its only mutating affordance; this says
the same thing server-side. The bulk COA import takes the other answer and forks
the chart (``ChartOfAccountsImporter._ensure_owns_chart``) — uploading a whole
chart against a company IS that gesture; typing one account is not.
 * @summary Create Account
 */
export const createAccountApiV1AccountingAccountsPost = (
  accountCreate: AccountCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: accountCreate,
    signal
  });
};

export const getCreateAccountApiV1AccountingAccountsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountApiV1AccountingAccountsPost>>,
    TError,
    { data: AccountCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountApiV1AccountingAccountsPost>>,
  TError,
  { data: AccountCreate },
  TContext
> => {
  const mutationKey = ['createAccountApiV1AccountingAccountsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountApiV1AccountingAccountsPost>>,
    { data: AccountCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createAccountApiV1AccountingAccountsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountApiV1AccountingAccountsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createAccountApiV1AccountingAccountsPost>>
  >;
export type CreateAccountApiV1AccountingAccountsPostMutationBody =
  AccountCreate;
export type CreateAccountApiV1AccountingAccountsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Account
 */
export const useCreateAccountApiV1AccountingAccountsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAccountApiV1AccountingAccountsPost>>,
      TError,
      { data: AccountCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAccountApiV1AccountingAccountsPost>>,
  TError,
  { data: AccountCreate },
  TContext
> => {
  const mutationOptions =
    getCreateAccountApiV1AccountingAccountsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get chart of accounts initialization status for the active company.

Per-company and inheritance-aware: a company whose chart is inherited from a
parent reports ``is_initialized=true`` with ``coa_mode='inherit'`` and the
resolved ``effective_company_id``. When no active company resolves (legacy
single-company tenants), falls back to the tenant-wide status.
 * @summary Get Chart Status
 */
export const getChartStatusApiV1AccountingAccountsStatusGet = (
  signal?: AbortSignal
) => {
  return customInstance<ChartStatusResponse>({
    url: `/api/v1/accounting/accounts/status`,
    method: 'GET',
    signal
  });
};

export const getGetChartStatusApiV1AccountingAccountsStatusGetQueryKey = () => {
  return [`/api/v1/accounting/accounts/status`] as const;
};

export const getGetChartStatusApiV1AccountingAccountsStatusGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetChartStatusApiV1AccountingAccountsStatusGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>>
  > = ({ signal }) => getChartStatusApiV1AccountingAccountsStatusGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetChartStatusApiV1AccountingAccountsStatusGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>>
  >;
export type GetChartStatusApiV1AccountingAccountsStatusGetQueryError = unknown;

export function useGetChartStatusApiV1AccountingAccountsStatusGet<
  TData = Awaited<
    ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChartStatusApiV1AccountingAccountsStatusGet<
  TData = Awaited<
    ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChartStatusApiV1AccountingAccountsStatusGet<
  TData = Awaited<
    ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Chart Status
 */

export function useGetChartStatusApiV1AccountingAccountsStatusGet<
  TData = Awaited<
    ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getChartStatusApiV1AccountingAccountsStatusGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetChartStatusApiV1AccountingAccountsStatusGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export a company's chart of accounts as a downloadable tabular file.
 * @summary Export Accounts
 */
export const exportAccountsApiV1AccountingAccountsExportGet = (
  params?: ExportAccountsApiV1AccountingAccountsExportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/export`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportAccountsApiV1AccountingAccountsExportGetQueryKey = (
  params?: ExportAccountsApiV1AccountingAccountsExportGetParams
) => {
  return [
    `/api/v1/accounting/accounts/export`,
    ...(params ? [params] : [])
  ] as const;
};

export const getExportAccountsApiV1AccountingAccountsExportGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
  >,
  TError = HTTPValidationError
>(
  params?: ExportAccountsApiV1AccountingAccountsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExportAccountsApiV1AccountingAccountsExportGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>>
  > = ({ signal }) =>
    exportAccountsApiV1AccountingAccountsExportGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExportAccountsApiV1AccountingAccountsExportGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>>
  >;
export type ExportAccountsApiV1AccountingAccountsExportGetQueryError =
  HTTPValidationError;

export function useExportAccountsApiV1AccountingAccountsExportGet<
  TData = Awaited<
    ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ExportAccountsApiV1AccountingAccountsExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportAccountsApiV1AccountingAccountsExportGet<
  TData = Awaited<
    ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
  >,
  TError = HTTPValidationError
>(
  params?: ExportAccountsApiV1AccountingAccountsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportAccountsApiV1AccountingAccountsExportGet<
  TData = Awaited<
    ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
  >,
  TError = HTTPValidationError
>(
  params?: ExportAccountsApiV1AccountingAccountsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Accounts
 */

export function useExportAccountsApiV1AccountingAccountsExportGet<
  TData = Awaited<
    ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
  >,
  TError = HTTPValidationError
>(
  params?: ExportAccountsApiV1AccountingAccountsExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportAccountsApiV1AccountingAccountsExportGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportAccountsApiV1AccountingAccountsExportGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Parse an uploaded file and return columns + suggested field mappings + sample.
 * @summary Preview Accounts Import
 */
export const previewAccountsImportApiV1AccountingAccountsImportPreviewPost = (
  bodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost: BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `file`,
    bodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost.file
  );

  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/import/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getPreviewAccountsImportApiV1AccountingAccountsImportPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewAccountsImportApiV1AccountingAccountsImportPreviewPost
        >
      >,
      TError,
      {
        data: BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof previewAccountsImportApiV1AccountingAccountsImportPreviewPost
      >
    >,
    TError,
    { data: BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost },
    TContext
  > => {
    const mutationKey = [
      'previewAccountsImportApiV1AccountingAccountsImportPreviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof previewAccountsImportApiV1AccountingAccountsImportPreviewPost
        >
      >,
      {
        data: BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost;
      }
    > = (props) => {
      const { data } = props ?? {};

      return previewAccountsImportApiV1AccountingAccountsImportPreviewPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewAccountsImportApiV1AccountingAccountsImportPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewAccountsImportApiV1AccountingAccountsImportPreviewPost
      >
    >
  >;
export type PreviewAccountsImportApiV1AccountingAccountsImportPreviewPostMutationBody =
  BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost;
export type PreviewAccountsImportApiV1AccountingAccountsImportPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Preview Accounts Import
 */
export const usePreviewAccountsImportApiV1AccountingAccountsImportPreviewPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof previewAccountsImportApiV1AccountingAccountsImportPreviewPost
          >
        >,
        TError,
        {
          data: BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof previewAccountsImportApiV1AccountingAccountsImportPreviewPost
      >
    >,
    TError,
    { data: BodyPreviewAccountsImportApiV1AccountingAccountsImportPreviewPost },
    TContext
  > => {
    const mutationOptions =
      getPreviewAccountsImportApiV1AccountingAccountsImportPreviewPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Import GL accounts from an uploaded file using the supplied column mappings.
 * @summary Import Accounts
 */
export const importAccountsApiV1AccountingAccountsImportPost = (
  bodyImportAccountsApiV1AccountingAccountsImportPost: BodyImportAccountsApiV1AccountingAccountsImportPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `file`,
    bodyImportAccountsApiV1AccountingAccountsImportPost.file
  );
  formData.append(
    `mappings`,
    bodyImportAccountsApiV1AccountingAccountsImportPost.mappings
  );
  if (
    bodyImportAccountsApiV1AccountingAccountsImportPost.company_id !==
      undefined &&
    bodyImportAccountsApiV1AccountingAccountsImportPost.company_id !== null
  ) {
    formData.append(
      `company_id`,
      bodyImportAccountsApiV1AccountingAccountsImportPost.company_id
    );
  }

  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getImportAccountsApiV1AccountingAccountsImportPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof importAccountsApiV1AccountingAccountsImportPost>
      >,
      TError,
      { data: BodyImportAccountsApiV1AccountingAccountsImportPost },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof importAccountsApiV1AccountingAccountsImportPost>>,
    TError,
    { data: BodyImportAccountsApiV1AccountingAccountsImportPost },
    TContext
  > => {
    const mutationKey = ['importAccountsApiV1AccountingAccountsImportPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof importAccountsApiV1AccountingAccountsImportPost>
      >,
      { data: BodyImportAccountsApiV1AccountingAccountsImportPost }
    > = (props) => {
      const { data } = props ?? {};

      return importAccountsApiV1AccountingAccountsImportPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ImportAccountsApiV1AccountingAccountsImportPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof importAccountsApiV1AccountingAccountsImportPost>>
  >;
export type ImportAccountsApiV1AccountingAccountsImportPostMutationBody =
  BodyImportAccountsApiV1AccountingAccountsImportPost;
export type ImportAccountsApiV1AccountingAccountsImportPostMutationError =
  HTTPValidationError;

/**
 * @summary Import Accounts
 */
export const useImportAccountsApiV1AccountingAccountsImportPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof importAccountsApiV1AccountingAccountsImportPost>
      >,
      TError,
      { data: BodyImportAccountsApiV1AccountingAccountsImportPost },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importAccountsApiV1AccountingAccountsImportPost>>,
  TError,
  { data: BodyImportAccountsApiV1AccountingAccountsImportPost },
  TContext
> => {
  const mutationOptions =
    getImportAccountsApiV1AccountingAccountsImportPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deterministic (no-AI) next-number suggestion for a new account, plus the
category window it falls in and (for expenses) the categories to group under.
Backs the smart Create Account dialog's number prefill + range hint.
 * @summary Suggest Account Number
 */
export const suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet = (
  params?: SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/number-suggestion`,
    method: 'GET',
    params,
    signal
  });
};

export const getSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetQueryKey =
  (
    params?: SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams
  ) => {
    return [
      `/api/v1/accounting/accounts/number-suggestion`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
        >
      >
    > = ({ signal }) =>
      suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
      >
    >
  >;
export type SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetQueryError =
  HTTPValidationError;

export function useSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet<
  TData = Awaited<
    ReturnType<
      typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet<
  TData = Awaited<
    ReturnType<
      typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet<
  TData = Awaited<
    ReturnType<
      typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Suggest Account Number
 */

export function useSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet<
  TData = Awaited<
    ReturnType<
      typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: SuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof suggestAccountNumberApiV1AccountingAccountsNumberSuggestionGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getSuggestAccountNumberApiV1AccountingAccountsNumberSuggestionGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single account by ID, scoped to the caller's company access.
 * @summary Get Account
 */
export const getAccountApiV1AccountingAccountsAccountIdGet = (
  accountId: string,
  params?: GetAccountApiV1AccountingAccountsAccountIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<AccountResponse>({
    url: `/api/v1/accounting/accounts/${accountId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetAccountApiV1AccountingAccountsAccountIdGetQueryKey = (
  accountId?: string,
  params?: GetAccountApiV1AccountingAccountsAccountIdGetParams
) => {
  return [
    `/api/v1/accounting/accounts/${accountId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetAccountApiV1AccountingAccountsAccountIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountApiV1AccountingAccountsAccountIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAccountApiV1AccountingAccountsAccountIdGetQueryKey(accountId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>>
  > = ({ signal }) =>
    getAccountApiV1AccountingAccountsAccountIdGet(accountId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!accountId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAccountApiV1AccountingAccountsAccountIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>>
  >;
export type GetAccountApiV1AccountingAccountsAccountIdGetQueryError =
  HTTPValidationError;

export function useGetAccountApiV1AccountingAccountsAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params: undefined | GetAccountApiV1AccountingAccountsAccountIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAccountApiV1AccountingAccountsAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountApiV1AccountingAccountsAccountIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAccountApiV1AccountingAccountsAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountApiV1AccountingAccountsAccountIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Account
 */

export function useGetAccountApiV1AccountingAccountsAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountApiV1AccountingAccountsAccountIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountApiV1AccountingAccountsAccountIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAccountApiV1AccountingAccountsAccountIdGetQueryOptions(
      accountId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an account.
 * @summary Update Account
 */
export const updateAccountApiV1AccountingAccountsAccountIdPut = (
  accountId: string,
  accountUpdate: AccountUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/${accountId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: accountUpdate
  });
};

export const getUpdateAccountApiV1AccountingAccountsAccountIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateAccountApiV1AccountingAccountsAccountIdPut>
      >,
      TError,
      { accountId: string; data: AccountUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateAccountApiV1AccountingAccountsAccountIdPut>
    >,
    TError,
    { accountId: string; data: AccountUpdate },
    TContext
  > => {
    const mutationKey = ['updateAccountApiV1AccountingAccountsAccountIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateAccountApiV1AccountingAccountsAccountIdPut>
      >,
      { accountId: string; data: AccountUpdate }
    > = (props) => {
      const { accountId, data } = props ?? {};

      return updateAccountApiV1AccountingAccountsAccountIdPut(accountId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateAccountApiV1AccountingAccountsAccountIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateAccountApiV1AccountingAccountsAccountIdPut>>
  >;
export type UpdateAccountApiV1AccountingAccountsAccountIdPutMutationBody =
  AccountUpdate;
export type UpdateAccountApiV1AccountingAccountsAccountIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Account
 */
export const useUpdateAccountApiV1AccountingAccountsAccountIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateAccountApiV1AccountingAccountsAccountIdPut>
      >,
      TError,
      { accountId: string; data: AccountUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAccountApiV1AccountingAccountsAccountIdPut>>,
  TError,
  { accountId: string; data: AccountUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateAccountApiV1AccountingAccountsAccountIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete or deactivate an account.
 * @summary Delete Account
 */
export const deleteAccountApiV1AccountingAccountsAccountIdDelete = (
  accountId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/${accountId}`,
    method: 'DELETE'
  });
};

export const getDeleteAccountApiV1AccountingAccountsAccountIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteAccountApiV1AccountingAccountsAccountIdDelete>
      >,
      TError,
      { accountId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteAccountApiV1AccountingAccountsAccountIdDelete>
    >,
    TError,
    { accountId: string },
    TContext
  > => {
    const mutationKey = ['deleteAccountApiV1AccountingAccountsAccountIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteAccountApiV1AccountingAccountsAccountIdDelete>
      >,
      { accountId: string }
    > = (props) => {
      const { accountId } = props ?? {};

      return deleteAccountApiV1AccountingAccountsAccountIdDelete(accountId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAccountApiV1AccountingAccountsAccountIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteAccountApiV1AccountingAccountsAccountIdDelete>
    >
  >;

export type DeleteAccountApiV1AccountingAccountsAccountIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Account
 */
export const useDeleteAccountApiV1AccountingAccountsAccountIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteAccountApiV1AccountingAccountsAccountIdDelete>
      >,
      TError,
      { accountId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteAccountApiV1AccountingAccountsAccountIdDelete>
  >,
  TError,
  { accountId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteAccountApiV1AccountingAccountsAccountIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Initialize the default chart of accounts.
 * @summary Initialize Default Accounts
 */
export const initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/accounts/initialize-default`,
      method: 'POST',
      signal
    });
  };

export const getInitializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost
        >
      >,
      void
    > = () => {
      return initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type InitializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost
      >
    >
  >;

export type InitializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPostMutationError =
  unknown;

/**
 * @summary Initialize Default Accounts
 */
export const useInitializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof initializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getInitializeDefaultAccountsApiV1AccountingAccountsInitializeDefaultPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Initialize a customized chart of accounts based on business profile.

If no body is provided, reads business models and industry verticals
from the products tenant settings.
 * @summary Initialize Customized Accounts
 */
export const initializeCustomizedAccountsApiV1AccountingAccountsInitializePost =
  (
    initializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody: InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/accounts/initialize`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: initializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody,
      signal
    });
  };

export const getInitializeCustomizedAccountsApiV1AccountingAccountsInitializePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof initializeCustomizedAccountsApiV1AccountingAccountsInitializePost
        >
      >,
      TError,
      {
        data: InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof initializeCustomizedAccountsApiV1AccountingAccountsInitializePost
      >
    >,
    TError,
    {
      data: InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'initializeCustomizedAccountsApiV1AccountingAccountsInitializePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof initializeCustomizedAccountsApiV1AccountingAccountsInitializePost
        >
      >,
      {
        data: InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody;
      }
    > = (props) => {
      const { data } = props ?? {};

      return initializeCustomizedAccountsApiV1AccountingAccountsInitializePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof initializeCustomizedAccountsApiV1AccountingAccountsInitializePost
      >
    >
  >;
export type InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostMutationBody =
  InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody;
export type InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostMutationError =
  HTTPValidationError;

/**
 * @summary Initialize Customized Accounts
 */
export const useInitializeCustomizedAccountsApiV1AccountingAccountsInitializePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof initializeCustomizedAccountsApiV1AccountingAccountsInitializePost
          >
        >,
        TError,
        {
          data: InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof initializeCustomizedAccountsApiV1AccountingAccountsInitializePost
      >
    >,
    TError,
    {
      data: InitializeCustomizedAccountsApiV1AccountingAccountsInitializePostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getInitializeCustomizedAccountsApiV1AccountingAccountsInitializePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Set the active company to inherit its parent's effective chart of accounts.

Creates no account rows — the company uses the effective chart of its
nearest ``own`` ancestor. Used by the "Use {parent}'s chart" setup action
for a subsidiary.
 * @summary Inherit Chart Of Accounts
 */
export const inheritChartOfAccountsApiV1AccountingAccountsInheritPost = (
  inheritChartOfAccountsApiV1AccountingAccountsInheritPostBody: InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody,
  signal?: AbortSignal
) => {
  return customInstance<ChartStatusResponse>({
    url: `/api/v1/accounting/accounts/inherit`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: inheritChartOfAccountsApiV1AccountingAccountsInheritPostBody,
    signal
  });
};

export const getInheritChartOfAccountsApiV1AccountingAccountsInheritPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof inheritChartOfAccountsApiV1AccountingAccountsInheritPost
        >
      >,
      TError,
      { data: InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof inheritChartOfAccountsApiV1AccountingAccountsInheritPost
      >
    >,
    TError,
    { data: InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody },
    TContext
  > => {
    const mutationKey = [
      'inheritChartOfAccountsApiV1AccountingAccountsInheritPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof inheritChartOfAccountsApiV1AccountingAccountsInheritPost
        >
      >,
      { data: InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return inheritChartOfAccountsApiV1AccountingAccountsInheritPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type InheritChartOfAccountsApiV1AccountingAccountsInheritPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof inheritChartOfAccountsApiV1AccountingAccountsInheritPost
      >
    >
  >;
export type InheritChartOfAccountsApiV1AccountingAccountsInheritPostMutationBody =
  InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody;
export type InheritChartOfAccountsApiV1AccountingAccountsInheritPostMutationError =
  HTTPValidationError;

/**
 * @summary Inherit Chart Of Accounts
 */
export const useInheritChartOfAccountsApiV1AccountingAccountsInheritPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof inheritChartOfAccountsApiV1AccountingAccountsInheritPost
        >
      >,
      TError,
      { data: InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof inheritChartOfAccountsApiV1AccountingAccountsInheritPost>
  >,
  TError,
  { data: InheritChartOfAccountsApiV1AccountingAccountsInheritPostBody },
  TContext
> => {
  const mutationOptions =
    getInheritChartOfAccountsApiV1AccountingAccountsInheritPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete only unused accounts from the active company's own chart.
 * @summary Reset Chart Of Accounts
 */
export const resetChartOfAccountsApiV1AccountingAccountsResetPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/reset`,
    method: 'POST',
    signal
  });
};

export const getResetChartOfAccountsApiV1AccountingAccountsResetPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetChartOfAccountsApiV1AccountingAccountsResetPost>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof resetChartOfAccountsApiV1AccountingAccountsResetPost>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'resetChartOfAccountsApiV1AccountingAccountsResetPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof resetChartOfAccountsApiV1AccountingAccountsResetPost>
      >,
      void
    > = () => {
      return resetChartOfAccountsApiV1AccountingAccountsResetPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResetChartOfAccountsApiV1AccountingAccountsResetPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof resetChartOfAccountsApiV1AccountingAccountsResetPost>
    >
  >;

export type ResetChartOfAccountsApiV1AccountingAccountsResetPostMutationError =
  unknown;

/**
 * @summary Reset Chart Of Accounts
 */
export const useResetChartOfAccountsApiV1AccountingAccountsResetPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetChartOfAccountsApiV1AccountingAccountsResetPost>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof resetChartOfAccountsApiV1AccountingAccountsResetPost>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getResetChartOfAccountsApiV1AccountingAccountsResetPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retire the active chart and drafts after one-time step-up authorization.
 * @summary Reset All Chart Data
 */
export const resetAllChartDataApiV1AccountingAccountsResetAllPost = (
  chartResetAllRequest: ChartResetAllRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/reset-all`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: chartResetAllRequest,
    signal
  });
};

export const getResetAllChartDataApiV1AccountingAccountsResetAllPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetAllChartDataApiV1AccountingAccountsResetAllPost>
      >,
      TError,
      { data: ChartResetAllRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof resetAllChartDataApiV1AccountingAccountsResetAllPost>
    >,
    TError,
    { data: ChartResetAllRequest },
    TContext
  > => {
    const mutationKey = [
      'resetAllChartDataApiV1AccountingAccountsResetAllPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof resetAllChartDataApiV1AccountingAccountsResetAllPost>
      >,
      { data: ChartResetAllRequest }
    > = (props) => {
      const { data } = props ?? {};

      return resetAllChartDataApiV1AccountingAccountsResetAllPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResetAllChartDataApiV1AccountingAccountsResetAllPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof resetAllChartDataApiV1AccountingAccountsResetAllPost>
    >
  >;
export type ResetAllChartDataApiV1AccountingAccountsResetAllPostMutationBody =
  ChartResetAllRequest;
export type ResetAllChartDataApiV1AccountingAccountsResetAllPostMutationError =
  HTTPValidationError;

/**
 * @summary Reset All Chart Data
 */
export const useResetAllChartDataApiV1AccountingAccountsResetAllPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetAllChartDataApiV1AccountingAccountsResetAllPost>
      >,
      TError,
      { data: ChartResetAllRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof resetAllChartDataApiV1AccountingAccountsResetAllPost>
  >,
  TError,
  { data: ChartResetAllRequest },
  TContext
> => {
  const mutationOptions =
    getResetAllChartDataApiV1AccountingAccountsResetAllPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get account balance.
 * @summary Get Account Balance
 */
export const getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet = (
  accountId: string,
  params?: GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accounts/${accountId}/balance`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetQueryKey =
  (
    accountId?: string,
    params?: GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams
  ) => {
    return [
      `/api/v1/accounting/accounts/${accountId}/balance`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
      >
    >,
    TError = HTTPValidationError
  >(
    accountId: string,
    params?: GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetQueryKey(
        accountId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
        >
      >
    > = ({ signal }) =>
      getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet(
        accountId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!accountId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
      >
    >
  >;
export type GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetQueryError =
  HTTPValidationError;

export function useGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params:
    | undefined
    | GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Account Balance
 */

export function useGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountBalanceApiV1AccountingAccountsAccountIdBalanceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAccountBalanceApiV1AccountingAccountsAccountIdBalanceGetQueryOptions(
      accountId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One page of an account's transactions, scoped to the caller's company access.

`count` is the unpaged total of the same filtered set — the ledger is Shape A
(append-only, a line per posting), so the page drives its pager from this
rather than from the number of rows it holds (ui-list-pages.md § 11).
 * @summary Get Account Transactions
 */
export const getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet =
  (
    accountId: string,
    params?: GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/accounts/${accountId}/transactions`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetQueryKey =
  (
    accountId?: string,
    params?: GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams
  ) => {
    return [
      `/api/v1/accounting/accounts/${accountId}/transactions`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    accountId: string,
    params?: GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetQueryKey(
        accountId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
        >
      >
    > = ({ signal }) =>
      getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet(
        accountId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!accountId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
      >
    >
  >;
export type GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetQueryError =
  HTTPValidationError;

export function useGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params:
    | undefined
    | GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Account Transactions
 */

export function useGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  accountId: string,
  params?: GetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAccountTransactionsApiV1AccountingAccountsAccountIdTransactionsGetQueryOptions(
      accountId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List journal entries.
 * @summary List Journal Entries
 */
export const listJournalEntriesApiV1AccountingJournalEntriesGet = (
  params?: ListJournalEntriesApiV1AccountingJournalEntriesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/journal-entries`,
    method: 'GET',
    params,
    signal
  });
};

export const getListJournalEntriesApiV1AccountingJournalEntriesGetQueryKey = (
  params?: ListJournalEntriesApiV1AccountingJournalEntriesGetParams
) => {
  return [
    `/api/v1/accounting/journal-entries`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListJournalEntriesApiV1AccountingJournalEntriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListJournalEntriesApiV1AccountingJournalEntriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listJournalEntriesApiV1AccountingJournalEntriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListJournalEntriesApiV1AccountingJournalEntriesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
      >
    > = ({ signal }) =>
      listJournalEntriesApiV1AccountingJournalEntriesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListJournalEntriesApiV1AccountingJournalEntriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
    >
  >;
export type ListJournalEntriesApiV1AccountingJournalEntriesGetQueryError =
  HTTPValidationError;

export function useListJournalEntriesApiV1AccountingJournalEntriesGet<
  TData = Awaited<
    ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListJournalEntriesApiV1AccountingJournalEntriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listJournalEntriesApiV1AccountingJournalEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listJournalEntriesApiV1AccountingJournalEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListJournalEntriesApiV1AccountingJournalEntriesGet<
  TData = Awaited<
    ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListJournalEntriesApiV1AccountingJournalEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listJournalEntriesApiV1AccountingJournalEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listJournalEntriesApiV1AccountingJournalEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListJournalEntriesApiV1AccountingJournalEntriesGet<
  TData = Awaited<
    ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListJournalEntriesApiV1AccountingJournalEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Journal Entries
 */

export function useListJournalEntriesApiV1AccountingJournalEntriesGet<
  TData = Awaited<
    ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListJournalEntriesApiV1AccountingJournalEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listJournalEntriesApiV1AccountingJournalEntriesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListJournalEntriesApiV1AccountingJournalEntriesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new journal entry.

The body is the generated ``JournalEntryCreate`` model, so FastAPI/Pydantic
enforce the JSON-schema field constraints (including the lossless-string
``exchange_rate`` — a raw JSON number is rejected with 422 rather than being
floated). Provenance (``source_type``/``source_id``) is not client-settable at
this seam: manual entries always post as ``source_type='manual'``; system JEs
are created through the service directly.
 * @summary Create Journal Entry
 */
export const createJournalEntryApiV1AccountingJournalEntriesPost = (
  journalEntryCreate: JournalEntryCreate,
  signal?: AbortSignal
) => {
  return customInstance<JournalEntryResponse>({
    url: `/api/v1/accounting/journal-entries`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: journalEntryCreate,
    signal
  });
};

export const getCreateJournalEntryApiV1AccountingJournalEntriesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createJournalEntryApiV1AccountingJournalEntriesPost>
      >,
      TError,
      { data: JournalEntryCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createJournalEntryApiV1AccountingJournalEntriesPost>
    >,
    TError,
    { data: JournalEntryCreate },
    TContext
  > => {
    const mutationKey = ['createJournalEntryApiV1AccountingJournalEntriesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createJournalEntryApiV1AccountingJournalEntriesPost>
      >,
      { data: JournalEntryCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createJournalEntryApiV1AccountingJournalEntriesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateJournalEntryApiV1AccountingJournalEntriesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createJournalEntryApiV1AccountingJournalEntriesPost>
    >
  >;
export type CreateJournalEntryApiV1AccountingJournalEntriesPostMutationBody =
  JournalEntryCreate;
export type CreateJournalEntryApiV1AccountingJournalEntriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Journal Entry
 */
export const useCreateJournalEntryApiV1AccountingJournalEntriesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createJournalEntryApiV1AccountingJournalEntriesPost>
      >,
      TError,
      { data: JournalEntryCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createJournalEntryApiV1AccountingJournalEntriesPost>
  >,
  TError,
  { data: JournalEntryCreate },
  TContext
> => {
  const mutationOptions =
    getCreateJournalEntryApiV1AccountingJournalEntriesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Return account and creator candidates used by the journal-entry base scope.
 * @summary Get Journal Entry Filter Facets
 */
export const getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet =
  (signal?: AbortSignal) => {
    return customInstance<JournalEntryFilterFacets>({
      url: `/api/v1/accounting/journal-entries/filter-facets`,
      method: 'GET',
      signal
    });
  };

export const getGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGetQueryKey =
  () => {
    return [`/api/v1/accounting/journal-entries/filter-facets`] as const;
  };

export const getGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
        >
      >
    > = ({ signal }) =>
      getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
      >
    >
  >;
export type GetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGetQueryError =
  unknown;

export function useGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Journal Entry Filter Facets
 */

export function useGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJournalEntryFilterFacetsApiV1AccountingJournalEntriesFilterFacetsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single journal entry with lines, scoped to the caller's company access.
 * @summary Get Journal Entry
 */
export const getJournalEntryApiV1AccountingJournalEntriesEntryIdGet = (
  entryId: string,
  signal?: AbortSignal
) => {
  return customInstance<JournalEntryResponse>({
    url: `/api/v1/accounting/journal-entries/${entryId}`,
    method: 'GET',
    signal
  });
};

export const getGetJournalEntryApiV1AccountingJournalEntriesEntryIdGetQueryKey =
  (entryId?: string) => {
    return [`/api/v1/accounting/journal-entries/${entryId}`] as const;
  };

export const getGetJournalEntryApiV1AccountingJournalEntriesEntryIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet>
    >,
    TError = HTTPValidationError
  >(
    entryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetJournalEntryApiV1AccountingJournalEntriesEntryIdGetQueryKey(
        entryId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
        >
      >
    > = ({ signal }) =>
      getJournalEntryApiV1AccountingJournalEntriesEntryIdGet(entryId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!entryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetJournalEntryApiV1AccountingJournalEntriesEntryIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet>
    >
  >;
export type GetJournalEntryApiV1AccountingJournalEntriesEntryIdGetQueryError =
  HTTPValidationError;

export function useGetJournalEntryApiV1AccountingJournalEntriesEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJournalEntryApiV1AccountingJournalEntriesEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJournalEntryApiV1AccountingJournalEntriesEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Journal Entry
 */

export function useGetJournalEntryApiV1AccountingJournalEntriesEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJournalEntryApiV1AccountingJournalEntriesEntryIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJournalEntryApiV1AccountingJournalEntriesEntryIdGetQueryOptions(
      entryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a draft journal entry.

The body is the generated ``JournalEntryUpdate`` model — every field optional,
an omitted one left unchanged — so FastAPI/Pydantic enforce the JSON-schema
constraints (typed account_id, lossless-string amounts/rates, extra-field
rejection) identically to the ``create`` sibling. Lines, when supplied, fully
replace the existing set and route through the same money-boundary contract
(``coerce_gl_amount`` / ``_coerce_exchange_rate``), including the foreign-leg
fields the previous raw-dict body silently dropped. The entry currency and
entry-level exchange rate are fixed at creation and are not editable here.
 * @summary Update Journal Entry
 */
export const updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut = (
  entryId: string,
  journalEntryUpdate: JournalEntryUpdate
) => {
  return customInstance<JournalEntryResponse>({
    url: `/api/v1/accounting/journal-entries/${entryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: journalEntryUpdate
  });
};

export const getUpdateJournalEntryApiV1AccountingJournalEntriesEntryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut
        >
      >,
      TError,
      { entryId: string; data: JournalEntryUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut
      >
    >,
    TError,
    { entryId: string; data: JournalEntryUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut
        >
      >,
      { entryId: string; data: JournalEntryUpdate }
    > = (props) => {
      const { entryId, data } = props ?? {};

      return updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut(
        entryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateJournalEntryApiV1AccountingJournalEntriesEntryIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut
      >
    >
  >;
export type UpdateJournalEntryApiV1AccountingJournalEntriesEntryIdPutMutationBody =
  JournalEntryUpdate;
export type UpdateJournalEntryApiV1AccountingJournalEntriesEntryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Journal Entry
 */
export const useUpdateJournalEntryApiV1AccountingJournalEntriesEntryIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut
        >
      >,
      TError,
      { entryId: string; data: JournalEntryUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateJournalEntryApiV1AccountingJournalEntriesEntryIdPut>
  >,
  TError,
  { entryId: string; data: JournalEntryUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateJournalEntryApiV1AccountingJournalEntriesEntryIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a draft journal entry.
 * @summary Delete Journal Entry
 */
export const deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete = (
  entryId: string
) => {
  return customInstance<void>({
    url: `/api/v1/accounting/journal-entries/${entryId}`,
    method: 'DELETE'
  });
};

export const getDeleteJournalEntryApiV1AccountingJournalEntriesEntryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete
        >
      >,
      { entryId: string }
    > = (props) => {
      const { entryId } = props ?? {};

      return deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete(
        entryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteJournalEntryApiV1AccountingJournalEntriesEntryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete
      >
    >
  >;

export type DeleteJournalEntryApiV1AccountingJournalEntriesEntryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Journal Entry
 */
export const useDeleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteJournalEntryApiV1AccountingJournalEntriesEntryIdDelete
    >
  >,
  TError,
  { entryId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteJournalEntryApiV1AccountingJournalEntriesEntryIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Post a journal entry.
 * @summary Post Journal Entry
 */
export const postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost = (
  entryId: string,
  signal?: AbortSignal
) => {
  return customInstance<JournalEntryResponse>({
    url: `/api/v1/accounting/journal-entries/${entryId}/post`,
    method: 'POST',
    signal
  });
};

export const getPostJournalEntryApiV1AccountingJournalEntriesEntryIdPostPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationKey = [
      'postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost
        >
      >,
      { entryId: string }
    > = (props) => {
      const { entryId } = props ?? {};

      return postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost(
        entryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostJournalEntryApiV1AccountingJournalEntriesEntryIdPostPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost
      >
    >
  >;

export type PostJournalEntryApiV1AccountingJournalEntriesEntryIdPostPostMutationError =
  HTTPValidationError;

/**
 * @summary Post Journal Entry
 */
export const usePostJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postJournalEntryApiV1AccountingJournalEntriesEntryIdPostPost
    >
  >,
  TError,
  { entryId: string },
  TContext
> => {
  const mutationOptions =
    getPostJournalEntryApiV1AccountingJournalEntriesEntryIdPostPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reverse a posted journal entry by posting an inverse entry (P5 append-only).
 * @summary Reverse Journal Entry
 */
export const reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost =
  (
    entryId: string,
    journalEntryReverseRequest: JournalEntryReverseRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<JournalEntryResponse>({
      url: `/api/v1/accounting/journal-entries/${entryId}/reverse`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: journalEntryReverseRequest,
      signal
    });
  };

export const getReverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost
        >
      >,
      TError,
      { entryId: string; data: JournalEntryReverseRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost
      >
    >,
    TError,
    { entryId: string; data: JournalEntryReverseRequest },
    TContext
  > => {
    const mutationKey = [
      'reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost
        >
      >,
      { entryId: string; data: JournalEntryReverseRequest }
    > = (props) => {
      const { entryId, data } = props ?? {};

      return reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost(
        entryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost
      >
    >
  >;
export type ReverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePostMutationBody =
  JournalEntryReverseRequest;
export type ReverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePostMutationError =
  HTTPValidationError;

/**
 * @summary Reverse Journal Entry
 */
export const useReverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost
          >
        >,
        TError,
        { entryId: string; data: JournalEntryReverseRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePost
      >
    >,
    TError,
    { entryId: string; data: JournalEntryReverseRequest },
    TContext
  > => {
    const mutationOptions =
      getReverseJournalEntryApiV1AccountingJournalEntriesEntryIdReversePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List fiscal periods for the caller's active company scope.

Fiscal periods are per legal entity, so this scopes to the active company
(``?company_id=`` / ``X-Active-Company-Id``, else the accessible set) — without
it a multi-company tenant returns every company's periods as indistinguishable
duplicates and the FX-revaluation picker could revalue the wrong company.
 * @summary List Fiscal Periods
 */
export const listFiscalPeriodsApiV1AccountingFiscalPeriodsGet = (
  params?: ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<FiscalPeriodListResponse>({
    url: `/api/v1/accounting/fiscal-periods`,
    method: 'GET',
    params,
    signal
  });
};

export const getListFiscalPeriodsApiV1AccountingFiscalPeriodsGetQueryKey = (
  params?: ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams
) => {
  return [
    `/api/v1/accounting/fiscal-periods`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListFiscalPeriodsApiV1AccountingFiscalPeriodsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListFiscalPeriodsApiV1AccountingFiscalPeriodsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>>
  > = ({ signal }) =>
    listFiscalPeriodsApiV1AccountingFiscalPeriodsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>>
  >;
export type ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetQueryError =
  HTTPValidationError;

export function useListFiscalPeriodsApiV1AccountingFiscalPeriodsGet<
  TData = Awaited<
    ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFiscalPeriodsApiV1AccountingFiscalPeriodsGet<
  TData = Awaited<
    ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFiscalPeriodsApiV1AccountingFiscalPeriodsGet<
  TData = Awaited<
    ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Fiscal Periods
 */

export function useListFiscalPeriodsApiV1AccountingFiscalPeriodsGet<
  TData = Awaited<
    ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFiscalPeriodsApiV1AccountingFiscalPeriodsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFiscalPeriodsApiV1AccountingFiscalPeriodsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListFiscalPeriodsApiV1AccountingFiscalPeriodsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a single fiscal period.
 * @summary Create Fiscal Period
 */
export const createFiscalPeriodApiV1AccountingFiscalPeriodsPost = (
  fiscalPeriodCreate: FiscalPeriodCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/fiscal-periods`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: fiscalPeriodCreate,
    signal
  });
};

export const getCreateFiscalPeriodApiV1AccountingFiscalPeriodsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFiscalPeriodApiV1AccountingFiscalPeriodsPost>
      >,
      TError,
      { data: FiscalPeriodCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createFiscalPeriodApiV1AccountingFiscalPeriodsPost>
    >,
    TError,
    { data: FiscalPeriodCreate },
    TContext
  > => {
    const mutationKey = ['createFiscalPeriodApiV1AccountingFiscalPeriodsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createFiscalPeriodApiV1AccountingFiscalPeriodsPost>
      >,
      { data: FiscalPeriodCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createFiscalPeriodApiV1AccountingFiscalPeriodsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateFiscalPeriodApiV1AccountingFiscalPeriodsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createFiscalPeriodApiV1AccountingFiscalPeriodsPost>
    >
  >;
export type CreateFiscalPeriodApiV1AccountingFiscalPeriodsPostMutationBody =
  FiscalPeriodCreate;
export type CreateFiscalPeriodApiV1AccountingFiscalPeriodsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Fiscal Period
 */
export const useCreateFiscalPeriodApiV1AccountingFiscalPeriodsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFiscalPeriodApiV1AccountingFiscalPeriodsPost>
      >,
      TError,
      { data: FiscalPeriodCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createFiscalPeriodApiV1AccountingFiscalPeriodsPost>
  >,
  TError,
  { data: FiscalPeriodCreate },
  TContext
> => {
  const mutationOptions =
    getCreateFiscalPeriodApiV1AccountingFiscalPeriodsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a single fiscal period, scoped to the caller's company access.
 * @summary Get Fiscal Period
 */
export const getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet = (
  periodId: string,
  signal?: AbortSignal
) => {
  return customInstance<FiscalPeriodResponse>({
    url: `/api/v1/accounting/fiscal-periods/${periodId}`,
    method: 'GET',
    signal
  });
};

export const getGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGetQueryKey =
  (periodId?: string) => {
    return [`/api/v1/accounting/fiscal-periods/${periodId}`] as const;
  };

export const getGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet>
    >,
    TError = HTTPValidationError
  >(
    periodId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGetQueryKey(
        periodId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
        >
      >
    > = ({ signal }) =>
      getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet(periodId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!periodId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet>
    >
  >;
export type GetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGetQueryError =
  HTTPValidationError;

export function useGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet<
  TData = Awaited<
    ReturnType<typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet>
  >,
  TError = HTTPValidationError
>(
  periodId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet<
  TData = Awaited<
    ReturnType<typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet>
  >,
  TError = HTTPValidationError
>(
  periodId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet<
  TData = Awaited<
    ReturnType<typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet>
  >,
  TError = HTTPValidationError
>(
  periodId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Fiscal Period
 */

export function useGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet<
  TData = Awaited<
    ReturnType<typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet>
  >,
  TError = HTTPValidationError
>(
  periodId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdGetQueryOptions(
      periodId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate all periods for a fiscal year.
 * @summary Generate Fiscal Year
 */
export const generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost = (
  generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody: GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/fiscal-periods/generate-year`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody,
    signal
  });
};

export const getGenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost
        >
      >,
      TError,
      {
        data: GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost
      >
    >,
    TError,
    {
      data: GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost
        >
      >,
      {
        data: GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody;
      }
    > = (props) => {
      const { data } = props ?? {};

      return generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost
      >
    >
  >;
export type GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostMutationBody =
  GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody;
export type GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Fiscal Year
 */
export const useGenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost
          >
        >,
        TError,
        {
          data: GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPost
      >
    >,
    TError,
    {
      data: GenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getGenerateFiscalYearApiV1AccountingFiscalPeriodsGenerateYearPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Deprecated — use POST /accounting/period-close/{period_id}/close.

Sends no acknowledgements, so a period with an amber finding returns 409
rather than closing silently: the old client cannot express an
acknowledgement, and inventing one would forge the audit record.
 * @deprecated
 * @summary Close Fiscal Period
 */
export const closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost = (
  periodId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/fiscal-periods/${periodId}/close`,
    method: 'POST',
    signal
  });
};

export const getCloseFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost
        >
      >,
      TError,
      { periodId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost
      >
    >,
    TError,
    { periodId: string },
    TContext
  > => {
    const mutationKey = [
      'closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost
        >
      >,
      { periodId: string }
    > = (props) => {
      const { periodId } = props ?? {};

      return closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost(
        periodId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CloseFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost
      >
    >
  >;

export type CloseFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePostMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Close Fiscal Period
 */
export const useCloseFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost
          >
        >,
        TError,
        { periodId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof closeFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePost
      >
    >,
    TError,
    { periodId: string },
    TContext
  > => {
    const mutationOptions =
      getCloseFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdClosePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Deprecated — use POST /accounting/period-close/{period_id}/reopen.
 * @deprecated
 * @summary Reopen Fiscal Period
 */
export const reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost =
  (periodId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/fiscal-periods/${periodId}/reopen`,
      method: 'POST',
      signal
    });
  };

export const getReopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost
        >
      >,
      TError,
      { periodId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost
      >
    >,
    TError,
    { periodId: string },
    TContext
  > => {
    const mutationKey = [
      'reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost
        >
      >,
      { periodId: string }
    > = (props) => {
      const { periodId } = props ?? {};

      return reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost(
        periodId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost
      >
    >
  >;

export type ReopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPostMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Reopen Fiscal Period
 */
export const useReopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost
          >
        >,
        TError,
        { periodId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPost
      >
    >,
    TError,
    { periodId: string },
    TContext
  > => {
    const mutationOptions =
      getReopenFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdReopenPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Lock a fiscal period.
 * @summary Lock Fiscal Period
 */
export const lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost = (
  periodId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/fiscal-periods/${periodId}/lock`,
    method: 'POST',
    signal
  });
};

export const getLockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost
        >
      >,
      TError,
      { periodId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost
      >
    >,
    TError,
    { periodId: string },
    TContext
  > => {
    const mutationKey = [
      'lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost
        >
      >,
      { periodId: string }
    > = (props) => {
      const { periodId } = props ?? {};

      return lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost(
        periodId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost
      >
    >
  >;

export type LockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPostMutationError =
  HTTPValidationError;

/**
 * @summary Lock Fiscal Period
 */
export const useLockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost
        >
      >,
      TError,
      { periodId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof lockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPost
    >
  >,
  TError,
  { periodId: string },
  TContext
> => {
  const mutationOptions =
    getLockFiscalPeriodApiV1AccountingFiscalPeriodsPeriodIdLockPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List currencies.

Shape B (bounded reference data): the exchange-rates page slices and filters
the currency catalogue client-side, so omitting ``limit`` returns the WHOLE
catalogue — ``resolve_limit`` supplies ``MAX_LIST_LIMIT`` as the safety net,
never a page size (``docs/design-system/ui-list-pages.md`` § 11). The
repository takes the resolved value as a required keyword precisely so the
cap can only ever be stated here: it used to default to 100, which silently
hid every currency past the hundredth from a tenant's own filtered view.
 * @summary List Currencies
 */
export const listCurrenciesApiV1AccountingCurrenciesGet = (
  params?: ListCurrenciesApiV1AccountingCurrenciesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/currencies`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCurrenciesApiV1AccountingCurrenciesGetQueryKey = (
  params?: ListCurrenciesApiV1AccountingCurrenciesGetParams
) => {
  return [
    `/api/v1/accounting/currencies`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListCurrenciesApiV1AccountingCurrenciesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCurrenciesApiV1AccountingCurrenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCurrenciesApiV1AccountingCurrenciesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>
  > = ({ signal }) =>
    listCurrenciesApiV1AccountingCurrenciesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListCurrenciesApiV1AccountingCurrenciesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>
>;
export type ListCurrenciesApiV1AccountingCurrenciesGetQueryError =
  HTTPValidationError;

export function useListCurrenciesApiV1AccountingCurrenciesGet<
  TData = Awaited<
    ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListCurrenciesApiV1AccountingCurrenciesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCurrenciesApiV1AccountingCurrenciesGet<
  TData = Awaited<
    ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCurrenciesApiV1AccountingCurrenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCurrenciesApiV1AccountingCurrenciesGet<
  TData = Awaited<
    ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCurrenciesApiV1AccountingCurrenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Currencies
 */

export function useListCurrenciesApiV1AccountingCurrenciesGet<
  TData = Awaited<
    ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCurrenciesApiV1AccountingCurrenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCurrenciesApiV1AccountingCurrenciesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCurrenciesApiV1AccountingCurrenciesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new currency.
 * @summary Create Currency
 */
export const createCurrencyApiV1AccountingCurrenciesPost = (
  createCurrencyApiV1AccountingCurrenciesPostBody: CreateCurrencyApiV1AccountingCurrenciesPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/currencies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCurrencyApiV1AccountingCurrenciesPostBody,
    signal
  });
};

export const getCreateCurrencyApiV1AccountingCurrenciesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCurrencyApiV1AccountingCurrenciesPost>>,
    TError,
    { data: CreateCurrencyApiV1AccountingCurrenciesPostBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCurrencyApiV1AccountingCurrenciesPost>>,
  TError,
  { data: CreateCurrencyApiV1AccountingCurrenciesPostBody },
  TContext
> => {
  const mutationKey = ['createCurrencyApiV1AccountingCurrenciesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCurrencyApiV1AccountingCurrenciesPost>>,
    { data: CreateCurrencyApiV1AccountingCurrenciesPostBody }
  > = (props) => {
    const { data } = props ?? {};

    return createCurrencyApiV1AccountingCurrenciesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCurrencyApiV1AccountingCurrenciesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createCurrencyApiV1AccountingCurrenciesPost>>
  >;
export type CreateCurrencyApiV1AccountingCurrenciesPostMutationBody =
  CreateCurrencyApiV1AccountingCurrenciesPostBody;
export type CreateCurrencyApiV1AccountingCurrenciesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Currency
 */
export const useCreateCurrencyApiV1AccountingCurrenciesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCurrencyApiV1AccountingCurrenciesPost>>,
      TError,
      { data: CreateCurrencyApiV1AccountingCurrenciesPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCurrencyApiV1AccountingCurrenciesPost>>,
  TError,
  { data: CreateCurrencyApiV1AccountingCurrenciesPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateCurrencyApiV1AccountingCurrenciesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Initialize default currencies.
 * @summary Initialize Default Currencies
 */
export const initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/currencies/initialize-default`,
      method: 'POST',
      signal
    });
  };

export const getInitializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost
        >
      >,
      void
    > = () => {
      return initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type InitializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost
      >
    >
  >;

export type InitializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPostMutationError =
  unknown;

/**
 * @summary Initialize Default Currencies
 */
export const useInitializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof initializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getInitializeDefaultCurrenciesApiV1AccountingCurrenciesInitializeDefaultPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List exchange rates.
 * @summary List Exchange Rates
 */
export const listExchangeRatesApiV1AccountingExchangeRatesGet = (
  params?: ListExchangeRatesApiV1AccountingExchangeRatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/exchange-rates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListExchangeRatesApiV1AccountingExchangeRatesGetQueryKey = (
  params?: ListExchangeRatesApiV1AccountingExchangeRatesGetParams
) => {
  return [
    `/api/v1/accounting/exchange-rates`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListExchangeRatesApiV1AccountingExchangeRatesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExchangeRatesApiV1AccountingExchangeRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListExchangeRatesApiV1AccountingExchangeRatesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>>
  > = ({ signal }) =>
    listExchangeRatesApiV1AccountingExchangeRatesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListExchangeRatesApiV1AccountingExchangeRatesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>>
  >;
export type ListExchangeRatesApiV1AccountingExchangeRatesGetQueryError =
  HTTPValidationError;

export function useListExchangeRatesApiV1AccountingExchangeRatesGet<
  TData = Awaited<
    ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListExchangeRatesApiV1AccountingExchangeRatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExchangeRatesApiV1AccountingExchangeRatesGet<
  TData = Awaited<
    ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExchangeRatesApiV1AccountingExchangeRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExchangeRatesApiV1AccountingExchangeRatesGet<
  TData = Awaited<
    ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExchangeRatesApiV1AccountingExchangeRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Exchange Rates
 */

export function useListExchangeRatesApiV1AccountingExchangeRatesGet<
  TData = Awaited<
    ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExchangeRatesApiV1AccountingExchangeRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExchangeRatesApiV1AccountingExchangeRatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExchangeRatesApiV1AccountingExchangeRatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update an exchange rate.
 * @summary Create Exchange Rate
 */
export const createExchangeRateApiV1AccountingExchangeRatesPost = (
  createExchangeRateApiV1AccountingExchangeRatesPostBody: CreateExchangeRateApiV1AccountingExchangeRatesPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/exchange-rates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createExchangeRateApiV1AccountingExchangeRatesPostBody,
    signal
  });
};

export const getCreateExchangeRateApiV1AccountingExchangeRatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createExchangeRateApiV1AccountingExchangeRatesPost>
      >,
      TError,
      { data: CreateExchangeRateApiV1AccountingExchangeRatesPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createExchangeRateApiV1AccountingExchangeRatesPost>
    >,
    TError,
    { data: CreateExchangeRateApiV1AccountingExchangeRatesPostBody },
    TContext
  > => {
    const mutationKey = ['createExchangeRateApiV1AccountingExchangeRatesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createExchangeRateApiV1AccountingExchangeRatesPost>
      >,
      { data: CreateExchangeRateApiV1AccountingExchangeRatesPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createExchangeRateApiV1AccountingExchangeRatesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateExchangeRateApiV1AccountingExchangeRatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createExchangeRateApiV1AccountingExchangeRatesPost>
    >
  >;
export type CreateExchangeRateApiV1AccountingExchangeRatesPostMutationBody =
  CreateExchangeRateApiV1AccountingExchangeRatesPostBody;
export type CreateExchangeRateApiV1AccountingExchangeRatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Exchange Rate
 */
export const useCreateExchangeRateApiV1AccountingExchangeRatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createExchangeRateApiV1AccountingExchangeRatesPost>
      >,
      TError,
      { data: CreateExchangeRateApiV1AccountingExchangeRatesPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createExchangeRateApiV1AccountingExchangeRatesPost>
  >,
  TError,
  { data: CreateExchangeRateApiV1AccountingExchangeRatesPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateExchangeRateApiV1AccountingExchangeRatesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List global market reference rates (shared across all tenants, read-only).

These are the 'market (global)' rates a tenant resolves against unless it has
entered its own override row (see GET /exchange-rates).
 * @summary List Fx Reference Rates
 */
export const listFxReferenceRatesApiV1AccountingFxReferenceRatesGet = (
  params?: ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/fx-reference-rates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListFxReferenceRatesApiV1AccountingFxReferenceRatesGetQueryKey =
  (params?: ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams) => {
    return [
      `/api/v1/accounting/fx-reference-rates`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListFxReferenceRatesApiV1AccountingFxReferenceRatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListFxReferenceRatesApiV1AccountingFxReferenceRatesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
        >
      >
    > = ({ signal }) =>
      listFxReferenceRatesApiV1AccountingFxReferenceRatesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet>
    >
  >;
export type ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetQueryError =
  HTTPValidationError;

export function useListFxReferenceRatesApiV1AccountingFxReferenceRatesGet<
  TData = Awaited<
    ReturnType<typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFxReferenceRatesApiV1AccountingFxReferenceRatesGet<
  TData = Awaited<
    ReturnType<typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFxReferenceRatesApiV1AccountingFxReferenceRatesGet<
  TData = Awaited<
    ReturnType<typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Fx Reference Rates
 */

export function useListFxReferenceRatesApiV1AccountingFxReferenceRatesGet<
  TData = Awaited<
    ReturnType<typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFxReferenceRatesApiV1AccountingFxReferenceRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFxReferenceRatesApiV1AccountingFxReferenceRatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListFxReferenceRatesApiV1AccountingFxReferenceRatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete a tenant override rate. The pair then falls back to the global
market reference rate on the next lookup.
 * @summary Delete Exchange Rate
 */
export const deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete = (
  rateId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/exchange-rates/${rateId}`,
    method: 'DELETE'
  });
};

export const getDeleteExchangeRateApiV1AccountingExchangeRatesRateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete
        >
      >,
      TError,
      { rateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete
      >
    >,
    TError,
    { rateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete
        >
      >,
      { rateId: string }
    > = (props) => {
      const { rateId } = props ?? {};

      return deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete(rateId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteExchangeRateApiV1AccountingExchangeRatesRateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete
      >
    >
  >;

export type DeleteExchangeRateApiV1AccountingExchangeRatesRateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Exchange Rate
 */
export const useDeleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete
        >
      >,
      TError,
      { rateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteExchangeRateApiV1AccountingExchangeRatesRateIdDelete
    >
  >,
  TError,
  { rateId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteExchangeRateApiV1AccountingExchangeRatesRateIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Convert an amount between currencies.

Returns the effective resolved rate plus a `source` discriminator and the
applied `markup_bps` so the caller can tell a `market+markup` result apart
from a plain `market` or `override` one. `base_rate` carries the raw
pre-markup market rate when a markup was applied (else equals `rate`).
 * @summary Convert Currency
 */
export const convertCurrencyApiV1AccountingExchangeRatesConvertGet = (
  params: ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/exchange-rates/convert`,
    method: 'GET',
    params,
    signal
  });
};

export const getConvertCurrencyApiV1AccountingExchangeRatesConvertGetQueryKey =
  (params?: ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams) => {
    return [
      `/api/v1/accounting/exchange-rates/convert`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getConvertCurrencyApiV1AccountingExchangeRatesConvertGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
    >,
    TError = HTTPValidationError
  >(
    params: ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getConvertCurrencyApiV1AccountingExchangeRatesConvertGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
      >
    > = ({ signal }) =>
      convertCurrencyApiV1AccountingExchangeRatesConvertGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ConvertCurrencyApiV1AccountingExchangeRatesConvertGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
    >
  >;
export type ConvertCurrencyApiV1AccountingExchangeRatesConvertGetQueryError =
  HTTPValidationError;

export function useConvertCurrencyApiV1AccountingExchangeRatesConvertGet<
  TData = Awaited<
    ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
  >,
  TError = HTTPValidationError
>(
  params: ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useConvertCurrencyApiV1AccountingExchangeRatesConvertGet<
  TData = Awaited<
    ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
  >,
  TError = HTTPValidationError
>(
  params: ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useConvertCurrencyApiV1AccountingExchangeRatesConvertGet<
  TData = Awaited<
    ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
  >,
  TError = HTTPValidationError
>(
  params: ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Convert Currency
 */

export function useConvertCurrencyApiV1AccountingExchangeRatesConvertGet<
  TData = Awaited<
    ReturnType<typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet>
  >,
  TError = HTTPValidationError
>(
  params: ConvertCurrencyApiV1AccountingExchangeRatesConvertGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof convertCurrencyApiV1AccountingExchangeRatesConvertGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getConvertCurrencyApiV1AccountingExchangeRatesConvertGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List every currency pair the tenant tracks, merged with the live market rate.

Each row carries the raw `market_rate`, the pair's `mode`, and the
`effective_rate` a conversion resolves to today. `default_markup_bps` is the
standing tenant-wide spread that `default`-mode pairs inherit. The list is
empty for a tenant that has not added any pair.
 * @summary List Fx Rate Policies
 */
export const listFxRatePoliciesApiV1AccountingFxRatePoliciesGet = (
  signal?: AbortSignal
) => {
  return customInstance<FxRatePolicyListResponse>({
    url: `/api/v1/accounting/fx-rate-policies`,
    method: 'GET',
    signal
  });
};

export const getListFxRatePoliciesApiV1AccountingFxRatePoliciesGetQueryKey =
  () => {
    return [`/api/v1/accounting/fx-rate-policies`] as const;
  };

export const getListFxRatePoliciesApiV1AccountingFxRatePoliciesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListFxRatePoliciesApiV1AccountingFxRatePoliciesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
      >
    > = ({ signal }) =>
      listFxRatePoliciesApiV1AccountingFxRatePoliciesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListFxRatePoliciesApiV1AccountingFxRatePoliciesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
    >
  >;
export type ListFxRatePoliciesApiV1AccountingFxRatePoliciesGetQueryError =
  unknown;

export function useListFxRatePoliciesApiV1AccountingFxRatePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFxRatePoliciesApiV1AccountingFxRatePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFxRatePoliciesApiV1AccountingFxRatePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Fx Rate Policies
 */

export function useListFxRatePoliciesApiV1AccountingFxRatePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRatePoliciesApiV1AccountingFxRatePoliciesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListFxRatePoliciesApiV1AccountingFxRatePoliciesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set a currency pair's rate policy (idempotent per pair).

Body: `from_currency`/`to_currency` plus a `mode` — `default` (watch, inherit
the default markup), `custom` (requires `markup_bps`), or `manual` (requires
`rate`, optional `rate_date` defaulting to today). The write clears the store
the chosen mode does not use, so exactly one rule governs the pair.
 * @summary Upsert Fx Rate Policy
 */
export const upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost = (
  fxRatePolicyUpsert: FxRatePolicyUpsert,
  signal?: AbortSignal
) => {
  return customInstance<FxRatePolicyResponse>({
    url: `/api/v1/accounting/fx-rate-policies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: fxRatePolicyUpsert,
    signal
  });
};

export const getUpsertFxRatePolicyApiV1AccountingFxRatePoliciesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost>
      >,
      TError,
      { data: FxRatePolicyUpsert },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost>
    >,
    TError,
    { data: FxRatePolicyUpsert },
    TContext
  > => {
    const mutationKey = ['upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost>
      >,
      { data: FxRatePolicyUpsert }
    > = (props) => {
      const { data } = props ?? {};

      return upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertFxRatePolicyApiV1AccountingFxRatePoliciesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost>
    >
  >;
export type UpsertFxRatePolicyApiV1AccountingFxRatePoliciesPostMutationBody =
  FxRatePolicyUpsert;
export type UpsertFxRatePolicyApiV1AccountingFxRatePoliciesPostMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Fx Rate Policy
 */
export const useUpsertFxRatePolicyApiV1AccountingFxRatePoliciesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost>
      >,
      TError,
      { data: FxRatePolicyUpsert },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof upsertFxRatePolicyApiV1AccountingFxRatePoliciesPost>
  >,
  TError,
  { data: FxRatePolicyUpsert },
  TContext
> => {
  const mutationOptions =
    getUpsertFxRatePolicyApiV1AccountingFxRatePoliciesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Stop tracking a currency pair: remove its markup row AND its pinned rates.

The pair then resolves off the market rate plus the tenant-wide default
markup, exactly as a pair that was never added.
 * @summary Delete Fx Rate Policy
 */
export const deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete =
  (fromCurrency: string, toCurrency: string) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/fx-rate-policies/${fromCurrency}/${toCurrency}`,
      method: 'DELETE'
    });
  };

export const getDeleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete
        >
      >,
      TError,
      { fromCurrency: string; toCurrency: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete
      >
    >,
    TError,
    { fromCurrency: string; toCurrency: string },
    TContext
  > => {
    const mutationKey = [
      'deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete
        >
      >,
      { fromCurrency: string; toCurrency: string }
    > = (props) => {
      const { fromCurrency, toCurrency } = props ?? {};

      return deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete(
        fromCurrency,
        toCurrency
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete
      >
    >
  >;

export type DeleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Fx Rate Policy
 */
export const useDeleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete
          >
        >,
        TError,
        { fromCurrency: string; toCurrency: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDelete
      >
    >,
    TError,
    { fromCurrency: string; toCurrency: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteFxRatePolicyApiV1AccountingFxRatePoliciesFromCurrencyToCurrencyDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Set the tenant-wide default FX markup (basis points; `0` = no spread).

It applies to every market-resolved conversion with no per-pair custom markup
and no pinned manual rate. The `> -10000` floor is enforced by the generated
`FxDefaultMarkupUpdate` schema (FastAPI returns 422 on violation).
 * @summary Set Fx Default Markup
 */
export const setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut = (
  fxDefaultMarkupUpdate: FxDefaultMarkupUpdate
) => {
  return customInstance<FxDefaultMarkupResponse>({
    url: `/api/v1/accounting/fx-rate-policies/default-markup`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: fxDefaultMarkupUpdate
  });
};

export const getSetFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut
        >
      >,
      TError,
      { data: FxDefaultMarkupUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut
      >
    >,
    TError,
    { data: FxDefaultMarkupUpdate },
    TContext
  > => {
    const mutationKey = [
      'setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut
        >
      >,
      { data: FxDefaultMarkupUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut
      >
    >
  >;
export type SetFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPutMutationBody =
  FxDefaultMarkupUpdate;
export type SetFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Fx Default Markup
 */
export const useSetFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut
          >
        >,
        TError,
        { data: FxDefaultMarkupUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPut
      >
    >,
    TError,
    { data: FxDefaultMarkupUpdate },
    TContext
  > => {
    const mutationOptions =
      getSetFxDefaultMarkupApiV1AccountingFxRatePoliciesDefaultMarkupPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get trial balance report. Pass `consolidated=true` for per-company
breakdown + grand total (optionally translated to `reporting_currency`).
Pass `dimension_value_id` to slice by a cost center / project / other axis.
Pass `start_date` for a period trial balance (opening balance + movement +
closing) rather than a point-in-time one.
 * @summary Get Trial Balance
 */
export const getTrialBalanceApiV1AccountingReportsTrialBalanceGet = (
  params?: GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/trial-balance`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTrialBalanceApiV1AccountingReportsTrialBalanceGetQueryKey = (
  params?: GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams
) => {
  return [
    `/api/v1/accounting/reports/trial-balance`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetTrialBalanceApiV1AccountingReportsTrialBalanceGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTrialBalanceApiV1AccountingReportsTrialBalanceGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
      >
    > = ({ signal }) =>
      getTrialBalanceApiV1AccountingReportsTrialBalanceGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTrialBalanceApiV1AccountingReportsTrialBalanceGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
    >
  >;
export type GetTrialBalanceApiV1AccountingReportsTrialBalanceGetQueryError =
  HTTPValidationError;

export function useGetTrialBalanceApiV1AccountingReportsTrialBalanceGet<
  TData = Awaited<
    ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTrialBalanceApiV1AccountingReportsTrialBalanceGet<
  TData = Awaited<
    ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTrialBalanceApiV1AccountingReportsTrialBalanceGet<
  TData = Awaited<
    ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Trial Balance
 */

export function useGetTrialBalanceApiV1AccountingReportsTrialBalanceGet<
  TData = Awaited<
    ReturnType<typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTrialBalanceApiV1AccountingReportsTrialBalanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrialBalanceApiV1AccountingReportsTrialBalanceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTrialBalanceApiV1AccountingReportsTrialBalanceGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get balance sheet report.
 * @summary Get Balance Sheet
 */
export const getBalanceSheetApiV1AccountingReportsBalanceSheetGet = (
  params?: GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/balance-sheet`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetBalanceSheetApiV1AccountingReportsBalanceSheetGetQueryKey = (
  params?: GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams
) => {
  return [
    `/api/v1/accounting/reports/balance-sheet`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetBalanceSheetApiV1AccountingReportsBalanceSheetGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBalanceSheetApiV1AccountingReportsBalanceSheetGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
      >
    > = ({ signal }) =>
      getBalanceSheetApiV1AccountingReportsBalanceSheetGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBalanceSheetApiV1AccountingReportsBalanceSheetGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
    >
  >;
export type GetBalanceSheetApiV1AccountingReportsBalanceSheetGetQueryError =
  HTTPValidationError;

export function useGetBalanceSheetApiV1AccountingReportsBalanceSheetGet<
  TData = Awaited<
    ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBalanceSheetApiV1AccountingReportsBalanceSheetGet<
  TData = Awaited<
    ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBalanceSheetApiV1AccountingReportsBalanceSheetGet<
  TData = Awaited<
    ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Balance Sheet
 */

export function useGetBalanceSheetApiV1AccountingReportsBalanceSheetGet<
  TData = Awaited<
    ReturnType<typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetBalanceSheetApiV1AccountingReportsBalanceSheetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBalanceSheetApiV1AccountingReportsBalanceSheetGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBalanceSheetApiV1AccountingReportsBalanceSheetGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get income statement (P&L) report.
 * @summary Get Income Statement
 */
export const getIncomeStatementApiV1AccountingReportsIncomeStatementGet = (
  params: GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/income-statement`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetIncomeStatementApiV1AccountingReportsIncomeStatementGetQueryKey =
  (
    params?: GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/income-statement`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetIncomeStatementApiV1AccountingReportsIncomeStatementGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetIncomeStatementApiV1AccountingReportsIncomeStatementGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
        >
      >
    > = ({ signal }) =>
      getIncomeStatementApiV1AccountingReportsIncomeStatementGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetIncomeStatementApiV1AccountingReportsIncomeStatementGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
      >
    >
  >;
export type GetIncomeStatementApiV1AccountingReportsIncomeStatementGetQueryError =
  HTTPValidationError;

export function useGetIncomeStatementApiV1AccountingReportsIncomeStatementGet<
  TData = Awaited<
    ReturnType<
      typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIncomeStatementApiV1AccountingReportsIncomeStatementGet<
  TData = Awaited<
    ReturnType<
      typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIncomeStatementApiV1AccountingReportsIncomeStatementGet<
  TData = Awaited<
    ReturnType<
      typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Income Statement
 */

export function useGetIncomeStatementApiV1AccountingReportsIncomeStatementGet<
  TData = Awaited<
    ReturnType<
      typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIncomeStatementApiV1AccountingReportsIncomeStatementGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIncomeStatementApiV1AccountingReportsIncomeStatementGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetIncomeStatementApiV1AccountingReportsIncomeStatementGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download the trial balance as a spreadsheet or a branded PDF.
 * @summary Export Trial Balance
 */
export const exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet = (
  params?: ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/trial-balance/export`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetQueryKey =
  (
    params?: ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/trial-balance/export`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
        >
      >
    > = ({ signal }) =>
      exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
      >
    >
  >;
export type ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetQueryError =
  HTTPValidationError;

export function useExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Trial Balance
 */

export function useExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportTrialBalanceApiV1AccountingReportsTrialBalanceExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportTrialBalanceApiV1AccountingReportsTrialBalanceExportGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download the balance sheet as a spreadsheet or a branded PDF.
 * @summary Export Balance Sheet
 */
export const exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet = (
  params?: ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/balance-sheet/export`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetQueryKey =
  (
    params?: ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/balance-sheet/export`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
        >
      >
    > = ({ signal }) =>
      exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
      >
    >
  >;
export type ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetQueryError =
  HTTPValidationError;

export function useExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Balance Sheet
 */

export function useExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBalanceSheetApiV1AccountingReportsBalanceSheetExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportBalanceSheetApiV1AccountingReportsBalanceSheetExportGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download the income statement as a spreadsheet or a branded PDF.
 * @summary Export Income Statement
 */
export const exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet =
  (
    params: ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/income-statement/export`,
      method: 'GET',
      params,
      signal
    });
  };

export const getExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetQueryKey =
  (
    params?: ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/income-statement/export`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
        >
      >
    > = ({ signal }) =>
      exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
      >
    >
  >;
export type ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetQueryError =
  HTTPValidationError;

export function useExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Income Statement
 */

export function useExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet<
  TData = Awaited<
    ReturnType<
      typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportIncomeStatementApiV1AccountingReportsIncomeStatementExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportIncomeStatementApiV1AccountingReportsIncomeStatementExportGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The intercompany elimination worksheet behind the consolidated statements.

Answers what was removed, from which entity, and against which counterparty —
the reconciliation view an accountant needs when the consolidated total is
smaller than the sum of the entities. Only pairs with **both** entities inside
the caller's consolidation boundary eliminate; activity with an entity outside
it is third-party activity from the group's point of view and stays gross.

Derived from the ledger on every call rather than read from a stored snapshot,
so it cannot disagree with the statements it explains.
 * @summary Get Intercompany Eliminations
 */
export const getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet =
  (
    params: GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ConsolidationEliminationReport>({
      url: `/api/v1/accounting/reports/intercompany-eliminations`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetQueryKey =
  (
    params?: GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/intercompany-eliminations`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
        >
      >
    > = ({ signal }) =>
      getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
      >
    >
  >;
export type GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetQueryError =
  HTTPValidationError;

export function useGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet<
  TData = Awaited<
    ReturnType<
      typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet<
  TData = Awaited<
    ReturnType<
      typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet<
  TData = Awaited<
    ReturnType<
      typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Intercompany Eliminations
 */

export function useGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet<
  TData = Awaited<
    ReturnType<
      typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetIntercompanyEliminationsApiV1AccountingReportsIntercompanyEliminationsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get general ledger for an account. Pass `dimension_value_id` to slice by
a cost center / project / other analytic axis.
 * @summary Get General Ledger
 */
export const getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet = (
  params: GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/general-ledger`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetQueryKey =
  (params?: GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams) => {
    return [
      `/api/v1/accounting/reports/general-ledger`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet>
    >,
    TError = HTTPValidationError
  >(
    params: GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
        >
      >
    > = ({ signal }) =>
      getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet>
    >
  >;
export type GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetQueryError =
  HTTPValidationError;

export function useGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGet<
  TData = Awaited<
    ReturnType<typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet>
  >,
  TError = HTTPValidationError
>(
  params: GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGet<
  TData = Awaited<
    ReturnType<typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet>
  >,
  TError = HTTPValidationError
>(
  params: GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGet<
  TData = Awaited<
    ReturnType<typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet>
  >,
  TError = HTTPValidationError
>(
  params: GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get General Ledger
 */

export function useGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGet<
  TData = Awaited<
    ReturnType<typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet>
  >,
  TError = HTTPValidationError
>(
  params: GetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGeneralLedgerApiV1AccountingReportsGeneralLedgerGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetGeneralLedgerApiV1AccountingReportsGeneralLedgerGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List FX revaluation runs (most recent first), one page at a time.
 * @summary List Fx Revaluations
 */
export const listFxRevaluationsApiV1AccountingFxRevaluationsGet = (
  params?: ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<FxRevaluationListResponse>({
    url: `/api/v1/accounting/fx-revaluations`,
    method: 'GET',
    params,
    signal
  });
};

export const getListFxRevaluationsApiV1AccountingFxRevaluationsGetQueryKey = (
  params?: ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams
) => {
  return [
    `/api/v1/accounting/fx-revaluations`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListFxRevaluationsApiV1AccountingFxRevaluationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListFxRevaluationsApiV1AccountingFxRevaluationsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
      >
    > = ({ signal }) =>
      listFxRevaluationsApiV1AccountingFxRevaluationsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListFxRevaluationsApiV1AccountingFxRevaluationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
    >
  >;
export type ListFxRevaluationsApiV1AccountingFxRevaluationsGetQueryError =
  HTTPValidationError;

export function useListFxRevaluationsApiV1AccountingFxRevaluationsGet<
  TData = Awaited<
    ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFxRevaluationsApiV1AccountingFxRevaluationsGet<
  TData = Awaited<
    ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFxRevaluationsApiV1AccountingFxRevaluationsGet<
  TData = Awaited<
    ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Fx Revaluations
 */

export function useListFxRevaluationsApiV1AccountingFxRevaluationsGet<
  TData = Awaited<
    ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFxRevaluationsApiV1AccountingFxRevaluationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFxRevaluationsApiV1AccountingFxRevaluationsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListFxRevaluationsApiV1AccountingFxRevaluationsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Run the period-end FX revaluation for a fiscal period.

Idempotent — re-running for the same period returns the existing run.
 * @summary Run Fx Revaluation
 */
export const runFxRevaluationApiV1AccountingFxRevaluationsPost = (
  fxRevaluationRunRequest: FxRevaluationRunRequest,
  signal?: AbortSignal
) => {
  return customInstance<FxRevaluationResponse>({
    url: `/api/v1/accounting/fx-revaluations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: fxRevaluationRunRequest,
    signal
  });
};

export const getRunFxRevaluationApiV1AccountingFxRevaluationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof runFxRevaluationApiV1AccountingFxRevaluationsPost>
      >,
      TError,
      { data: FxRevaluationRunRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof runFxRevaluationApiV1AccountingFxRevaluationsPost>
    >,
    TError,
    { data: FxRevaluationRunRequest },
    TContext
  > => {
    const mutationKey = ['runFxRevaluationApiV1AccountingFxRevaluationsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof runFxRevaluationApiV1AccountingFxRevaluationsPost>
      >,
      { data: FxRevaluationRunRequest }
    > = (props) => {
      const { data } = props ?? {};

      return runFxRevaluationApiV1AccountingFxRevaluationsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunFxRevaluationApiV1AccountingFxRevaluationsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof runFxRevaluationApiV1AccountingFxRevaluationsPost>
    >
  >;
export type RunFxRevaluationApiV1AccountingFxRevaluationsPostMutationBody =
  FxRevaluationRunRequest;
export type RunFxRevaluationApiV1AccountingFxRevaluationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Run Fx Revaluation
 */
export const useRunFxRevaluationApiV1AccountingFxRevaluationsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof runFxRevaluationApiV1AccountingFxRevaluationsPost>
      >,
      TError,
      { data: FxRevaluationRunRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof runFxRevaluationApiV1AccountingFxRevaluationsPost>>,
  TError,
  { data: FxRevaluationRunRequest },
  TContext
> => {
  const mutationOptions =
    getRunFxRevaluationApiV1AccountingFxRevaluationsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a single FX revaluation run with its per-currency lines, scoped to the
caller's company access.
 * @summary Get Fx Revaluation
 */
export const getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet = (
  revaluationId: string,
  signal?: AbortSignal
) => {
  return customInstance<FxRevaluationResponse>({
    url: `/api/v1/accounting/fx-revaluations/${revaluationId}`,
    method: 'GET',
    signal
  });
};

export const getGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGetQueryKey =
  (revaluationId?: string) => {
    return [`/api/v1/accounting/fx-revaluations/${revaluationId}`] as const;
  };

export const getGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    revaluationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGetQueryKey(
        revaluationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
        >
      >
    > = ({ signal }) =>
      getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet(
        revaluationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!revaluationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
      >
    >
  >;
export type GetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGetQueryError =
  HTTPValidationError;

export function useGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  revaluationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  revaluationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  revaluationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Fx Revaluation
 */

export function useGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  revaluationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdGetQueryOptions(
      revaluationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Void a posted FX revaluation (reverse its journal entries) so the period
can be re-revalued. Both affected periods must be open — reopen the period
first.
 * @summary Void Fx Revaluation
 */
export const voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost =
  (
    revaluationId: string,
    fxRevaluationVoidRequest: FxRevaluationVoidRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<FxRevaluationResponse>({
      url: `/api/v1/accounting/fx-revaluations/${revaluationId}/void`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: fxRevaluationVoidRequest,
      signal
    });
  };

export const getVoidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost
        >
      >,
      TError,
      { revaluationId: string; data: FxRevaluationVoidRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost
      >
    >,
    TError,
    { revaluationId: string; data: FxRevaluationVoidRequest },
    TContext
  > => {
    const mutationKey = [
      'voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost
        >
      >,
      { revaluationId: string; data: FxRevaluationVoidRequest }
    > = (props) => {
      const { revaluationId, data } = props ?? {};

      return voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost(
        revaluationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type VoidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost
      >
    >
  >;
export type VoidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPostMutationBody =
  FxRevaluationVoidRequest;
export type VoidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPostMutationError =
  HTTPValidationError;

/**
 * @summary Void Fx Revaluation
 */
export const useVoidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost
          >
        >,
        TError,
        { revaluationId: string; data: FxRevaluationVoidRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof voidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPost
      >
    >,
    TError,
    { revaluationId: string; data: FxRevaluationVoidRequest },
    TContext
  > => {
    const mutationOptions =
      getVoidFxRevaluationApiV1AccountingFxRevaluationsRevaluationIdVoidPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Export accounting data in BKMV (Israeli Open Format) as a ZIP file.
 * @summary Export Bkmv
 */
export const exportBkmvApiV1AccountingExportBkmvGet = (
  params: ExportBkmvApiV1AccountingExportBkmvGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/export/bkmv`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportBkmvApiV1AccountingExportBkmvGetQueryKey = (
  params?: ExportBkmvApiV1AccountingExportBkmvGetParams
) => {
  return [
    `/api/v1/accounting/export/bkmv`,
    ...(params ? [params] : [])
  ] as const;
};

export const getExportBkmvApiV1AccountingExportBkmvGetQueryOptions = <
  TData = Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
  TError = HTTPValidationError
>(
  params: ExportBkmvApiV1AccountingExportBkmvGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExportBkmvApiV1AccountingExportBkmvGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>
  > = ({ signal }) => exportBkmvApiV1AccountingExportBkmvGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExportBkmvApiV1AccountingExportBkmvGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>
>;
export type ExportBkmvApiV1AccountingExportBkmvGetQueryError =
  HTTPValidationError;

export function useExportBkmvApiV1AccountingExportBkmvGet<
  TData = Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
  TError = HTTPValidationError
>(
  params: ExportBkmvApiV1AccountingExportBkmvGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
          TError,
          Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportBkmvApiV1AccountingExportBkmvGet<
  TData = Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
  TError = HTTPValidationError
>(
  params: ExportBkmvApiV1AccountingExportBkmvGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
          TError,
          Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportBkmvApiV1AccountingExportBkmvGet<
  TData = Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
  TError = HTTPValidationError
>(
  params: ExportBkmvApiV1AccountingExportBkmvGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Bkmv
 */

export function useExportBkmvApiV1AccountingExportBkmvGet<
  TData = Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
  TError = HTTPValidationError
>(
  params: ExportBkmvApiV1AccountingExportBkmvGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBkmvApiV1AccountingExportBkmvGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getExportBkmvApiV1AccountingExportBkmvGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate BKMV export and return summary (record counts + document type breakdown).
 * @summary Export Bkmv Summary
 */
export const exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet = (
  params: ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/export/bkmv/summary`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetQueryKey = (
  params?: ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams
) => {
  return [
    `/api/v1/accounting/export/bkmv/summary`,
    ...(params ? [params] : [])
  ] as const;
};

export const getExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
    >,
    TError = HTTPValidationError
  >(
    params: ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
      >
    > = ({ signal }) =>
      exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
    >
  >;
export type ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetQueryError =
  HTTPValidationError;

export function useExportBkmvSummaryApiV1AccountingExportBkmvSummaryGet<
  TData = Awaited<
    ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportBkmvSummaryApiV1AccountingExportBkmvSummaryGet<
  TData = Awaited<
    ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportBkmvSummaryApiV1AccountingExportBkmvSummaryGet<
  TData = Awaited<
    ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Bkmv Summary
 */

export function useExportBkmvSummaryApiV1AccountingExportBkmvSummaryGet<
  TData = Awaited<
    ReturnType<typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportBkmvSummaryApiV1AccountingExportBkmvSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportBkmvSummaryApiV1AccountingExportBkmvSummaryGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Counts for the accountant-export dialog (would-export + already-reported).
 * @summary Preview Accountant Export
 */
export const previewAccountantExportApiV1AccountingAccountantExportPreviewGet =
  (
    params: PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<AccountantExportPreviewResponse>({
      url: `/api/v1/accounting/accountant-export/preview`,
      method: 'GET',
      params,
      signal
    });
  };

export const getPreviewAccountantExportApiV1AccountingAccountantExportPreviewGetQueryKey =
  (
    params?: PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams
  ) => {
    return [
      `/api/v1/accounting/accountant-export/preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getPreviewAccountantExportApiV1AccountingAccountantExportPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPreviewAccountantExportApiV1AccountingAccountantExportPreviewGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
        >
      >
    > = ({ signal }) =>
      previewAccountantExportApiV1AccountingAccountantExportPreviewGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
      >
    >
  >;
export type PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetQueryError =
  HTTPValidationError;

export function usePreviewAccountantExportApiV1AccountingAccountantExportPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  params: PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePreviewAccountantExportApiV1AccountingAccountantExportPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  params: PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePreviewAccountantExportApiV1AccountingAccountantExportPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  params: PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Preview Accountant Export
 */

export function usePreviewAccountantExportApiV1AccountingAccountantExportPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  params: PreviewAccountantExportApiV1AccountingAccountantExportPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewAccountantExportApiV1AccountingAccountantExportPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getPreviewAccountantExportApiV1AccountingAccountantExportPreviewGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bundle every expense-bill receipt attachment for a period into one ZIP.

Gated at ``member`` (not ``viewer``): although a viewer can already see each
bill's receipt individually, the bulk-exfil convenience of a one-click
period backup warrants the same tier as the tabular accountant export.
 * @summary Download Expense Receipts Zip
 */
export const downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet =
  (
    params: DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/accountant-export/receipts-zip`,
      method: 'GET',
      params,
      signal
    });
  };

export const getDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetQueryKey =
  (
    params?: DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams
  ) => {
    return [
      `/api/v1/accounting/accountant-export/receipts-zip`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
        >
      >
    > = ({ signal }) =>
      downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
      >
    >
  >;
export type DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetQueryError =
  HTTPValidationError;

export function useDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet<
  TData = Awaited<
    ReturnType<
      typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet<
  TData = Awaited<
    ReturnType<
      typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet<
  TData = Awaited<
    ReturnType<
      typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Expense Receipts Zip
 */

export function useDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet<
  TData = Awaited<
    ReturnType<
      typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadExpenseReceiptsZipApiV1AccountingAccountantExportReceiptsZipGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an accountant export file, record the batch, mark docs reported.
 * @summary Generate Accountant Export
 */
export const generateAccountantExportApiV1AccountingAccountantExportPost = (
  accountantExportRequest: AccountantExportRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/accountant-export`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: accountantExportRequest,
    signal
  });
};

export const getGenerateAccountantExportApiV1AccountingAccountantExportPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateAccountantExportApiV1AccountingAccountantExportPost
        >
      >,
      TError,
      { data: AccountantExportRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateAccountantExportApiV1AccountingAccountantExportPost
      >
    >,
    TError,
    { data: AccountantExportRequest },
    TContext
  > => {
    const mutationKey = [
      'generateAccountantExportApiV1AccountingAccountantExportPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateAccountantExportApiV1AccountingAccountantExportPost
        >
      >,
      { data: AccountantExportRequest }
    > = (props) => {
      const { data } = props ?? {};

      return generateAccountantExportApiV1AccountingAccountantExportPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateAccountantExportApiV1AccountingAccountantExportPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateAccountantExportApiV1AccountingAccountantExportPost
      >
    >
  >;
export type GenerateAccountantExportApiV1AccountingAccountantExportPostMutationBody =
  AccountantExportRequest;
export type GenerateAccountantExportApiV1AccountingAccountantExportPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Accountant Export
 */
export const useGenerateAccountantExportApiV1AccountingAccountantExportPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateAccountantExportApiV1AccountingAccountantExportPost
        >
      >,
      TError,
      { data: AccountantExportRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof generateAccountantExportApiV1AccountingAccountantExportPost
    >
  >,
  TError,
  { data: AccountantExportRequest },
  TContext
> => {
  const mutationOptions =
    getGenerateAccountantExportApiV1AccountingAccountantExportPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List past accountant exports (newest first), with re-download metadata.
 * @summary List Accountant Export History
 */
export const listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet =
  (
    params?: ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<AccountantExportHistoryResponse>({
      url: `/api/v1/accounting/accountant-export/history`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetQueryKey =
  (
    params?: ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams
  ) => {
    return [
      `/api/v1/accounting/accountant-export/history`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
        >
      >
    > = ({ signal }) =>
      listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
      >
    >
  >;
export type ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetQueryError =
  HTTPValidationError;

export function useListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Accountant Export History
 */

export function useListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantExportHistoryApiV1AccountingAccountantExportHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAccountantExportHistoryApiV1AccountingAccountantExportHistoryGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Re-download a past export, regenerated from its stored document membership.
 * @summary Download Accountant Export
 */
export const downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet =
  (batchId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/accountant-export/${batchId}/download`,
      method: 'GET',
      signal
    });
  };

export const getDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGetQueryKey =
  (batchId?: string) => {
    return [
      `/api/v1/accounting/accountant-export/${batchId}/download`
    ] as const;
  };

export const getDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
      >
    >,
    TError = HTTPValidationError
  >(
    batchId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGetQueryKey(
        batchId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
        >
      >
    > = ({ signal }) =>
      downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet(
        batchId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!batchId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
      >
    >
  >;
export type DownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGetQueryError =
  HTTPValidationError;

export function useDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  batchId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Accountant Export
 */

export function useDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadAccountantExportApiV1AccountingAccountantExportBatchIdDownloadGetQueryOptions(
      batchId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Cancel a past export, un-reporting its documents for the next export.
 * @summary Cancel Accountant Export
 */
export const cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost =
  (batchId: string, signal?: AbortSignal) => {
    return customInstance<AccountantExportBatchResponse>({
      url: `/api/v1/accounting/accountant-export/${batchId}/cancel`,
      method: 'POST',
      signal
    });
  };

export const getCancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost
        >
      >,
      TError,
      { batchId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost
      >
    >,
    TError,
    { batchId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost
        >
      >,
      { batchId: string }
    > = (props) => {
      const { batchId } = props ?? {};

      return cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost(
        batchId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost
      >
    >
  >;

export type CancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Accountant Export
 */
export const useCancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost
          >
        >,
        TError,
        { batchId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPost
      >
    >,
    TError,
    { batchId: string },
    TContext
  > => {
    const mutationOptions =
      getCancelAccountantExportApiV1AccountingAccountantExportBatchIdCancelPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The scheduled auto-send config (income/expense) for a company.
 * @summary List Accountant Report Schedules
 */
export const listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet =
  (
    params?: ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<AccountantReportScheduleListResponse>({
      url: `/api/v1/accounting/accountant-export/schedules`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetQueryKey =
  (
    params?: ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams
  ) => {
    return [
      `/api/v1/accounting/accountant-export/schedules`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
        >
      >
    > = ({ signal }) =>
      listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
      >
    >
  >;
export type ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetQueryError =
  HTTPValidationError;

export function useListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Accountant Report Schedules
 */

export function useListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet<
  TData = Awaited<
    ReturnType<
      typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAccountantReportSchedulesApiV1AccountingAccountantExportSchedulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update the scheduled accountant export for one (company, kind).

Configuration is tenant-admin only: enabling it adds a recurring side-effect
(auto-emailing the accountant + auto-marking documents reported).
 * @summary Upsert Accountant Report Schedule
 */
export const upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut =
  (
    kind: string,
    accountantReportScheduleUpdate: AccountantReportScheduleUpdate
  ) => {
    return customInstance<AccountantReportScheduleResponse>({
      url: `/api/v1/accounting/accountant-export/schedules/${kind}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: accountantReportScheduleUpdate
    });
  };

export const getUpsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut
        >
      >,
      TError,
      { kind: string; data: AccountantReportScheduleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut
      >
    >,
    TError,
    { kind: string; data: AccountantReportScheduleUpdate },
    TContext
  > => {
    const mutationKey = [
      'upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut
        >
      >,
      { kind: string; data: AccountantReportScheduleUpdate }
    > = (props) => {
      const { kind, data } = props ?? {};

      return upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut(
        kind,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut
      >
    >
  >;
export type UpsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPutMutationBody =
  AccountantReportScheduleUpdate;
export type UpsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Accountant Report Schedule
 */
export const useUpsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut
          >
        >,
        TError,
        { kind: string; data: AccountantReportScheduleUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof upsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPut
      >
    >,
    TError,
    { kind: string; data: AccountantReportScheduleUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpsertAccountantReportScheduleApiV1AccountingAccountantExportSchedulesKindPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Bank Accounts
 */
export const listBankAccountsApiV1AccountingBankAccountsGet = (
  params?: ListBankAccountsApiV1AccountingBankAccountsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bank-accounts`,
    method: 'GET',
    params,
    signal
  });
};

export const getListBankAccountsApiV1AccountingBankAccountsGetQueryKey = (
  params?: ListBankAccountsApiV1AccountingBankAccountsGetParams
) => {
  return [
    `/api/v1/accounting/bank-accounts`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListBankAccountsApiV1AccountingBankAccountsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListBankAccountsApiV1AccountingBankAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListBankAccountsApiV1AccountingBankAccountsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>>
  > = ({ signal }) =>
    listBankAccountsApiV1AccountingBankAccountsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListBankAccountsApiV1AccountingBankAccountsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>>
  >;
export type ListBankAccountsApiV1AccountingBankAccountsGetQueryError =
  HTTPValidationError;

export function useListBankAccountsApiV1AccountingBankAccountsGet<
  TData = Awaited<
    ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListBankAccountsApiV1AccountingBankAccountsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBankAccountsApiV1AccountingBankAccountsGet<
  TData = Awaited<
    ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListBankAccountsApiV1AccountingBankAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBankAccountsApiV1AccountingBankAccountsGet<
  TData = Awaited<
    ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListBankAccountsApiV1AccountingBankAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Bank Accounts
 */

export function useListBankAccountsApiV1AccountingBankAccountsGet<
  TData = Awaited<
    ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListBankAccountsApiV1AccountingBankAccountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBankAccountsApiV1AccountingBankAccountsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListBankAccountsApiV1AccountingBankAccountsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Bank Account
 */
export const createBankAccountApiV1AccountingBankAccountsPost = (
  bankAccountCreateRequest: BankAccountCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bank-accounts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bankAccountCreateRequest,
    signal
  });
};

export const getCreateBankAccountApiV1AccountingBankAccountsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createBankAccountApiV1AccountingBankAccountsPost>
      >,
      TError,
      { data: BankAccountCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createBankAccountApiV1AccountingBankAccountsPost>
    >,
    TError,
    { data: BankAccountCreateRequest },
    TContext
  > => {
    const mutationKey = ['createBankAccountApiV1AccountingBankAccountsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createBankAccountApiV1AccountingBankAccountsPost>
      >,
      { data: BankAccountCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createBankAccountApiV1AccountingBankAccountsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateBankAccountApiV1AccountingBankAccountsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createBankAccountApiV1AccountingBankAccountsPost>>
  >;
export type CreateBankAccountApiV1AccountingBankAccountsPostMutationBody =
  BankAccountCreateRequest;
export type CreateBankAccountApiV1AccountingBankAccountsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Bank Account
 */
export const useCreateBankAccountApiV1AccountingBankAccountsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createBankAccountApiV1AccountingBankAccountsPost>
      >,
      TError,
      { data: BankAccountCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBankAccountApiV1AccountingBankAccountsPost>>,
  TError,
  { data: BankAccountCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateBankAccountApiV1AccountingBankAccountsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Bank Account
 */
export const getBankAccountApiV1AccountingBankAccountsBankAccountIdGet = (
  bankAccountId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bank-accounts/${bankAccountId}`,
    method: 'GET',
    signal
  });
};

export const getGetBankAccountApiV1AccountingBankAccountsBankAccountIdGetQueryKey =
  (bankAccountId?: string) => {
    return [`/api/v1/accounting/bank-accounts/${bankAccountId}`] as const;
  };

export const getGetBankAccountApiV1AccountingBankAccountsBankAccountIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    bankAccountId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBankAccountApiV1AccountingBankAccountsBankAccountIdGetQueryKey(
        bankAccountId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
        >
      >
    > = ({ signal }) =>
      getBankAccountApiV1AccountingBankAccountsBankAccountIdGet(
        bankAccountId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!bankAccountId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBankAccountApiV1AccountingBankAccountsBankAccountIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
      >
    >
  >;
export type GetBankAccountApiV1AccountingBankAccountsBankAccountIdGetQueryError =
  HTTPValidationError;

export function useGetBankAccountApiV1AccountingBankAccountsBankAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  bankAccountId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBankAccountApiV1AccountingBankAccountsBankAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  bankAccountId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBankAccountApiV1AccountingBankAccountsBankAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  bankAccountId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bank Account
 */

export function useGetBankAccountApiV1AccountingBankAccountsBankAccountIdGet<
  TData = Awaited<
    ReturnType<typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet>
  >,
  TError = HTTPValidationError
>(
  bankAccountId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBankAccountApiV1AccountingBankAccountsBankAccountIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBankAccountApiV1AccountingBankAccountsBankAccountIdGetQueryOptions(
      bankAccountId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Bank Account
 */
export const updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut = (
  bankAccountId: string,
  bankAccountUpdateRequest: BankAccountUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bank-accounts/${bankAccountId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: bankAccountUpdateRequest
  });
};

export const getUpdateBankAccountApiV1AccountingBankAccountsBankAccountIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut
        >
      >,
      TError,
      { bankAccountId: string; data: BankAccountUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut
      >
    >,
    TError,
    { bankAccountId: string; data: BankAccountUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut
        >
      >,
      { bankAccountId: string; data: BankAccountUpdateRequest }
    > = (props) => {
      const { bankAccountId, data } = props ?? {};

      return updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut(
        bankAccountId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateBankAccountApiV1AccountingBankAccountsBankAccountIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut
      >
    >
  >;
export type UpdateBankAccountApiV1AccountingBankAccountsBankAccountIdPutMutationBody =
  BankAccountUpdateRequest;
export type UpdateBankAccountApiV1AccountingBankAccountsBankAccountIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Bank Account
 */
export const useUpdateBankAccountApiV1AccountingBankAccountsBankAccountIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut
        >
      >,
      TError,
      { bankAccountId: string; data: BankAccountUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateBankAccountApiV1AccountingBankAccountsBankAccountIdPut
    >
  >,
  TError,
  { bankAccountId: string; data: BankAccountUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateBankAccountApiV1AccountingBankAccountsBankAccountIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Bank Account
 */
export const deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete = (
  bankAccountId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bank-accounts/${bankAccountId}`,
    method: 'DELETE'
  });
};

export const getDeleteBankAccountApiV1AccountingBankAccountsBankAccountIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete
        >
      >,
      TError,
      { bankAccountId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete
      >
    >,
    TError,
    { bankAccountId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete
        >
      >,
      { bankAccountId: string }
    > = (props) => {
      const { bankAccountId } = props ?? {};

      return deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete(
        bankAccountId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteBankAccountApiV1AccountingBankAccountsBankAccountIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete
      >
    >
  >;

export type DeleteBankAccountApiV1AccountingBankAccountsBankAccountIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Bank Account
 */
export const useDeleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete
          >
        >,
        TError,
        { bankAccountId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteBankAccountApiV1AccountingBankAccountsBankAccountIdDelete
      >
    >,
    TError,
    { bankAccountId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteBankAccountApiV1AccountingBankAccountsBankAccountIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List every payer's outstanding "Due to <payer>" balance — the subledger view.
 * @summary List Reimbursement Payer Balances
 */
export const listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet =
  (
    params?: ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ReimbursementPayerBalanceListResponse>({
      url: `/api/v1/accounting/reimbursements/payers`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetQueryKey =
  (
    params?: ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams
  ) => {
    return [
      `/api/v1/accounting/reimbursements/payers`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
        >
      >
    > = ({ signal }) =>
      listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
      >
    >
  >;
export type ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetQueryError =
  HTTPValidationError;

export function useListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Reimbursement Payer Balances
 */

export function useListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListReimbursementPayerBalancesApiV1AccountingReimbursementsPayersGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One payer's reimbursement ledger (newest first) + per-currency balances.
 * @summary List Reimbursement Payer Transactions
 */
export const listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet =
  (
    payerEntityTable: string,
    payerEntityId: string,
    params?: ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ReimbursementPayerTransactionsResponse>({
      url: `/api/v1/accounting/reimbursements/payers/${payerEntityTable}/${payerEntityId}/transactions`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetQueryKey =
  (
    payerEntityTable?: string,
    payerEntityId?: string,
    params?: ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams
  ) => {
    return [
      `/api/v1/accounting/reimbursements/payers/${payerEntityTable}/${payerEntityId}/transactions`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    payerEntityTable: string,
    payerEntityId: string,
    params?: ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetQueryKey(
        payerEntityTable,
        payerEntityId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
        >
      >
    > = ({ signal }) =>
      listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet(
        payerEntityTable,
        payerEntityId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(payerEntityTable && payerEntityId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
      >
    >
  >;
export type ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetQueryError =
  HTTPValidationError;

export function useListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  payerEntityTable: string,
  payerEntityId: string,
  params:
    | undefined
    | ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  payerEntityTable: string,
  payerEntityId: string,
  params?: ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  payerEntityTable: string,
  payerEntityId: string,
  params?: ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Reimbursement Payer Transactions
 */

export function useListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
    >
  >,
  TError = HTTPValidationError
>(
  payerEntityTable: string,
  payerEntityId: string,
  params?: ListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListReimbursementPayerTransactionsApiV1AccountingReimbursementsPayersPayerEntityTablePayerEntityIdTransactionsGetQueryOptions(
      payerEntityTable,
      payerEntityId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reimburse a payer (DR 2350 / CR business bank) and record the clearing.
 * @summary Clear Reimbursement Payer
 */
export const clearReimbursementPayerApiV1AccountingReimbursementsClearPost = (
  reimbursementClearRequest: ReimbursementClearRequest,
  signal?: AbortSignal
) => {
  return customInstance<ReimbursementClearResponse>({
    url: `/api/v1/accounting/reimbursements/clear`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reimbursementClearRequest,
    signal
  });
};

export const getClearReimbursementPayerApiV1AccountingReimbursementsClearPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearReimbursementPayerApiV1AccountingReimbursementsClearPost
        >
      >,
      TError,
      { data: ReimbursementClearRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof clearReimbursementPayerApiV1AccountingReimbursementsClearPost
      >
    >,
    TError,
    { data: ReimbursementClearRequest },
    TContext
  > => {
    const mutationKey = [
      'clearReimbursementPayerApiV1AccountingReimbursementsClearPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof clearReimbursementPayerApiV1AccountingReimbursementsClearPost
        >
      >,
      { data: ReimbursementClearRequest }
    > = (props) => {
      const { data } = props ?? {};

      return clearReimbursementPayerApiV1AccountingReimbursementsClearPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClearReimbursementPayerApiV1AccountingReimbursementsClearPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof clearReimbursementPayerApiV1AccountingReimbursementsClearPost
      >
    >
  >;
export type ClearReimbursementPayerApiV1AccountingReimbursementsClearPostMutationBody =
  ReimbursementClearRequest;
export type ClearReimbursementPayerApiV1AccountingReimbursementsClearPostMutationError =
  HTTPValidationError;

/**
 * @summary Clear Reimbursement Payer
 */
export const useClearReimbursementPayerApiV1AccountingReimbursementsClearPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof clearReimbursementPayerApiV1AccountingReimbursementsClearPost
          >
        >,
        TError,
        { data: ReimbursementClearRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof clearReimbursementPayerApiV1AccountingReimbursementsClearPost
      >
    >,
    TError,
    { data: ReimbursementClearRequest },
    TContext
  > => {
    const mutationOptions =
      getClearReimbursementPayerApiV1AccountingReimbursementsClearPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reimburse several payers in one transaction (each its own balanced JE).
 * @summary Clear Reimbursement Payers Batch
 */
export const clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost =
  (
    reimbursementClearBatchRequest: ReimbursementClearBatchRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ReimbursementClearBatchResponse>({
      url: `/api/v1/accounting/reimbursements/clear-batch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reimbursementClearBatchRequest,
      signal
    });
  };

export const getClearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost
        >
      >,
      TError,
      { data: ReimbursementClearBatchRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost
      >
    >,
    TError,
    { data: ReimbursementClearBatchRequest },
    TContext
  > => {
    const mutationKey = [
      'clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost
        >
      >,
      { data: ReimbursementClearBatchRequest }
    > = (props) => {
      const { data } = props ?? {};

      return clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost
      >
    >
  >;
export type ClearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPostMutationBody =
  ReimbursementClearBatchRequest;
export type ClearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPostMutationError =
  HTTPValidationError;

/**
 * @summary Clear Reimbursement Payers Batch
 */
export const useClearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost
          >
        >,
        TError,
        { data: ReimbursementClearBatchRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof clearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPost
      >
    >,
    TError,
    { data: ReimbursementClearBatchRequest },
    TContext
  > => {
    const mutationOptions =
      getClearReimbursementPayersBatchApiV1AccountingReimbursementsClearBatchPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the company's tax rates.

Shape B (bounded reference data — § 11 names tax rates outright): a tenant
curates its rate catalogue to a natural size and ``TaxRateList`` slices and
filters it client-side, so omitting ``limit`` returns the WHOLE catalogue.
``resolve_limit`` is what makes that safe rather than unbounded: FastAPI
skips ``le=`` on ``None`` and SQLAlchemy's ``.limit(None)`` drops the LIMIT
clause entirely, so the handler resolves the value before the service ever
sees it and a client-supplied cap is clamped to ``MAX_LIST_LIMIT``.
 * @summary List Tax Rates
 */
export const listTaxRatesApiV1AccountingTaxRatesGet = (
  params?: ListTaxRatesApiV1AccountingTaxRatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/tax-rates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTaxRatesApiV1AccountingTaxRatesGetQueryKey = (
  params?: ListTaxRatesApiV1AccountingTaxRatesGetParams
) => {
  return [`/api/v1/accounting/tax-rates`, ...(params ? [params] : [])] as const;
};

export const getListTaxRatesApiV1AccountingTaxRatesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTaxRatesApiV1AccountingTaxRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTaxRatesApiV1AccountingTaxRatesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>
  > = ({ signal }) => listTaxRatesApiV1AccountingTaxRatesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTaxRatesApiV1AccountingTaxRatesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>
>;
export type ListTaxRatesApiV1AccountingTaxRatesGetQueryError =
  HTTPValidationError;

export function useListTaxRatesApiV1AccountingTaxRatesGet<
  TData = Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListTaxRatesApiV1AccountingTaxRatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
          TError,
          Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTaxRatesApiV1AccountingTaxRatesGet<
  TData = Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTaxRatesApiV1AccountingTaxRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
          TError,
          Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTaxRatesApiV1AccountingTaxRatesGet<
  TData = Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTaxRatesApiV1AccountingTaxRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tax Rates
 */

export function useListTaxRatesApiV1AccountingTaxRatesGet<
  TData = Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTaxRatesApiV1AccountingTaxRatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTaxRatesApiV1AccountingTaxRatesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListTaxRatesApiV1AccountingTaxRatesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Tax Rate
 */
export const createTaxRateApiV1AccountingTaxRatesPost = (
  taxRateCreateRequest: TaxRateCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/tax-rates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: taxRateCreateRequest,
    signal
  });
};

export const getCreateTaxRateApiV1AccountingTaxRatesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaxRateApiV1AccountingTaxRatesPost>>,
    TError,
    { data: TaxRateCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaxRateApiV1AccountingTaxRatesPost>>,
  TError,
  { data: TaxRateCreateRequest },
  TContext
> => {
  const mutationKey = ['createTaxRateApiV1AccountingTaxRatesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaxRateApiV1AccountingTaxRatesPost>>,
    { data: TaxRateCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createTaxRateApiV1AccountingTaxRatesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaxRateApiV1AccountingTaxRatesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createTaxRateApiV1AccountingTaxRatesPost>>
  >;
export type CreateTaxRateApiV1AccountingTaxRatesPostMutationBody =
  TaxRateCreateRequest;
export type CreateTaxRateApiV1AccountingTaxRatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Tax Rate
 */
export const useCreateTaxRateApiV1AccountingTaxRatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTaxRateApiV1AccountingTaxRatesPost>>,
      TError,
      { data: TaxRateCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTaxRateApiV1AccountingTaxRatesPost>>,
  TError,
  { data: TaxRateCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateTaxRateApiV1AccountingTaxRatesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Tax Rate
 */
export const getTaxRateApiV1AccountingTaxRatesTaxRateIdGet = (
  taxRateId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/tax-rates/${taxRateId}`,
    method: 'GET',
    signal
  });
};

export const getGetTaxRateApiV1AccountingTaxRatesTaxRateIdGetQueryKey = (
  taxRateId?: string
) => {
  return [`/api/v1/accounting/tax-rates/${taxRateId}`] as const;
};

export const getGetTaxRateApiV1AccountingTaxRatesTaxRateIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
  >,
  TError = HTTPValidationError
>(
  taxRateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTaxRateApiV1AccountingTaxRatesTaxRateIdGetQueryKey(taxRateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>>
  > = ({ signal }) =>
    getTaxRateApiV1AccountingTaxRatesTaxRateIdGet(taxRateId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!taxRateId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTaxRateApiV1AccountingTaxRatesTaxRateIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>>
  >;
export type GetTaxRateApiV1AccountingTaxRatesTaxRateIdGetQueryError =
  HTTPValidationError;

export function useGetTaxRateApiV1AccountingTaxRatesTaxRateIdGet<
  TData = Awaited<
    ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
  >,
  TError = HTTPValidationError
>(
  taxRateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTaxRateApiV1AccountingTaxRatesTaxRateIdGet<
  TData = Awaited<
    ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
  >,
  TError = HTTPValidationError
>(
  taxRateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTaxRateApiV1AccountingTaxRatesTaxRateIdGet<
  TData = Awaited<
    ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
  >,
  TError = HTTPValidationError
>(
  taxRateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tax Rate
 */

export function useGetTaxRateApiV1AccountingTaxRatesTaxRateIdGet<
  TData = Awaited<
    ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
  >,
  TError = HTTPValidationError
>(
  taxRateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTaxRateApiV1AccountingTaxRatesTaxRateIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTaxRateApiV1AccountingTaxRatesTaxRateIdGetQueryOptions(
      taxRateId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Tax Rate
 */
export const updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut = (
  taxRateId: string,
  taxRateUpdateRequest: TaxRateUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/tax-rates/${taxRateId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: taxRateUpdateRequest
  });
};

export const getUpdateTaxRateApiV1AccountingTaxRatesTaxRateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut>
      >,
      TError,
      { taxRateId: string; data: TaxRateUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut>
    >,
    TError,
    { taxRateId: string; data: TaxRateUpdateRequest },
    TContext
  > => {
    const mutationKey = ['updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut>
      >,
      { taxRateId: string; data: TaxRateUpdateRequest }
    > = (props) => {
      const { taxRateId, data } = props ?? {};

      return updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut(taxRateId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTaxRateApiV1AccountingTaxRatesTaxRateIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut>>
  >;
export type UpdateTaxRateApiV1AccountingTaxRatesTaxRateIdPutMutationBody =
  TaxRateUpdateRequest;
export type UpdateTaxRateApiV1AccountingTaxRatesTaxRateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tax Rate
 */
export const useUpdateTaxRateApiV1AccountingTaxRatesTaxRateIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut>
      >,
      TError,
      { taxRateId: string; data: TaxRateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTaxRateApiV1AccountingTaxRatesTaxRateIdPut>>,
  TError,
  { taxRateId: string; data: TaxRateUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateTaxRateApiV1AccountingTaxRatesTaxRateIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Tax Rate
 */
export const deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete = (
  taxRateId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/tax-rates/${taxRateId}`,
    method: 'DELETE'
  });
};

export const getDeleteTaxRateApiV1AccountingTaxRatesTaxRateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete>
      >,
      TError,
      { taxRateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete>
    >,
    TError,
    { taxRateId: string },
    TContext
  > => {
    const mutationKey = ['deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete>
      >,
      { taxRateId: string }
    > = (props) => {
      const { taxRateId } = props ?? {};

      return deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete(taxRateId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTaxRateApiV1AccountingTaxRatesTaxRateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete>
    >
  >;

export type DeleteTaxRateApiV1AccountingTaxRatesTaxRateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Tax Rate
 */
export const useDeleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete>
      >,
      TError,
      { taxRateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteTaxRateApiV1AccountingTaxRatesTaxRateIdDelete>
  >,
  TError,
  { taxRateId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteTaxRateApiV1AccountingTaxRatesTaxRateIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Initialize Default Tax Rates
 */
export const initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/tax-rates/initialize-defaults`,
      method: 'POST',
      signal
    });
  };

export const getInitializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost
        >
      >,
      void
    > = () => {
      return initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type InitializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost
      >
    >
  >;

export type InitializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPostMutationError =
  unknown;

/**
 * @summary Initialize Default Tax Rates
 */
export const useInitializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof initializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getInitializeDefaultTaxRatesApiV1AccountingTaxRatesInitializeDefaultsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Payment Terms
 */
export const listPaymentTermsApiV1AccountingPaymentTermsGet = (
  params?: ListPaymentTermsApiV1AccountingPaymentTermsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PaymentTermListResponse>({
    url: `/api/v1/accounting/payment-terms`,
    method: 'GET',
    params,
    signal
  });
};

export const getListPaymentTermsApiV1AccountingPaymentTermsGetQueryKey = (
  params?: ListPaymentTermsApiV1AccountingPaymentTermsGetParams
) => {
  return [
    `/api/v1/accounting/payment-terms`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListPaymentTermsApiV1AccountingPaymentTermsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPaymentTermsApiV1AccountingPaymentTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPaymentTermsApiV1AccountingPaymentTermsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>>
  > = ({ signal }) =>
    listPaymentTermsApiV1AccountingPaymentTermsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListPaymentTermsApiV1AccountingPaymentTermsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>>
  >;
export type ListPaymentTermsApiV1AccountingPaymentTermsGetQueryError =
  HTTPValidationError;

export function useListPaymentTermsApiV1AccountingPaymentTermsGet<
  TData = Awaited<
    ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListPaymentTermsApiV1AccountingPaymentTermsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPaymentTermsApiV1AccountingPaymentTermsGet<
  TData = Awaited<
    ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPaymentTermsApiV1AccountingPaymentTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPaymentTermsApiV1AccountingPaymentTermsGet<
  TData = Awaited<
    ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPaymentTermsApiV1AccountingPaymentTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Payment Terms
 */

export function useListPaymentTermsApiV1AccountingPaymentTermsGet<
  TData = Awaited<
    ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPaymentTermsApiV1AccountingPaymentTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPaymentTermsApiV1AccountingPaymentTermsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPaymentTermsApiV1AccountingPaymentTermsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Payment Term
 */
export const createPaymentTermApiV1AccountingPaymentTermsPost = (
  paymentTermCreate: PaymentTermCreate,
  signal?: AbortSignal
) => {
  return customInstance<PaymentTermResponse>({
    url: `/api/v1/accounting/payment-terms`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: paymentTermCreate,
    signal
  });
};

export const getCreatePaymentTermApiV1AccountingPaymentTermsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPaymentTermApiV1AccountingPaymentTermsPost>
      >,
      TError,
      { data: PaymentTermCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createPaymentTermApiV1AccountingPaymentTermsPost>
    >,
    TError,
    { data: PaymentTermCreate },
    TContext
  > => {
    const mutationKey = ['createPaymentTermApiV1AccountingPaymentTermsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createPaymentTermApiV1AccountingPaymentTermsPost>
      >,
      { data: PaymentTermCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createPaymentTermApiV1AccountingPaymentTermsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreatePaymentTermApiV1AccountingPaymentTermsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createPaymentTermApiV1AccountingPaymentTermsPost>>
  >;
export type CreatePaymentTermApiV1AccountingPaymentTermsPostMutationBody =
  PaymentTermCreate;
export type CreatePaymentTermApiV1AccountingPaymentTermsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Payment Term
 */
export const useCreatePaymentTermApiV1AccountingPaymentTermsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPaymentTermApiV1AccountingPaymentTermsPost>
      >,
      TError,
      { data: PaymentTermCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPaymentTermApiV1AccountingPaymentTermsPost>>,
  TError,
  { data: PaymentTermCreate },
  TContext
> => {
  const mutationOptions =
    getCreatePaymentTermApiV1AccountingPaymentTermsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Payment Term
 */
export const getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet = (
  paymentTermId: string,
  signal?: AbortSignal
) => {
  return customInstance<PaymentTermResponse>({
    url: `/api/v1/accounting/payment-terms/${paymentTermId}`,
    method: 'GET',
    signal
  });
};

export const getGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGetQueryKey =
  (paymentTermId?: string) => {
    return [`/api/v1/accounting/payment-terms/${paymentTermId}`] as const;
  };

export const getGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    paymentTermId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGetQueryKey(
        paymentTermId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
        >
      >
    > = ({ signal }) =>
      getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet(
        paymentTermId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!paymentTermId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
      >
    >
  >;
export type GetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGetQueryError =
  HTTPValidationError;

export function useGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Payment Term
 */

export function useGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPaymentTermApiV1AccountingPaymentTermsPaymentTermIdGetQueryOptions(
      paymentTermId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Payment Term
 */
export const updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut = (
  paymentTermId: string,
  paymentTermUpdate: PaymentTermUpdate
) => {
  return customInstance<PaymentTermResponse>({
    url: `/api/v1/accounting/payment-terms/${paymentTermId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: paymentTermUpdate
  });
};

export const getUpdatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut
        >
      >,
      TError,
      { paymentTermId: string; data: PaymentTermUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut
      >
    >,
    TError,
    { paymentTermId: string; data: PaymentTermUpdate },
    TContext
  > => {
    const mutationKey = [
      'updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut
        >
      >,
      { paymentTermId: string; data: PaymentTermUpdate }
    > = (props) => {
      const { paymentTermId, data } = props ?? {};

      return updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut(
        paymentTermId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut
      >
    >
  >;
export type UpdatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPutMutationBody =
  PaymentTermUpdate;
export type UpdatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Payment Term
 */
export const useUpdatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut
        >
      >,
      TError,
      { paymentTermId: string; data: PaymentTermUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPut
    >
  >,
  TError,
  { paymentTermId: string; data: PaymentTermUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdatePaymentTermApiV1AccountingPaymentTermsPaymentTermIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Payment Term
 */
export const deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete = (
  paymentTermId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/payment-terms/${paymentTermId}`,
    method: 'DELETE'
  });
};

export const getDeletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete
        >
      >,
      TError,
      { paymentTermId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete
      >
    >,
    TError,
    { paymentTermId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete
        >
      >,
      { paymentTermId: string }
    > = (props) => {
      const { paymentTermId } = props ?? {};

      return deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete(
        paymentTermId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete
      >
    >
  >;

export type DeletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Payment Term
 */
export const useDeletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete
          >
        >,
        TError,
        { paymentTermId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDelete
      >
    >,
    TError,
    { paymentTermId: string },
    TContext
  > => {
    const mutationOptions =
      getDeletePaymentTermApiV1AccountingPaymentTermsPaymentTermIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Initialize Default Payment Terms
 */
export const initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost =
  (signal?: AbortSignal) => {
    return customInstance<PaymentTermListResponse>({
      url: `/api/v1/accounting/payment-terms/initialize-defaults`,
      method: 'POST',
      signal
    });
  };

export const getInitializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost
        >
      >,
      void
    > = () => {
      return initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type InitializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost
      >
    >
  >;

export type InitializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPostMutationError =
  unknown;

/**
 * @summary Initialize Default Payment Terms
 */
export const useInitializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof initializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getInitializeDefaultPaymentTermsApiV1AccountingPaymentTermsInitializeDefaultsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Payment Term Lines
 */
export const listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet =
  (paymentTermId: string, signal?: AbortSignal) => {
    return customInstance<PaymentTermLineListResponse>({
      url: `/api/v1/accounting/payment-terms/${paymentTermId}/lines`,
      method: 'GET',
      signal
    });
  };

export const getListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGetQueryKey =
  (paymentTermId?: string) => {
    return [`/api/v1/accounting/payment-terms/${paymentTermId}/lines`] as const;
  };

export const getListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
      >
    >,
    TError = HTTPValidationError
  >(
    paymentTermId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGetQueryKey(
        paymentTermId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
        >
      >
    > = ({ signal }) =>
      listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet(
        paymentTermId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!paymentTermId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
      >
    >
  >;
export type ListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGetQueryError =
  HTTPValidationError;

export function useListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet<
  TData = Awaited<
    ReturnType<
      typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet<
  TData = Awaited<
    ReturnType<
      typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet<
  TData = Awaited<
    ReturnType<
      typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Payment Term Lines
 */

export function useListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet<
  TData = Awaited<
    ReturnType<
      typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentTermId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesGetQueryOptions(
      paymentTermId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Atomically replace a term's installment schedule (staged-payment lines).

An empty `lines` array clears the schedule — the term reverts to a single
due date. Proportion-based lines must sum to 1.0. Returns the updated term
with its lines embedded.
 * @summary Replace Payment Term Lines
 */
export const replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut =
  (paymentTermId: string, paymentTermLinesReplace: PaymentTermLinesReplace) => {
    return customInstance<PaymentTermResponse>({
      url: `/api/v1/accounting/payment-terms/${paymentTermId}/lines`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: paymentTermLinesReplace
    });
  };

export const getReplacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut
        >
      >,
      TError,
      { paymentTermId: string; data: PaymentTermLinesReplace },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut
      >
    >,
    TError,
    { paymentTermId: string; data: PaymentTermLinesReplace },
    TContext
  > => {
    const mutationKey = [
      'replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut
        >
      >,
      { paymentTermId: string; data: PaymentTermLinesReplace }
    > = (props) => {
      const { paymentTermId, data } = props ?? {};

      return replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut(
        paymentTermId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReplacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut
      >
    >
  >;
export type ReplacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPutMutationBody =
  PaymentTermLinesReplace;
export type ReplacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPutMutationError =
  HTTPValidationError;

/**
 * @summary Replace Payment Term Lines
 */
export const useReplacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut
          >
        >,
        TError,
        { paymentTermId: string; data: PaymentTermLinesReplace },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof replacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPut
      >
    >,
    TError,
    { paymentTermId: string; data: PaymentTermLinesReplace },
    TContext
  > => {
    const mutationOptions =
      getReplacePaymentTermLinesApiV1AccountingPaymentTermsPaymentTermIdLinesPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Invoices
 */
export const listInvoicesApiV1AccountingInvoicesGet = (
  params?: ListInvoicesApiV1AccountingInvoicesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InvoiceListResponse>({
    url: `/api/v1/accounting/invoices`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInvoicesApiV1AccountingInvoicesGetQueryKey = (
  params?: ListInvoicesApiV1AccountingInvoicesGetParams
) => {
  return [`/api/v1/accounting/invoices`, ...(params ? [params] : [])] as const;
};

export const getListInvoicesApiV1AccountingInvoicesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
  TError = HTTPValidationError
>(
  params?: ListInvoicesApiV1AccountingInvoicesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListInvoicesApiV1AccountingInvoicesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>
  > = ({ signal }) => listInvoicesApiV1AccountingInvoicesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListInvoicesApiV1AccountingInvoicesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>
>;
export type ListInvoicesApiV1AccountingInvoicesGetQueryError =
  HTTPValidationError;

export function useListInvoicesApiV1AccountingInvoicesGet<
  TData = Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListInvoicesApiV1AccountingInvoicesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
          TError,
          Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInvoicesApiV1AccountingInvoicesGet<
  TData = Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
  TError = HTTPValidationError
>(
  params?: ListInvoicesApiV1AccountingInvoicesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
          TError,
          Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInvoicesApiV1AccountingInvoicesGet<
  TData = Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
  TError = HTTPValidationError
>(
  params?: ListInvoicesApiV1AccountingInvoicesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Invoices
 */

export function useListInvoicesApiV1AccountingInvoicesGet<
  TData = Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
  TError = HTTPValidationError
>(
  params?: ListInvoicesApiV1AccountingInvoicesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvoicesApiV1AccountingInvoicesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListInvoicesApiV1AccountingInvoicesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Invoice
 */
export const createInvoiceApiV1AccountingInvoicesPost = (
  invoiceCreateRequest: InvoiceCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: invoiceCreateRequest,
    signal
  });
};

export const getCreateInvoiceApiV1AccountingInvoicesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvoiceApiV1AccountingInvoicesPost>>,
    TError,
    { data: InvoiceCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvoiceApiV1AccountingInvoicesPost>>,
  TError,
  { data: InvoiceCreateRequest },
  TContext
> => {
  const mutationKey = ['createInvoiceApiV1AccountingInvoicesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvoiceApiV1AccountingInvoicesPost>>,
    { data: InvoiceCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createInvoiceApiV1AccountingInvoicesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvoiceApiV1AccountingInvoicesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createInvoiceApiV1AccountingInvoicesPost>>
  >;
export type CreateInvoiceApiV1AccountingInvoicesPostMutationBody =
  InvoiceCreateRequest;
export type CreateInvoiceApiV1AccountingInvoicesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Invoice
 */
export const useCreateInvoiceApiV1AccountingInvoicesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInvoiceApiV1AccountingInvoicesPost>>,
      TError,
      { data: InvoiceCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createInvoiceApiV1AccountingInvoicesPost>>,
  TError,
  { data: InvoiceCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateInvoiceApiV1AccountingInvoicesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Aggregate figures over the **whole filtered invoice set**, never one page.

ui-list-pages.md §11 (aggregates on a server-paged list): this endpoint takes
the identical filter query params as ``GET /invoices`` minus `offset`/`limit`,
and resolves them through the same service query builder, so the figures above
the table can never honour a different filter set than the rows in it.

Grouped by `currency_code` — invoices carry their own currency and
`total_in_base` is nullable, so one cross-currency SUM would be meaningless
and silently short.
 * @summary Get Invoice Aggregates
 */
export const getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet = (
  params?: GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InvoiceAggregatesResponse>({
    url: `/api/v1/accounting/invoices/aggregates`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetQueryKey =
  (params?: GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams) => {
    return [
      `/api/v1/accounting/invoices/aggregates`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
        >
      >
    > = ({ signal }) =>
      getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
      >
    >
  >;
export type GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetQueryError =
  HTTPValidationError;

export function useGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Invoice Aggregates
 */

export function useGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoiceAggregatesApiV1AccountingInvoicesAggregatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInvoiceAggregatesApiV1AccountingInvoicesAggregatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Invoice
 */
export const getInvoiceApiV1AccountingInvoicesInvoiceIdGet = (
  invoiceId: string,
  signal?: AbortSignal
) => {
  return customInstance<InvoiceResponse>({
    url: `/api/v1/accounting/invoices/${invoiceId}`,
    method: 'GET',
    signal
  });
};

export const getGetInvoiceApiV1AccountingInvoicesInvoiceIdGetQueryKey = (
  invoiceId?: string
) => {
  return [`/api/v1/accounting/invoices/${invoiceId}`] as const;
};

export const getGetInvoiceApiV1AccountingInvoicesInvoiceIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvoiceApiV1AccountingInvoicesInvoiceIdGetQueryKey(invoiceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>>
  > = ({ signal }) =>
    getInvoiceApiV1AccountingInvoicesInvoiceIdGet(invoiceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!invoiceId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetInvoiceApiV1AccountingInvoicesInvoiceIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>>
  >;
export type GetInvoiceApiV1AccountingInvoicesInvoiceIdGetQueryError =
  HTTPValidationError;

export function useGetInvoiceApiV1AccountingInvoicesInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInvoiceApiV1AccountingInvoicesInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInvoiceApiV1AccountingInvoicesInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Invoice
 */

export function useGetInvoiceApiV1AccountingInvoicesInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoiceApiV1AccountingInvoicesInvoiceIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInvoiceApiV1AccountingInvoicesInvoiceIdGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Invoice
 */
export const updateInvoiceApiV1AccountingInvoicesInvoiceIdPut = (
  invoiceId: string,
  invoiceUpdateRequest: InvoiceUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: invoiceUpdateRequest
  });
};

export const getUpdateInvoiceApiV1AccountingInvoicesInvoiceIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateInvoiceApiV1AccountingInvoicesInvoiceIdPut>
      >,
      TError,
      { invoiceId: string; data: InvoiceUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateInvoiceApiV1AccountingInvoicesInvoiceIdPut>
    >,
    TError,
    { invoiceId: string; data: InvoiceUpdateRequest },
    TContext
  > => {
    const mutationKey = ['updateInvoiceApiV1AccountingInvoicesInvoiceIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateInvoiceApiV1AccountingInvoicesInvoiceIdPut>
      >,
      { invoiceId: string; data: InvoiceUpdateRequest }
    > = (props) => {
      const { invoiceId, data } = props ?? {};

      return updateInvoiceApiV1AccountingInvoicesInvoiceIdPut(invoiceId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateInvoiceApiV1AccountingInvoicesInvoiceIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateInvoiceApiV1AccountingInvoicesInvoiceIdPut>>
  >;
export type UpdateInvoiceApiV1AccountingInvoicesInvoiceIdPutMutationBody =
  InvoiceUpdateRequest;
export type UpdateInvoiceApiV1AccountingInvoicesInvoiceIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Invoice
 */
export const useUpdateInvoiceApiV1AccountingInvoicesInvoiceIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateInvoiceApiV1AccountingInvoicesInvoiceIdPut>
      >,
      TError,
      { invoiceId: string; data: InvoiceUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateInvoiceApiV1AccountingInvoicesInvoiceIdPut>>,
  TError,
  { invoiceId: string; data: InvoiceUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateInvoiceApiV1AccountingInvoicesInvoiceIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Invoice
 */
export const deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete = (
  invoiceId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}`,
    method: 'DELETE'
  });
};

export const getDeleteInvoiceApiV1AccountingInvoicesInvoiceIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete>
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationKey = ['deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete>
      >,
      { invoiceId: string }
    > = (props) => {
      const { invoiceId } = props ?? {};

      return deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete(invoiceId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteInvoiceApiV1AccountingInvoicesInvoiceIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete>
    >
  >;

export type DeleteInvoiceApiV1AccountingInvoicesInvoiceIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Invoice
 */
export const useDeleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteInvoiceApiV1AccountingInvoicesInvoiceIdDelete>
  >,
  TError,
  { invoiceId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteInvoiceApiV1AccountingInvoicesInvoiceIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * One page of payments applied to this invoice (newest first) for the
detail-page history section, plus the total. Each row carries
``allocated_amount`` — the slice applied to THIS invoice — since one receipt
can split across several invoices. The history accumulates a row per
collection (an installment plan can run to dozens), so it is server-paged
like every other Shape A surface. Same visibility gate as ``get_invoice``: a
non-accessible invoice 404s (hide existence).
 * @summary List Invoice Payments
 */
export const listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet = (
  invoiceId: string,
  params?: ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/payments`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetQueryKey =
  (
    invoiceId?: string,
    params?: ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams
  ) => {
    return [
      `/api/v1/accounting/invoices/${invoiceId}/payments`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    params?: ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetQueryKey(
        invoiceId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
        >
      >
    > = ({ signal }) =>
      listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet(
        invoiceId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
      >
    >
  >;
export type ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetQueryError =
  HTTPValidationError;

export function useListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params:
    | undefined
    | ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Invoice Payments
 */

export function useListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: ListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInvoicePaymentsApiV1AccountingInvoicesInvoiceIdPaymentsGetQueryOptions(
      invoiceId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The freight shipment(s) this AR invoice bills, both storage arms unioned.

NEAR side: the same VIEWER/404 gate as ``get_invoice`` — a non-accessible
invoice hides its existence. FAR side: the shipment projection comes from
``ShipmentCostService.list_shipments_for_invoice``, which resolves it through
``ShipmentService.summaries_by_id(for_reader=...)`` — shipments the caller
may not open come back REDACTED (present, null reference/status) rather than
dropped, which is that seam's recorded decision so "you may not see it" stays
distinguishable from "nothing is linked".
 * @summary List Invoice Shipments
 */
export const listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet =
  (invoiceId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/invoices/${invoiceId}/shipments`,
      method: 'GET',
      signal
    });
  };

export const getListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGetQueryKey =
  (invoiceId?: string) => {
    return [`/api/v1/accounting/invoices/${invoiceId}/shipments`] as const;
  };

export const getListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGetQueryKey(
        invoiceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
        >
      >
    > = ({ signal }) =>
      listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet(
        invoiceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
      >
    >
  >;
export type ListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGetQueryError =
  HTTPValidationError;

export function useListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Invoice Shipments
 */

export function useListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInvoiceShipmentsApiV1AccountingInvoicesInvoiceIdShipmentsGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set or clear the SINGLE-shipment arm of this invoice's freight link — the
sell-side mirror of ``PATCH /bills/{id}/shipment-link``. Separate from
``PUT /invoices/{id}`` so it works on a sent invoice (a coordinator routinely
attaches an issued invoice to its freight job).

Two-sided gate, per §5 of the relationship contract: EDITOR on the invoice
(the near side) plus VIEWER on the shipment the BODY names, checked through
shipments' own ``enforce_shipment_link_access`` so a caller who cannot see
the file gets the same "Shipment not found" a nonexistent id produces — the
check is not an existence oracle. Clearing (``freight_shipment_id=null``)
names no shipment, so there is no far side to check; the contract is explicit
that removal takes EDITOR on the near side alone, or revoking a share would
strand the link with nobody able to release it.
 * @summary Link Invoice Shipment
 */
export const linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch =
  (
    invoiceId: string,
    invoiceShipmentLinkRequest: InvoiceShipmentLinkRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/invoices/${invoiceId}/shipment-link`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: invoiceShipmentLinkRequest
    });
  };

export const getLinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch
        >
      >,
      TError,
      { invoiceId: string; data: InvoiceShipmentLinkRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch
      >
    >,
    TError,
    { invoiceId: string; data: InvoiceShipmentLinkRequest },
    TContext
  > => {
    const mutationKey = [
      'linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch
        >
      >,
      { invoiceId: string; data: InvoiceShipmentLinkRequest }
    > = (props) => {
      const { invoiceId, data } = props ?? {};

      return linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch(
        invoiceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch
      >
    >
  >;
export type LinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatchMutationBody =
  InvoiceShipmentLinkRequest;
export type LinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatchMutationError =
  HTTPValidationError;

/**
 * @summary Link Invoice Shipment
 */
export const useLinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch
          >
        >,
        TError,
        { invoiceId: string; data: InvoiceShipmentLinkRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof linkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatch
      >
    >,
    TError,
    { invoiceId: string; data: InvoiceShipmentLinkRequest },
    TContext
  > => {
    const mutationOptions =
      getLinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentLinkPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Release one shipment from this invoice, whichever arm binds them — the
invoice-side half of "found, CHANGED and removed from every participant".

EDITOR on the INVOICE only. §5: removal requires editor on the near side and
deliberately NOT viewer on the far side, because a shipment unshared after
the link was made would otherwise be undetachable by the invoice's own
owner. Removal reveals nothing — the caller already knows the pair exists.
Idempotent: an unlinked pair returns zeroes rather than 404ing.
 * @summary Unlink Invoice Shipment
 */
export const unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete =
  (invoiceId: string, shipmentId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/invoices/${invoiceId}/shipments/${shipmentId}`,
      method: 'DELETE'
    });
  };

export const getUnlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete
        >
      >,
      TError,
      { invoiceId: string; shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete
      >
    >,
    TError,
    { invoiceId: string; shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete
        >
      >,
      { invoiceId: string; shipmentId: string }
    > = (props) => {
      const { invoiceId, shipmentId } = props ?? {};

      return unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete(
        invoiceId,
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete
      >
    >
  >;

export type UnlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Invoice Shipment
 */
export const useUnlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete
          >
        >,
        TError,
        { invoiceId: string; shipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDelete
      >
    >,
    TError,
    { invoiceId: string; shipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkInvoiceShipmentApiV1AccountingInvoicesInvoiceIdShipmentsShipmentIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Send Invoice
 */
export const sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost = (
  invoiceId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/send`,
    method: 'POST',
    signal
  });
};

export const getSendInvoiceApiV1AccountingInvoicesInvoiceIdSendPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost>
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationKey = ['sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost>
      >,
      { invoiceId: string }
    > = (props) => {
      const { invoiceId } = props ?? {};

      return sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost(invoiceId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type SendInvoiceApiV1AccountingInvoicesInvoiceIdSendPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost>
    >
  >;

export type SendInvoiceApiV1AccountingInvoicesInvoiceIdSendPostMutationError =
  HTTPValidationError;

/**
 * @summary Send Invoice
 */
export const useSendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof sendInvoiceApiV1AccountingInvoicesInvoiceIdSendPost>
  >,
  TError,
  { invoiceId: string },
  TContext
> => {
  const mutationOptions =
    getSendInvoiceApiV1AccountingInvoicesInvoiceIdSendPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Void Invoice
 */
export const voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost = (
  invoiceId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/void`,
    method: 'POST',
    signal
  });
};

export const getVoidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost>
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationKey = ['voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost>
      >,
      { invoiceId: string }
    > = (props) => {
      const { invoiceId } = props ?? {};

      return voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost(invoiceId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type VoidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost>
    >
  >;

export type VoidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPostMutationError =
  HTTPValidationError;

/**
 * @summary Void Invoice
 */
export const useVoidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof voidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPost>
  >,
  TError,
  { invoiceId: string },
  TContext
> => {
  const mutationOptions =
    getVoidInvoiceApiV1AccountingInvoicesInvoiceIdVoidPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Send many draft invoices at once (flip to sent + post each JE).

Permission is all-or-nothing: the caller must hold EDITOR on every referenced
invoice (no-op in ``everyone`` mode). Business-state failures (not a draft, no
lines, JE failure) skip that invoice only — each is applied in its own
savepoint — and are reported per id.

Page-scoped by construction (``BulkIdsRequest``): see that model's docstring
for the audited per-item-work verdict behind the refusal.
 * @summary Bulk Send Invoices
 */
export const bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost = (
  bulkInvoiceActionRequest: BulkInvoiceActionRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/bulk-send`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkInvoiceActionRequest,
    signal
  });
};

export const getBulkSendInvoicesApiV1AccountingInvoicesBulkSendPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost>
      >,
      TError,
      { data: BulkInvoiceActionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost>
    >,
    TError,
    { data: BulkInvoiceActionRequest },
    TContext
  > => {
    const mutationKey = ['bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost>
      >,
      { data: BulkInvoiceActionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkSendInvoicesApiV1AccountingInvoicesBulkSendPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost>
    >
  >;
export type BulkSendInvoicesApiV1AccountingInvoicesBulkSendPostMutationBody =
  BulkInvoiceActionRequest;
export type BulkSendInvoicesApiV1AccountingInvoicesBulkSendPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Send Invoices
 */
export const useBulkSendInvoicesApiV1AccountingInvoicesBulkSendPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost>
      >,
      TError,
      { data: BulkInvoiceActionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkSendInvoicesApiV1AccountingInvoicesBulkSendPost>
  >,
  TError,
  { data: BulkInvoiceActionRequest },
  TContext
> => {
  const mutationOptions =
    getBulkSendInvoicesApiV1AccountingInvoicesBulkSendPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Void many invoices at once (post each reversing JE + guards).

Permission is all-or-nothing (EDITOR on every id; no-op in ``everyone`` mode).
Business-state failures (already voided, has applied payments) skip that
invoice only — each in its own savepoint — and are reported per id.

Page-scoped by construction (``BulkIdsRequest``): see that model's docstring
for the audited per-item-work verdict behind the refusal.
 * @summary Bulk Void Invoices
 */
export const bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost = (
  bulkInvoiceActionRequest: BulkInvoiceActionRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/bulk-void`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkInvoiceActionRequest,
    signal
  });
};

export const getBulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost>
      >,
      TError,
      { data: BulkInvoiceActionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost>
    >,
    TError,
    { data: BulkInvoiceActionRequest },
    TContext
  > => {
    const mutationKey = ['bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost>
      >,
      { data: BulkInvoiceActionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost>
    >
  >;
export type BulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPostMutationBody =
  BulkInvoiceActionRequest;
export type BulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Void Invoices
 */
export const useBulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost>
      >,
      TError,
      { data: BulkInvoiceActionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPost>
  >,
  TError,
  { data: BulkInvoiceActionRequest },
  TContext
> => {
  const mutationOptions =
    getBulkVoidInvoicesApiV1AccountingInvoicesBulkVoidPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deferred-revenue recognition schedule rows for an invoice (feature gap [33]).
 * @summary Invoice Revenue Recognition Schedule
 */
export const invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet =
  (invoiceId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/invoices/${invoiceId}/revenue-recognition-schedule`,
      method: 'GET',
      signal
    });
  };

export const getInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGetQueryKey =
  (invoiceId?: string) => {
    return [
      `/api/v1/accounting/invoices/${invoiceId}/revenue-recognition-schedule`
    ] as const;
  };

export const getInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
      >
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGetQueryKey(
        invoiceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
        >
      >
    > = ({ signal }) =>
      invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet(
        invoiceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type InvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
      >
    >
  >;
export type InvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGetQueryError =
  HTTPValidationError;

export function useInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Invoice Revenue Recognition Schedule
 */

export function useInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getInvoiceRevenueRecognitionScheduleApiV1AccountingInvoicesInvoiceIdRevenueRecognitionScheduleGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deferred-revenue liability roll-forward per month (opening + deferred - recognized = closing).
 * @summary Deferred Revenue Rollforward Report
 */
export const deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet =
  (
    params: DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/deferred-revenue-rollforward`,
      method: 'GET',
      params,
      signal
    });
  };

export const getDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetQueryKey =
  (
    params?: DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/deferred-revenue-rollforward`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
        >
      >
    > = ({ signal }) =>
      deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
      >
    >
  >;
export type DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetQueryError =
  HTTPValidationError;

export function useDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet<
  TData = Awaited<
    ReturnType<
      typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet<
  TData = Awaited<
    ReturnType<
      typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet<
  TData = Awaited<
    ReturnType<
      typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Deferred Revenue Rollforward Report
 */

export function useDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet<
  TData = Awaited<
    ReturnType<
      typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
    >
  >,
  TError = HTTPValidationError
>(
  params: DeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof deferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDeferredRevenueRollforwardReportApiV1AccountingReportsDeferredRevenueRollforwardGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Write Off Invoice
 */
export const writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost = (
  invoiceId: string,
  writeOffRequest: WriteOffRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/write-off`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: writeOffRequest,
    signal
  });
};

export const getWriteOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost
        >
      >,
      TError,
      { invoiceId: string; data: WriteOffRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost
      >
    >,
    TError,
    { invoiceId: string; data: WriteOffRequest },
    TContext
  > => {
    const mutationKey = [
      'writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost
        >
      >,
      { invoiceId: string; data: WriteOffRequest }
    > = (props) => {
      const { invoiceId, data } = props ?? {};

      return writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost(
        invoiceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type WriteOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost
      >
    >
  >;
export type WriteOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPostMutationBody =
  WriteOffRequest;
export type WriteOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPostMutationError =
  HTTPValidationError;

/**
 * @summary Write Off Invoice
 */
export const useWriteOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost
        >
      >,
      TError,
      { invoiceId: string; data: WriteOffRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof writeOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPost
    >
  >,
  TError,
  { invoiceId: string; data: WriteOffRequest },
  TContext
> => {
  const mutationOptions =
    getWriteOffInvoiceApiV1AccountingInvoicesInvoiceIdWriteOffPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create Credit Note
 */
export const createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost = (
  invoiceId: string,
  createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody: CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/credit-note`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody,
    signal
  });
};

export const getCreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost
        >
      >,
      TError,
      {
        invoiceId: string;
        data: CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost
      >
    >,
    TError,
    {
      invoiceId: string;
      data: CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost
        >
      >,
      {
        invoiceId: string;
        data: CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody;
      }
    > = (props) => {
      const { invoiceId, data } = props ?? {};

      return createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost(
        invoiceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost
      >
    >
  >;
export type CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostMutationBody =
  CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody;
export type CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostMutationError =
  HTTPValidationError;

/**
 * @summary Create Credit Note
 */
export const useCreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost
          >
        >,
        TError,
        {
          invoiceId: string;
          data: CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePost
      >
    >,
    TError,
    {
      invoiceId: string;
      data: CreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getCreateCreditNoteApiV1AccountingInvoicesInvoiceIdCreditNotePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Clone Invoice
 */
export const cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost = (
  invoiceId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/clone`,
    method: 'POST',
    signal
  });
};

export const getCloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost>
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationKey = [
      'cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost>
      >,
      { invoiceId: string }
    > = (props) => {
      const { invoiceId } = props ?? {};

      return cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost(invoiceId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost>
    >
  >;

export type CloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePostMutationError =
  HTTPValidationError;

/**
 * @summary Clone Invoice
 */
export const useCloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost>
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof cloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePost>
  >,
  TError,
  { invoiceId: string },
  TContext
> => {
  const mutationOptions =
    getCloneInvoiceApiV1AccountingInvoicesInvoiceIdClonePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List Bills
 */
export const listBillsApiV1AccountingBillsGet = (
  params?: ListBillsApiV1AccountingBillsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<BillListResponse>({
    url: `/api/v1/accounting/bills`,
    method: 'GET',
    params,
    signal
  });
};

export const getListBillsApiV1AccountingBillsGetQueryKey = (
  params?: ListBillsApiV1AccountingBillsGetParams
) => {
  return [`/api/v1/accounting/bills`, ...(params ? [params] : [])] as const;
};

export const getListBillsApiV1AccountingBillsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1AccountingBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListBillsApiV1AccountingBillsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>
  > = ({ signal }) => listBillsApiV1AccountingBillsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListBillsApiV1AccountingBillsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>
>;
export type ListBillsApiV1AccountingBillsGetQueryError = HTTPValidationError;

export function useListBillsApiV1AccountingBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListBillsApiV1AccountingBillsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
          TError,
          Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBillsApiV1AccountingBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1AccountingBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
          TError,
          Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBillsApiV1AccountingBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1AccountingBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Bills
 */

export function useListBillsApiV1AccountingBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1AccountingBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1AccountingBillsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListBillsApiV1AccountingBillsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Bill
 */
export const createBillApiV1AccountingBillsPost = (
  billCreateRequest: BillCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: billCreateRequest,
    signal
  });
};

export const getCreateBillApiV1AccountingBillsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillApiV1AccountingBillsPost>>,
    TError,
    { data: BillCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillApiV1AccountingBillsPost>>,
  TError,
  { data: BillCreateRequest },
  TContext
> => {
  const mutationKey = ['createBillApiV1AccountingBillsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillApiV1AccountingBillsPost>>,
    { data: BillCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createBillApiV1AccountingBillsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillApiV1AccountingBillsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillApiV1AccountingBillsPost>>
>;
export type CreateBillApiV1AccountingBillsPostMutationBody = BillCreateRequest;
export type CreateBillApiV1AccountingBillsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Bill
 */
export const useCreateBillApiV1AccountingBillsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBillApiV1AccountingBillsPost>>,
      TError,
      { data: BillCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBillApiV1AccountingBillsPost>>,
  TError,
  { data: BillCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateBillApiV1AccountingBillsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Return vendor candidates used by at least one bill in the list's base scope.
 * @summary Get Bill Filter Facets
 */
export const getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet = (
  params?: GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<BillFilterFacets>({
    url: `/api/v1/accounting/bills/filter-facets`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetQueryKey =
  (params?: GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams) => {
    return [
      `/api/v1/accounting/bills/filter-facets`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
        >
      >
    > = ({ signal }) =>
      getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet>
    >
  >;
export type GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetQueryError =
  HTTPValidationError;

export function useGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bill Filter Facets
 */

export function useGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillFilterFacetsApiV1AccountingBillsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBillFilterFacetsApiV1AccountingBillsFilterFacetsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Bill
 */
export const getBillApiV1AccountingBillsBillIdGet = (
  billId: string,
  signal?: AbortSignal
) => {
  return customInstance<BillResponse>({
    url: `/api/v1/accounting/bills/${billId}`,
    method: 'GET',
    signal
  });
};

export const getGetBillApiV1AccountingBillsBillIdGetQueryKey = (
  billId?: string
) => {
  return [`/api/v1/accounting/bills/${billId}`] as const;
};

export const getGetBillApiV1AccountingBillsBillIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBillApiV1AccountingBillsBillIdGetQueryKey(billId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>
  > = ({ signal }) => getBillApiV1AccountingBillsBillIdGet(billId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!billId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBillApiV1AccountingBillsBillIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>
>;
export type GetBillApiV1AccountingBillsBillIdGetQueryError =
  HTTPValidationError;

export function useGetBillApiV1AccountingBillsBillIdGet<
  TData = Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
  TError = HTTPValidationError
>(
  billId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBillApiV1AccountingBillsBillIdGet<
  TData = Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBillApiV1AccountingBillsBillIdGet<
  TData = Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bill
 */

export function useGetBillApiV1AccountingBillsBillIdGet<
  TData = Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillApiV1AccountingBillsBillIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetBillApiV1AccountingBillsBillIdGetQueryOptions(
    billId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Bill
 */
export const updateBillApiV1AccountingBillsBillIdPut = (
  billId: string,
  billUpdateRequest: BillUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: billUpdateRequest
  });
};

export const getUpdateBillApiV1AccountingBillsBillIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBillApiV1AccountingBillsBillIdPut>>,
    TError,
    { billId: string; data: BillUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBillApiV1AccountingBillsBillIdPut>>,
  TError,
  { billId: string; data: BillUpdateRequest },
  TContext
> => {
  const mutationKey = ['updateBillApiV1AccountingBillsBillIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBillApiV1AccountingBillsBillIdPut>>,
    { billId: string; data: BillUpdateRequest }
  > = (props) => {
    const { billId, data } = props ?? {};

    return updateBillApiV1AccountingBillsBillIdPut(billId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBillApiV1AccountingBillsBillIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBillApiV1AccountingBillsBillIdPut>>
>;
export type UpdateBillApiV1AccountingBillsBillIdPutMutationBody =
  BillUpdateRequest;
export type UpdateBillApiV1AccountingBillsBillIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Bill
 */
export const useUpdateBillApiV1AccountingBillsBillIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBillApiV1AccountingBillsBillIdPut>>,
      TError,
      { billId: string; data: BillUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateBillApiV1AccountingBillsBillIdPut>>,
  TError,
  { billId: string; data: BillUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateBillApiV1AccountingBillsBillIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Bill
 */
export const deleteBillApiV1AccountingBillsBillIdDelete = (billId: string) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}`,
    method: 'DELETE'
  });
};

export const getDeleteBillApiV1AccountingBillsBillIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBillApiV1AccountingBillsBillIdDelete>>,
    TError,
    { billId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBillApiV1AccountingBillsBillIdDelete>>,
  TError,
  { billId: string },
  TContext
> => {
  const mutationKey = ['deleteBillApiV1AccountingBillsBillIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBillApiV1AccountingBillsBillIdDelete>>,
    { billId: string }
  > = (props) => {
    const { billId } = props ?? {};

    return deleteBillApiV1AccountingBillsBillIdDelete(billId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBillApiV1AccountingBillsBillIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteBillApiV1AccountingBillsBillIdDelete>>
  >;

export type DeleteBillApiV1AccountingBillsBillIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Bill
 */
export const useDeleteBillApiV1AccountingBillsBillIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBillApiV1AccountingBillsBillIdDelete>>,
      TError,
      { billId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBillApiV1AccountingBillsBillIdDelete>>,
  TError,
  { billId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteBillApiV1AccountingBillsBillIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * One page of payments applied to this bill (newest first) for the
detail-page history section, plus the total — the AP mirror of
``list_invoice_payments``. Each row carries
``allocated_amount`` (the slice applied to THIS bill, since one vendor payment
can settle several) and, when the payment came out of a payment run, the
``payment_run_id`` / ``payment_run_number`` back-link to that run. Run numbers
are resolved in ONE batched read for the page. Same visibility gate as
``get_bill``: a non-accessible bill 404s (hide existence).
 * @summary List Bill Payments
 */
export const listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet = (
  billId: string,
  params?: ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}/payments`,
    method: 'GET',
    params,
    signal
  });
};

export const getListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetQueryKey =
  (
    billId?: string,
    params?: ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams
  ) => {
    return [
      `/api/v1/accounting/bills/${billId}/payments`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
    >,
    TError = HTTPValidationError
  >(
    billId: string,
    params?: ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetQueryKey(
        billId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
      >
    > = ({ signal }) =>
      listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet(
        billId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!billId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
    >
  >;
export type ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetQueryError =
  HTTPValidationError;

export function useListBillPaymentsApiV1AccountingBillsBillIdPaymentsGet<
  TData = Awaited<
    ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
  >,
  TError = HTTPValidationError
>(
  billId: string,
  params:
    | undefined
    | ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBillPaymentsApiV1AccountingBillsBillIdPaymentsGet<
  TData = Awaited<
    ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
  >,
  TError = HTTPValidationError
>(
  billId: string,
  params?: ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBillPaymentsApiV1AccountingBillsBillIdPaymentsGet<
  TData = Awaited<
    ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
  >,
  TError = HTTPValidationError
>(
  billId: string,
  params?: ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Bill Payments
 */

export function useListBillPaymentsApiV1AccountingBillsBillIdPaymentsGet<
  TData = Awaited<
    ReturnType<typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet>
  >,
  TError = HTTPValidationError
>(
  billId: string,
  params?: ListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBillPaymentsApiV1AccountingBillsBillIdPaymentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListBillPaymentsApiV1AccountingBillsBillIdPaymentsGetQueryOptions(
      billId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * PO / receipts / bill comparison for THIS bill, for the AP reviewer (F-07).

The variance was only visible on the goods receipt and, on the bill, only
after an approval attempt bounced with ``BILL_THREE_WAY_MATCH_HOLD``. This
read surfaces it on the bill *before* approval, reading the existing
procurement three-way-match report plus the approval gate's own findings —
see ``BillService.three_way_match_report``.

Same visibility gate as ``get_bill``: a non-accessible bill 404s. The AP
clerk needs no procurement access — the bill she may read is the grant.
 * @summary Get Bill Three Way Match
 */
export const getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet = (
  billId: string,
  signal?: AbortSignal
) => {
  return customInstance<BillThreeWayMatchResponse>({
    url: `/api/v1/accounting/bills/${billId}/three-way-match`,
    method: 'GET',
    signal
  });
};

export const getGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGetQueryKey =
  (billId?: string) => {
    return [`/api/v1/accounting/bills/${billId}/three-way-match`] as const;
  };

export const getGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
      >
    >,
    TError = HTTPValidationError
  >(
    billId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGetQueryKey(
        billId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
        >
      >
    > = ({ signal }) =>
      getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet(
        billId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!billId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
      >
    >
  >;
export type GetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGetQueryError =
  HTTPValidationError;

export function useGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet<
  TData = Awaited<
    ReturnType<
      typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet<
  TData = Awaited<
    ReturnType<
      typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet<
  TData = Awaited<
    ReturnType<
      typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bill Three Way Match
 */

export function useGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet<
  TData = Awaited<
    ReturnType<
      typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBillThreeWayMatchApiV1AccountingBillsBillIdThreeWayMatchGetQueryOptions(
      billId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * P2P-1: confirmed goods receipts for a vendor not yet on any bill — the
source list for the vendor→unbilled-receipts picker in Create Bill.
 * @summary List Unbilled Receipts
 */
export const listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet = (
  params: ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/unbilled-receipts`,
    method: 'GET',
    params,
    signal
  });
};

export const getListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetQueryKey =
  (params?: ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams) => {
    return [
      `/api/v1/accounting/unbilled-receipts`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet>
    >,
    TError = HTTPValidationError
  >(
    params: ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
        >
      >
    > = ({ signal }) =>
      listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet>
    >
  >;
export type ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetQueryError =
  HTTPValidationError;

export function useListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet<
  TData = Awaited<
    ReturnType<typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet>
  >,
  TError = HTTPValidationError
>(
  params: ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet<
  TData = Awaited<
    ReturnType<typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet>
  >,
  TError = HTTPValidationError
>(
  params: ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet<
  TData = Awaited<
    ReturnType<typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet>
  >,
  TError = HTTPValidationError
>(
  params: ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Unbilled Receipts
 */

export function useListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet<
  TData = Awaited<
    ReturnType<typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet>
  >,
  TError = HTTPValidationError
>(
  params: ListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnbilledReceiptsApiV1AccountingUnbilledReceiptsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUnbilledReceiptsApiV1AccountingUnbilledReceiptsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * P2P-1: build a draft AP bill from one confirmed goods receipt (the GR
"Create Bill" CTA). Idempotent — returns the existing bill if already built.
Lines, qty/price and 3-way-match linkage are pre-filled from the receipt.
 * @summary Create Bill From Receipt
 */
export const createBillFromReceiptApiV1AccountingBillsFromReceiptPost = (
  billFromReceiptRequest: BillFromReceiptRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/from-receipt`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: billFromReceiptRequest,
    signal
  });
};

export const getCreateBillFromReceiptApiV1AccountingBillsFromReceiptPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createBillFromReceiptApiV1AccountingBillsFromReceiptPost
        >
      >,
      TError,
      { data: BillFromReceiptRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createBillFromReceiptApiV1AccountingBillsFromReceiptPost
      >
    >,
    TError,
    { data: BillFromReceiptRequest },
    TContext
  > => {
    const mutationKey = [
      'createBillFromReceiptApiV1AccountingBillsFromReceiptPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createBillFromReceiptApiV1AccountingBillsFromReceiptPost
        >
      >,
      { data: BillFromReceiptRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createBillFromReceiptApiV1AccountingBillsFromReceiptPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateBillFromReceiptApiV1AccountingBillsFromReceiptPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createBillFromReceiptApiV1AccountingBillsFromReceiptPost
      >
    >
  >;
export type CreateBillFromReceiptApiV1AccountingBillsFromReceiptPostMutationBody =
  BillFromReceiptRequest;
export type CreateBillFromReceiptApiV1AccountingBillsFromReceiptPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Bill From Receipt
 */
export const useCreateBillFromReceiptApiV1AccountingBillsFromReceiptPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createBillFromReceiptApiV1AccountingBillsFromReceiptPost
        >
      >,
      TError,
      { data: BillFromReceiptRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createBillFromReceiptApiV1AccountingBillsFromReceiptPost>
  >,
  TError,
  { data: BillFromReceiptRequest },
  TContext
> => {
  const mutationOptions =
    getCreateBillFromReceiptApiV1AccountingBillsFromReceiptPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * P2P-1: assemble one draft AP bill from several confirmed, unbilled
receipts for the same vendor (the invoice-in-hand picker).
 * @summary Create Bill From Receipts
 */
export const createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost = (
  billFromReceiptsRequest: BillFromReceiptsRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/from-receipts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: billFromReceiptsRequest,
    signal
  });
};

export const getCreateBillFromReceiptsApiV1AccountingBillsFromReceiptsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost
        >
      >,
      TError,
      { data: BillFromReceiptsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost
      >
    >,
    TError,
    { data: BillFromReceiptsRequest },
    TContext
  > => {
    const mutationKey = [
      'createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost
        >
      >,
      { data: BillFromReceiptsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateBillFromReceiptsApiV1AccountingBillsFromReceiptsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost
      >
    >
  >;
export type CreateBillFromReceiptsApiV1AccountingBillsFromReceiptsPostMutationBody =
  BillFromReceiptsRequest;
export type CreateBillFromReceiptsApiV1AccountingBillsFromReceiptsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Bill From Receipts
 */
export const useCreateBillFromReceiptsApiV1AccountingBillsFromReceiptsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost
        >
      >,
      TError,
      { data: BillFromReceiptsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createBillFromReceiptsApiV1AccountingBillsFromReceiptsPost
    >
  >,
  TError,
  { data: BillFromReceiptsRequest },
  TContext
> => {
  const mutationOptions =
    getCreateBillFromReceiptsApiV1AccountingBillsFromReceiptsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * T20B: list the tenant's landed-cost categories (FREIGHT, DUTY, …) for
the bill link picker. Ordered by sort_order then code.
 * @summary List Landed Cost Categories
 */
export const listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet = (
  params?: ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/landed-cost-categories`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetQueryKey =
  (
    params?: ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams
  ) => {
    return [
      `/api/v1/accounting/landed-cost-categories`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
        >
      >
    > = ({ signal }) =>
      listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
      >
    >
  >;
export type ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetQueryError =
  HTTPValidationError;

export function useListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Landed Cost Categories
 */

export function useListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLandedCostCategoriesApiV1AccountingLandedCostCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLandedCostCategoriesApiV1AccountingLandedCostCategoriesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * T20B: link/unlink a bill to an inbound freight shipment + landed-cost
category. Separate from PUT /bills/{id} so it works on approved/paid bills
(landed-cost bills are often linked after the bill is finalised).

Two-sided gate, per §5 of the relationship contract and like its rollup-arm
sibling ``link_bill_rollup_shipment`` and its sell-side mirror
``link_invoice_shipment``: EDITOR on the bill (the near side) plus VIEWER on
the shipment the BODY names, checked through shipments' own
``enforce_shipment_link_access`` so a caller who cannot see the file gets the
same "Shipment not found" a nonexistent id produces — the check is not an
existence oracle. The far-side half was MISSING (the rollup sibling's docstring
already claimed this route did it), so an accounting member with no relation to
a shipment could capitalize a bill's cost onto its inventory layers by naming
its id; landed-cost estimates E3 widened that to writing realised-bill links
onto its estimate lines. Unlinking (``freight_shipment_id=null``) names no
shipment, so there is no far side to check — removal takes EDITOR on the near
side alone, or revoking a share would strand the link with nobody able to
release it.
 * @summary Link Bill Shipment
 */
export const linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch = (
  billId: string,
  billShipmentLinkRequest: BillShipmentLinkRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}/shipment-link`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: billShipmentLinkRequest
  });
};

export const getLinkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch
        >
      >,
      TError,
      { billId: string; data: BillShipmentLinkRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch
      >
    >,
    TError,
    { billId: string; data: BillShipmentLinkRequest },
    TContext
  > => {
    const mutationKey = [
      'linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch
        >
      >,
      { billId: string; data: BillShipmentLinkRequest }
    > = (props) => {
      const { billId, data } = props ?? {};

      return linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch(
        billId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch
      >
    >
  >;
export type LinkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatchMutationBody =
  BillShipmentLinkRequest;
export type LinkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatchMutationError =
  HTTPValidationError;

/**
 * @summary Link Bill Shipment
 */
export const useLinkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch
        >
      >,
      TError,
      { billId: string; data: BillShipmentLinkRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof linkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatch
    >
  >,
  TError,
  { billId: string; data: BillShipmentLinkRequest },
  TContext
> => {
  const mutationOptions =
    getLinkBillShipmentApiV1AccountingBillsBillIdShipmentLinkPatchMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * GAP-1: set the per-line landed-cost category on a mixed-charge bill (one
forwarder invoice carrying ocean freight + duty + handling). Separate from
PUT /bills/{id} so it works on approved/paid bills — the same reasoning as
/shipment-link: this is categorisation metadata, not financial line data.
 * @summary Set Bill Line Landed Cost Categories
 */
export const setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch =
  (billId: string, billLineCategoriesRequest: BillLineCategoriesRequest) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/bills/${billId}/line-landed-cost-categories`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: billLineCategoriesRequest
    });
  };

export const getSetBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch
        >
      >,
      TError,
      { billId: string; data: BillLineCategoriesRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch
      >
    >,
    TError,
    { billId: string; data: BillLineCategoriesRequest },
    TContext
  > => {
    const mutationKey = [
      'setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch
        >
      >,
      { billId: string; data: BillLineCategoriesRequest }
    > = (props) => {
      const { billId, data } = props ?? {};

      return setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch(
        billId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch
      >
    >
  >;
export type SetBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatchMutationBody =
  BillLineCategoriesRequest;
export type SetBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatchMutationError =
  HTTPValidationError;

/**
 * @summary Set Bill Line Landed Cost Categories
 */
export const useSetBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch
          >
        >,
        TError,
        { billId: string; data: BillLineCategoriesRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatch
      >
    >,
    TError,
    { billId: string; data: BillLineCategoriesRequest },
    TContext
  > => {
    const mutationOptions =
      getSetBillLineLandedCostCategoriesApiV1AccountingBillsBillIdLineLandedCostCategoriesPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * ACC-J10: what the reclassify dialog needs before the user picks anything —
where each line's cost sits now, which lines can be corrected, and the date the
correction would post on.

Gated as the WRITE it precedes (member + EDITOR), not as a read: it exists only
to arm the correction, and offering the preview to someone the submit would
refuse is the "control the app put in front of the user" defect.
 * @summary Get Bill Reclassification Preview
 */
export const getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet =
  (billId: string, signal?: AbortSignal) => {
    return customInstance<BillReclassificationPreviewResponse>({
      url: `/api/v1/accounting/bills/${billId}/reclassification-preview`,
      method: 'GET',
      signal
    });
  };

export const getGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGetQueryKey =
  (billId?: string) => {
    return [
      `/api/v1/accounting/bills/${billId}/reclassification-preview`
    ] as const;
  };

export const getGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    billId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGetQueryKey(
        billId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
        >
      >
    > = ({ signal }) =>
      getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet(
        billId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!billId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
      >
    >
  >;
export type GetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGetQueryError =
  HTTPValidationError;

export function useGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bill Reclassification Preview
 */

export function useGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  billId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBillReclassificationPreviewApiV1AccountingBillsBillIdReclassificationPreviewGetQueryOptions(
      billId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ACC-J10: correct a posted bill's expense coding by POSTING a contra entry.

Separate from PUT /bills/{id} because it is not an edit: the bill's lines and
its recognition entry are left byte-for-byte alone (ERP P5) and the correction
is a new balanced journal entry cross-referenced to the bill. That is also why
it works on a PAID bill, unlike the date-correction window — a reclassification
touches neither AP nor cash.
 * @summary Reclassify Bill Expense Accounts
 */
export const reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost =
  (
    billId: string,
    billReclassifyRequest: BillReclassifyRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BillReclassificationResponse>({
      url: `/api/v1/accounting/bills/${billId}/reclassify-expense-accounts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: billReclassifyRequest,
      signal
    });
  };

export const getReclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost
        >
      >,
      TError,
      { billId: string; data: BillReclassifyRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost
      >
    >,
    TError,
    { billId: string; data: BillReclassifyRequest },
    TContext
  > => {
    const mutationKey = [
      'reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost
        >
      >,
      { billId: string; data: BillReclassifyRequest }
    > = (props) => {
      const { billId, data } = props ?? {};

      return reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost(
        billId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost
      >
    >
  >;
export type ReclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPostMutationBody =
  BillReclassifyRequest;
export type ReclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPostMutationError =
  HTTPValidationError;

/**
 * @summary Reclassify Bill Expense Accounts
 */
export const useReclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost
          >
        >,
        TError,
        { billId: string; data: BillReclassifyRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPost
      >
    >,
    TError,
    { billId: string; data: BillReclassifyRequest },
    TContext
  > => {
    const mutationOptions =
      getReclassifyBillExpenseAccountsApiV1AccountingBillsBillIdReclassifyExpenseAccountsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Shipments Phase 2: group/ungroup a bill under a transport shipment for the
per-vendor-role AP rollup. Separate from PUT /bills/{id} so it works on
approved/paid bills. Publishes accounting.bill.changed AFTER commit so the
shipments cost service recomputes landed_unit_cost for the affected
shipment(s) — including the one the bill moved away from on a re-link.

Two-sided gate, per §5 of the relationship contract and exactly as its
single-shipment sibling ``link_bill_shipment`` does it: EDITOR on the bill (the
near side) plus VIEWER on the shipment the BODY names, checked through
shipments' own ``enforce_shipment_link_access`` so a caller who cannot see the
file gets the same "Shipment not found" a nonexistent id produces — the check is
not an existence oracle and quotes nothing about the shipment. Ungrouping
(``shipment_id=null``) names no shipment, so there is no far side to check.
 * @summary Link Bill Rollup Shipment
 */
export const linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch =
  (
    billId: string,
    billRollupShipmentLinkRequest: BillRollupShipmentLinkRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/bills/${billId}/rollup-shipment-link`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: billRollupShipmentLinkRequest
    });
  };

export const getLinkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch
        >
      >,
      TError,
      { billId: string; data: BillRollupShipmentLinkRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch
      >
    >,
    TError,
    { billId: string; data: BillRollupShipmentLinkRequest },
    TContext
  > => {
    const mutationKey = [
      'linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch
        >
      >,
      { billId: string; data: BillRollupShipmentLinkRequest }
    > = (props) => {
      const { billId, data } = props ?? {};

      return linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch(
        billId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch
      >
    >
  >;
export type LinkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatchMutationBody =
  BillRollupShipmentLinkRequest;
export type LinkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatchMutationError =
  HTTPValidationError;

/**
 * @summary Link Bill Rollup Shipment
 */
export const useLinkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch
          >
        >,
        TError,
        { billId: string; data: BillRollupShipmentLinkRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof linkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatch
      >
    >,
    TError,
    { billId: string; data: BillRollupShipmentLinkRequest },
    TContext
  > => {
    const mutationOptions =
      getLinkBillRollupShipmentApiV1AccountingBillsBillIdRollupShipmentLinkPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Invoice-first AP (WI fc69e9b2): manually link a DRAFT bill to a purchase
order / goods receipt(s) for the unmatched case. Rebuilds the draft's lines
from the selected confirmed, unbilled receipts (stocked lines coded to GRNI
with 3-way-match linkage) so on approval the bill relieves GRNI instead of
double-booking the goods as expense. Draft-only — a posted bill's JE is
immutable (void + rebuild instead).
 * @summary Link Bill Purchase Order
 */
export const linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch = (
  billId: string,
  billLinkPoRequest: BillLinkPoRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}/po-link`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: billLinkPoRequest
  });
};

export const getLinkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch
        >
      >,
      TError,
      { billId: string; data: BillLinkPoRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch
      >
    >,
    TError,
    { billId: string; data: BillLinkPoRequest },
    TContext
  > => {
    const mutationKey = [
      'linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch
        >
      >,
      { billId: string; data: BillLinkPoRequest }
    > = (props) => {
      const { billId, data } = props ?? {};

      return linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch(
        billId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch
      >
    >
  >;
export type LinkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatchMutationBody =
  BillLinkPoRequest;
export type LinkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatchMutationError =
  HTTPValidationError;

/**
 * @summary Link Bill Purchase Order
 */
export const useLinkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch
        >
      >,
      TError,
      { billId: string; data: BillLinkPoRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof linkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatch
    >
  >,
  TError,
  { billId: string; data: BillLinkPoRequest },
  TContext
> => {
  const mutationOptions =
    getLinkBillPurchaseOrderApiV1AccountingBillsBillIdPoLinkPatchMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit Bill
 */
export const submitBillApiV1AccountingBillsBillIdSubmitPost = (
  billId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}/submit`,
    method: 'POST',
    signal
  });
};

export const getSubmitBillApiV1AccountingBillsBillIdSubmitPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof submitBillApiV1AccountingBillsBillIdSubmitPost>
      >,
      TError,
      { billId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof submitBillApiV1AccountingBillsBillIdSubmitPost>>,
    TError,
    { billId: string },
    TContext
  > => {
    const mutationKey = ['submitBillApiV1AccountingBillsBillIdSubmitPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof submitBillApiV1AccountingBillsBillIdSubmitPost>
      >,
      { billId: string }
    > = (props) => {
      const { billId } = props ?? {};

      return submitBillApiV1AccountingBillsBillIdSubmitPost(billId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type SubmitBillApiV1AccountingBillsBillIdSubmitPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof submitBillApiV1AccountingBillsBillIdSubmitPost>>
  >;

export type SubmitBillApiV1AccountingBillsBillIdSubmitPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit Bill
 */
export const useSubmitBillApiV1AccountingBillsBillIdSubmitPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof submitBillApiV1AccountingBillsBillIdSubmitPost>
      >,
      TError,
      { billId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitBillApiV1AccountingBillsBillIdSubmitPost>>,
  TError,
  { billId: string },
  TContext
> => {
  const mutationOptions =
    getSubmitBillApiV1AccountingBillsBillIdSubmitPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit many draft bills for approval at once (J8-01).

Permission is all-or-nothing: the caller must hold EDITOR on every referenced
bill (no-op in ``everyone`` mode). A bill that isn't a draft is skipped alone
— each is applied in its own savepoint — and reported per id.
 * @summary Bulk Submit Bills
 */
export const bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost = (
  bulkBillActionRequest: BulkBillActionRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/bulk-submit`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkBillActionRequest,
    signal
  });
};

export const getBulkSubmitBillsApiV1AccountingBillsBulkSubmitPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost>
      >,
      TError,
      { data: BulkBillActionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost>
    >,
    TError,
    { data: BulkBillActionRequest },
    TContext
  > => {
    const mutationKey = ['bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost>
      >,
      { data: BulkBillActionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkSubmitBillsApiV1AccountingBillsBulkSubmitPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost>
    >
  >;
export type BulkSubmitBillsApiV1AccountingBillsBulkSubmitPostMutationBody =
  BulkBillActionRequest;
export type BulkSubmitBillsApiV1AccountingBillsBulkSubmitPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Submit Bills
 */
export const useBulkSubmitBillsApiV1AccountingBillsBulkSubmitPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost>
      >,
      TError,
      { data: BulkBillActionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkSubmitBillsApiV1AccountingBillsBulkSubmitPost>>,
  TError,
  { data: BulkBillActionRequest },
  TContext
> => {
  const mutationOptions =
    getBulkSubmitBillsApiV1AccountingBillsBulkSubmitPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Approve many bills at once — flip each to ``due`` and post its JE (J8-01).

Permission is all-or-nothing (EDITOR on every id; no-op in ``everyone`` mode).
A bill held by the three-way match, missing a GL account mapping, or in the
wrong status is skipped alone with its reason; there is deliberately no
blanket accept-variance flag, since a match hold exists to make someone look
at that specific bill.
 * @summary Bulk Approve Bills
 */
export const bulkApproveBillsApiV1AccountingBillsBulkApprovePost = (
  bulkBillActionRequest: BulkBillActionRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/bulk-approve`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkBillActionRequest,
    signal
  });
};

export const getBulkApproveBillsApiV1AccountingBillsBulkApprovePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkApproveBillsApiV1AccountingBillsBulkApprovePost>
      >,
      TError,
      { data: BulkBillActionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkApproveBillsApiV1AccountingBillsBulkApprovePost>
    >,
    TError,
    { data: BulkBillActionRequest },
    TContext
  > => {
    const mutationKey = ['bulkApproveBillsApiV1AccountingBillsBulkApprovePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkApproveBillsApiV1AccountingBillsBulkApprovePost>
      >,
      { data: BulkBillActionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkApproveBillsApiV1AccountingBillsBulkApprovePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkApproveBillsApiV1AccountingBillsBulkApprovePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkApproveBillsApiV1AccountingBillsBulkApprovePost>
    >
  >;
export type BulkApproveBillsApiV1AccountingBillsBulkApprovePostMutationBody =
  BulkBillActionRequest;
export type BulkApproveBillsApiV1AccountingBillsBulkApprovePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Approve Bills
 */
export const useBulkApproveBillsApiV1AccountingBillsBulkApprovePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkApproveBillsApiV1AccountingBillsBulkApprovePost>
      >,
      TError,
      { data: BulkBillActionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkApproveBillsApiV1AccountingBillsBulkApprovePost>
  >,
  TError,
  { data: BulkBillActionRequest },
  TContext
> => {
  const mutationOptions =
    getBulkApproveBillsApiV1AccountingBillsBulkApprovePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Approve Bill
 */
export const approveBillApiV1AccountingBillsBillIdApprovePost = (
  billId: string,
  approveBillApiV1AccountingBillsBillIdApprovePostBody: ApproveBillApiV1AccountingBillsBillIdApprovePostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}/approve`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: approveBillApiV1AccountingBillsBillIdApprovePostBody,
    signal
  });
};

export const getApproveBillApiV1AccountingBillsBillIdApprovePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof approveBillApiV1AccountingBillsBillIdApprovePost>
      >,
      TError,
      {
        billId: string;
        data: ApproveBillApiV1AccountingBillsBillIdApprovePostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof approveBillApiV1AccountingBillsBillIdApprovePost>
    >,
    TError,
    {
      billId: string;
      data: ApproveBillApiV1AccountingBillsBillIdApprovePostBody;
    },
    TContext
  > => {
    const mutationKey = ['approveBillApiV1AccountingBillsBillIdApprovePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof approveBillApiV1AccountingBillsBillIdApprovePost>
      >,
      {
        billId: string;
        data: ApproveBillApiV1AccountingBillsBillIdApprovePostBody;
      }
    > = (props) => {
      const { billId, data } = props ?? {};

      return approveBillApiV1AccountingBillsBillIdApprovePost(billId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApproveBillApiV1AccountingBillsBillIdApprovePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof approveBillApiV1AccountingBillsBillIdApprovePost>>
  >;
export type ApproveBillApiV1AccountingBillsBillIdApprovePostMutationBody =
  ApproveBillApiV1AccountingBillsBillIdApprovePostBody;
export type ApproveBillApiV1AccountingBillsBillIdApprovePostMutationError =
  HTTPValidationError;

/**
 * @summary Approve Bill
 */
export const useApproveBillApiV1AccountingBillsBillIdApprovePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof approveBillApiV1AccountingBillsBillIdApprovePost>
      >,
      TError,
      {
        billId: string;
        data: ApproveBillApiV1AccountingBillsBillIdApprovePostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof approveBillApiV1AccountingBillsBillIdApprovePost>>,
  TError,
  {
    billId: string;
    data: ApproveBillApiV1AccountingBillsBillIdApprovePostBody;
  },
  TContext
> => {
  const mutationOptions =
    getApproveBillApiV1AccountingBillsBillIdApprovePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Void Bill
 */
export const voidBillApiV1AccountingBillsBillIdVoidPost = (
  billId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}/void`,
    method: 'POST',
    signal
  });
};

export const getVoidBillApiV1AccountingBillsBillIdVoidPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voidBillApiV1AccountingBillsBillIdVoidPost>>,
    TError,
    { billId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof voidBillApiV1AccountingBillsBillIdVoidPost>>,
  TError,
  { billId: string },
  TContext
> => {
  const mutationKey = ['voidBillApiV1AccountingBillsBillIdVoidPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof voidBillApiV1AccountingBillsBillIdVoidPost>>,
    { billId: string }
  > = (props) => {
    const { billId } = props ?? {};

    return voidBillApiV1AccountingBillsBillIdVoidPost(billId);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoidBillApiV1AccountingBillsBillIdVoidPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof voidBillApiV1AccountingBillsBillIdVoidPost>>
  >;

export type VoidBillApiV1AccountingBillsBillIdVoidPostMutationError =
  HTTPValidationError;

/**
 * @summary Void Bill
 */
export const useVoidBillApiV1AccountingBillsBillIdVoidPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof voidBillApiV1AccountingBillsBillIdVoidPost>>,
      TError,
      { billId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof voidBillApiV1AccountingBillsBillIdVoidPost>>,
  TError,
  { billId: string },
  TContext
> => {
  const mutationOptions =
    getVoidBillApiV1AccountingBillsBillIdVoidPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Clone Bill
 */
export const cloneBillApiV1AccountingBillsBillIdClonePost = (
  billId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/bills/${billId}/clone`,
    method: 'POST',
    signal
  });
};

export const getCloneBillApiV1AccountingBillsBillIdClonePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneBillApiV1AccountingBillsBillIdClonePost>>,
    TError,
    { billId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneBillApiV1AccountingBillsBillIdClonePost>>,
  TError,
  { billId: string },
  TContext
> => {
  const mutationKey = ['cloneBillApiV1AccountingBillsBillIdClonePost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneBillApiV1AccountingBillsBillIdClonePost>>,
    { billId: string }
  > = (props) => {
    const { billId } = props ?? {};

    return cloneBillApiV1AccountingBillsBillIdClonePost(billId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneBillApiV1AccountingBillsBillIdClonePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof cloneBillApiV1AccountingBillsBillIdClonePost>>
  >;

export type CloneBillApiV1AccountingBillsBillIdClonePostMutationError =
  HTTPValidationError;

/**
 * @summary Clone Bill
 */
export const useCloneBillApiV1AccountingBillsBillIdClonePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cloneBillApiV1AccountingBillsBillIdClonePost>>,
      TError,
      { billId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cloneBillApiV1AccountingBillsBillIdClonePost>>,
  TError,
  { billId: string },
  TContext
> => {
  const mutationOptions =
    getCloneBillApiV1AccountingBillsBillIdClonePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Raise a draft vendor credit against a bill — the AP mirror of
``POST /invoices/{invoice_id}/credit-note``.

Gated at VIEWER on the source, exactly like the AR twin and like
``clone_bill``: the source bill is READ to build the credit, and the credit is
a new document the caller owns. Gating at EDITOR would refuse a shared-in
clerk the one route AP has for a pricing dispute.
 * @summary Create Vendor Credit
 */
export const createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost = (
  billId: string,
  createVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody: CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody,
  signal?: AbortSignal
) => {
  return customInstance<BillResponse>({
    url: `/api/v1/accounting/bills/${billId}/vendor-credit`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody,
    signal
  });
};

export const getCreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost
        >
      >,
      TError,
      {
        billId: string;
        data: CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost
      >
    >,
    TError,
    {
      billId: string;
      data: CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost
        >
      >,
      {
        billId: string;
        data: CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody;
      }
    > = (props) => {
      const { billId, data } = props ?? {};

      return createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost(
        billId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost
      >
    >
  >;
export type CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostMutationBody =
  CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody;
export type CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Vendor Credit
 */
export const useCreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost
        >
      >,
      TError,
      {
        billId: string;
        data: CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createVendorCreditApiV1AccountingBillsBillIdVendorCreditPost
    >
  >,
  TError,
  {
    billId: string;
    data: CreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostBody;
  },
  TContext
> => {
  const mutationOptions =
    getCreateVendorCreditApiV1AccountingBillsBillIdVendorCreditPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List Payments
 */
export const listPaymentsApiV1AccountingPaymentsGet = (
  params?: ListPaymentsApiV1AccountingPaymentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/payments`,
    method: 'GET',
    params,
    signal
  });
};

export const getListPaymentsApiV1AccountingPaymentsGetQueryKey = (
  params?: ListPaymentsApiV1AccountingPaymentsGetParams
) => {
  return [`/api/v1/accounting/payments`, ...(params ? [params] : [])] as const;
};

export const getListPaymentsApiV1AccountingPaymentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListPaymentsApiV1AccountingPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPaymentsApiV1AccountingPaymentsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>
  > = ({ signal }) => listPaymentsApiV1AccountingPaymentsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListPaymentsApiV1AccountingPaymentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>
>;
export type ListPaymentsApiV1AccountingPaymentsGetQueryError =
  HTTPValidationError;

export function useListPaymentsApiV1AccountingPaymentsGet<
  TData = Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListPaymentsApiV1AccountingPaymentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
          TError,
          Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPaymentsApiV1AccountingPaymentsGet<
  TData = Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListPaymentsApiV1AccountingPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
          TError,
          Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPaymentsApiV1AccountingPaymentsGet<
  TData = Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListPaymentsApiV1AccountingPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Payments
 */

export function useListPaymentsApiV1AccountingPaymentsGet<
  TData = Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListPaymentsApiV1AccountingPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPaymentsApiV1AccountingPaymentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListPaymentsApiV1AccountingPaymentsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Payment
 */
export const createPaymentApiV1AccountingPaymentsPost = (
  paymentCreateRequest: PaymentCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/payments`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: paymentCreateRequest,
    signal
  });
};

export const getCreatePaymentApiV1AccountingPaymentsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentApiV1AccountingPaymentsPost>>,
    TError,
    { data: PaymentCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPaymentApiV1AccountingPaymentsPost>>,
  TError,
  { data: PaymentCreateRequest },
  TContext
> => {
  const mutationKey = ['createPaymentApiV1AccountingPaymentsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPaymentApiV1AccountingPaymentsPost>>,
    { data: PaymentCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createPaymentApiV1AccountingPaymentsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePaymentApiV1AccountingPaymentsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createPaymentApiV1AccountingPaymentsPost>>
  >;
export type CreatePaymentApiV1AccountingPaymentsPostMutationBody =
  PaymentCreateRequest;
export type CreatePaymentApiV1AccountingPaymentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Payment
 */
export const useCreatePaymentApiV1AccountingPaymentsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPaymentApiV1AccountingPaymentsPost>>,
      TError,
      { data: PaymentCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPaymentApiV1AccountingPaymentsPost>>,
  TError,
  { data: PaymentCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreatePaymentApiV1AccountingPaymentsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Payment
 */
export const getPaymentApiV1AccountingPaymentsPaymentIdGet = (
  paymentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/payments/${paymentId}`,
    method: 'GET',
    signal
  });
};

export const getGetPaymentApiV1AccountingPaymentsPaymentIdGetQueryKey = (
  paymentId?: string
) => {
  return [`/api/v1/accounting/payments/${paymentId}`] as const;
};

export const getGetPaymentApiV1AccountingPaymentsPaymentIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPaymentApiV1AccountingPaymentsPaymentIdGetQueryKey(paymentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>>
  > = ({ signal }) =>
    getPaymentApiV1AccountingPaymentsPaymentIdGet(paymentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!paymentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPaymentApiV1AccountingPaymentsPaymentIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>>
  >;
export type GetPaymentApiV1AccountingPaymentsPaymentIdGetQueryError =
  HTTPValidationError;

export function useGetPaymentApiV1AccountingPaymentsPaymentIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPaymentApiV1AccountingPaymentsPaymentIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPaymentApiV1AccountingPaymentsPaymentIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Payment
 */

export function useGetPaymentApiV1AccountingPaymentsPaymentIdGet<
  TData = Awaited<
    ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPaymentApiV1AccountingPaymentsPaymentIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPaymentApiV1AccountingPaymentsPaymentIdGetQueryOptions(
      paymentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Void Payment
 */
export const voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost = (
  paymentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/payments/${paymentId}/void`,
    method: 'POST',
    signal
  });
};

export const getVoidPaymentApiV1AccountingPaymentsPaymentIdVoidPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost>
      >,
      TError,
      { paymentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost>
    >,
    TError,
    { paymentId: string },
    TContext
  > => {
    const mutationKey = ['voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost>
      >,
      { paymentId: string }
    > = (props) => {
      const { paymentId } = props ?? {};

      return voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost(paymentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type VoidPaymentApiV1AccountingPaymentsPaymentIdVoidPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost>
    >
  >;

export type VoidPaymentApiV1AccountingPaymentsPaymentIdVoidPostMutationError =
  HTTPValidationError;

/**
 * @summary Void Payment
 */
export const useVoidPaymentApiV1AccountingPaymentsPaymentIdVoidPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost>
      >,
      TError,
      { paymentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof voidPaymentApiV1AccountingPaymentsPaymentIdVoidPost>
  >,
  TError,
  { paymentId: string },
  TContext
> => {
  const mutationOptions =
    getVoidPaymentApiV1AccountingPaymentsPaymentIdVoidPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Apply an existing vendor (made) payment to open bills (AP "apply afterwards").

Mirrors the bill-allocation arm of ``create_payment``: no new JE (the AP
control was already relieved at create), just a bill-subledger catch-up.
 * @summary Allocate Payment
 */
export const allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost = (
  paymentId: string,
  paymentAllocateRequest: PaymentAllocateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/payments/${paymentId}/allocations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: paymentAllocateRequest,
    signal
  });
};

export const getAllocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost
        >
      >,
      TError,
      { paymentId: string; data: PaymentAllocateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost
      >
    >,
    TError,
    { paymentId: string; data: PaymentAllocateRequest },
    TContext
  > => {
    const mutationKey = [
      'allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost
        >
      >,
      { paymentId: string; data: PaymentAllocateRequest }
    > = (props) => {
      const { paymentId, data } = props ?? {};

      return allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost(
        paymentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AllocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost
      >
    >
  >;
export type AllocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPostMutationBody =
  PaymentAllocateRequest;
export type AllocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Allocate Payment
 */
export const useAllocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost
          >
        >,
        TError,
        { paymentId: string; data: PaymentAllocateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof allocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPost
      >
    >,
    TError,
    { paymentId: string; data: PaymentAllocateRequest },
    TContext
  > => {
    const mutationOptions =
      getAllocatePaymentApiV1AccountingPaymentsPaymentIdAllocationsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Render a received payment as branded receipt HTML (for the preview).

The ``layout_id`` query param names the line-column layout to render with;
None resolves the company/tenant default (see ``build_line_layout``). The
receipt has no PDF *download* route — the preview and the distribute send
are its only two render surfaces.
 * @summary Get Receipt Preview
 */
export const getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet =
  (
    paymentId: string,
    params?: GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/payments/${paymentId}/receipt-preview`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetQueryKey =
  (
    paymentId?: string,
    params?: GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams
  ) => {
    return [
      `/api/v1/accounting/payments/${paymentId}/receipt-preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    paymentId: string,
    params?: GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetQueryKey(
        paymentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
        >
      >
    > = ({ signal }) =>
      getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet(
        paymentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!paymentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
      >
    >
  >;
export type GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetQueryError =
  HTTPValidationError;

export function useGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  params:
    | undefined
    | GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  params?: GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  params?: GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Receipt Preview
 */

export function useGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  paymentId: string,
  params?: GetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetReceiptPreviewApiV1AccountingPaymentsPaymentIdReceiptPreviewGetQueryOptions(
      paymentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Email a branded receipt for a received payment to the payer (and re-share).

Each call is its own tracked distribution event. Recipients default to the
payment's contact when ``to`` is omitted. Only ``payment_type='received'``
payments are distributable (enforced by the provider). Delegates to the
generic shared distribution service.
 * @summary Distribute Payment
 */
export const distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost = (
  paymentId: string,
  documentDistributeRequest: DocumentDistributeRequest,
  signal?: AbortSignal
) => {
  return customInstance<PaymentDistributeResponse>({
    url: `/api/v1/accounting/payments/${paymentId}/distribute`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: documentDistributeRequest,
    signal
  });
};

export const getDistributePaymentApiV1AccountingPaymentsPaymentIdDistributePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost
        >
      >,
      TError,
      { paymentId: string; data: DocumentDistributeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost
      >
    >,
    TError,
    { paymentId: string; data: DocumentDistributeRequest },
    TContext
  > => {
    const mutationKey = [
      'distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost
        >
      >,
      { paymentId: string; data: DocumentDistributeRequest }
    > = (props) => {
      const { paymentId, data } = props ?? {};

      return distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost(
        paymentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DistributePaymentApiV1AccountingPaymentsPaymentIdDistributePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost
      >
    >
  >;
export type DistributePaymentApiV1AccountingPaymentsPaymentIdDistributePostMutationBody =
  DocumentDistributeRequest;
export type DistributePaymentApiV1AccountingPaymentsPaymentIdDistributePostMutationError =
  HTTPValidationError;

/**
 * @summary Distribute Payment
 */
export const useDistributePaymentApiV1AccountingPaymentsPaymentIdDistributePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost
          >
        >,
        TError,
        { paymentId: string; data: DocumentDistributeRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof distributePaymentApiV1AccountingPaymentsPaymentIdDistributePost
      >
    >,
    TError,
    { paymentId: string; data: DocumentDistributeRequest },
    TContext
  > => {
    const mutationOptions =
      getDistributePaymentApiV1AccountingPaymentsPaymentIdDistributePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List Tier-2 vendor-default rules the caller may view.

Bounded to the caller's accessible companies — the read counterpart of the
by-id ``_assert_company_accessible`` gate on every other route here. RLS scopes
these rows by tenant, NOT company, so without this a member of one company
could read another's vendor defaults; that went unnoticed while the endpoint
had no frontend consumer, and Phase 5c gives it one.

``accessible or None`` mirrors ``list_learned_match_rules``: an EMPTY accessible
list is the documented legacy pre-seeding passthrough (still bounded by the
query's own ``tenant_id``), not "no companies" — see
``resolve_active_company_scope``.
 * @summary List Vendor Rules
 */
export const listVendorRulesApiV1AccountingVendorRulesGet = (
  params?: ListVendorRulesApiV1AccountingVendorRulesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/vendor-rules`,
    method: 'GET',
    params,
    signal
  });
};

export const getListVendorRulesApiV1AccountingVendorRulesGetQueryKey = (
  params?: ListVendorRulesApiV1AccountingVendorRulesGetParams
) => {
  return [
    `/api/v1/accounting/vendor-rules`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListVendorRulesApiV1AccountingVendorRulesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListVendorRulesApiV1AccountingVendorRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListVendorRulesApiV1AccountingVendorRulesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>>
  > = ({ signal }) =>
    listVendorRulesApiV1AccountingVendorRulesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListVendorRulesApiV1AccountingVendorRulesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>>
  >;
export type ListVendorRulesApiV1AccountingVendorRulesGetQueryError =
  HTTPValidationError;

export function useListVendorRulesApiV1AccountingVendorRulesGet<
  TData = Awaited<
    ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListVendorRulesApiV1AccountingVendorRulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListVendorRulesApiV1AccountingVendorRulesGet<
  TData = Awaited<
    ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListVendorRulesApiV1AccountingVendorRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListVendorRulesApiV1AccountingVendorRulesGet<
  TData = Awaited<
    ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListVendorRulesApiV1AccountingVendorRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Vendor Rules
 */

export function useListVendorRulesApiV1AccountingVendorRulesGet<
  TData = Awaited<
    ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListVendorRulesApiV1AccountingVendorRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listVendorRulesApiV1AccountingVendorRulesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListVendorRulesApiV1AccountingVendorRulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Vendor Rule
 */
export const createVendorRuleApiV1AccountingVendorRulesPost = (
  vendorRuleCreateRequest: VendorRuleCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/vendor-rules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: vendorRuleCreateRequest,
    signal
  });
};

export const getCreateVendorRuleApiV1AccountingVendorRulesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createVendorRuleApiV1AccountingVendorRulesPost>
      >,
      TError,
      { data: VendorRuleCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createVendorRuleApiV1AccountingVendorRulesPost>>,
    TError,
    { data: VendorRuleCreateRequest },
    TContext
  > => {
    const mutationKey = ['createVendorRuleApiV1AccountingVendorRulesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createVendorRuleApiV1AccountingVendorRulesPost>
      >,
      { data: VendorRuleCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createVendorRuleApiV1AccountingVendorRulesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateVendorRuleApiV1AccountingVendorRulesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createVendorRuleApiV1AccountingVendorRulesPost>>
  >;
export type CreateVendorRuleApiV1AccountingVendorRulesPostMutationBody =
  VendorRuleCreateRequest;
export type CreateVendorRuleApiV1AccountingVendorRulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Vendor Rule
 */
export const useCreateVendorRuleApiV1AccountingVendorRulesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createVendorRuleApiV1AccountingVendorRulesPost>
      >,
      TError,
      { data: VendorRuleCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createVendorRuleApiV1AccountingVendorRulesPost>>,
  TError,
  { data: VendorRuleCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateVendorRuleApiV1AccountingVendorRulesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Vendor Rule
 */
export const getVendorRuleApiV1AccountingVendorRulesRuleIdGet = (
  ruleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/vendor-rules/${ruleId}`,
    method: 'GET',
    signal
  });
};

export const getGetVendorRuleApiV1AccountingVendorRulesRuleIdGetQueryKey = (
  ruleId?: string
) => {
  return [`/api/v1/accounting/vendor-rules/${ruleId}`] as const;
};

export const getGetVendorRuleApiV1AccountingVendorRulesRuleIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVendorRuleApiV1AccountingVendorRulesRuleIdGetQueryKey(ruleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>>
  > = ({ signal }) =>
    getVendorRuleApiV1AccountingVendorRulesRuleIdGet(ruleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!ruleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVendorRuleApiV1AccountingVendorRulesRuleIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>>
  >;
export type GetVendorRuleApiV1AccountingVendorRulesRuleIdGetQueryError =
  HTTPValidationError;

export function useGetVendorRuleApiV1AccountingVendorRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVendorRuleApiV1AccountingVendorRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVendorRuleApiV1AccountingVendorRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Vendor Rule
 */

export function useGetVendorRuleApiV1AccountingVendorRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVendorRuleApiV1AccountingVendorRulesRuleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetVendorRuleApiV1AccountingVendorRulesRuleIdGetQueryOptions(
      ruleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Vendor Rule
 */
export const updateVendorRuleApiV1AccountingVendorRulesRuleIdPut = (
  ruleId: string,
  vendorRuleUpdateRequest: VendorRuleUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/vendor-rules/${ruleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: vendorRuleUpdateRequest
  });
};

export const getUpdateVendorRuleApiV1AccountingVendorRulesRuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateVendorRuleApiV1AccountingVendorRulesRuleIdPut>
      >,
      TError,
      { ruleId: string; data: VendorRuleUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateVendorRuleApiV1AccountingVendorRulesRuleIdPut>
    >,
    TError,
    { ruleId: string; data: VendorRuleUpdateRequest },
    TContext
  > => {
    const mutationKey = ['updateVendorRuleApiV1AccountingVendorRulesRuleIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateVendorRuleApiV1AccountingVendorRulesRuleIdPut>
      >,
      { ruleId: string; data: VendorRuleUpdateRequest }
    > = (props) => {
      const { ruleId, data } = props ?? {};

      return updateVendorRuleApiV1AccountingVendorRulesRuleIdPut(ruleId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateVendorRuleApiV1AccountingVendorRulesRuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateVendorRuleApiV1AccountingVendorRulesRuleIdPut>
    >
  >;
export type UpdateVendorRuleApiV1AccountingVendorRulesRuleIdPutMutationBody =
  VendorRuleUpdateRequest;
export type UpdateVendorRuleApiV1AccountingVendorRulesRuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Vendor Rule
 */
export const useUpdateVendorRuleApiV1AccountingVendorRulesRuleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateVendorRuleApiV1AccountingVendorRulesRuleIdPut>
      >,
      TError,
      { ruleId: string; data: VendorRuleUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateVendorRuleApiV1AccountingVendorRulesRuleIdPut>
  >,
  TError,
  { ruleId: string; data: VendorRuleUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateVendorRuleApiV1AccountingVendorRulesRuleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Vendor Rule
 */
export const deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete = (
  ruleId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/vendor-rules/${ruleId}`,
    method: 'DELETE'
  });
};

export const getDeleteVendorRuleApiV1AccountingVendorRulesRuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete>
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete
        >
      >,
      { ruleId: string }
    > = (props) => {
      const { ruleId } = props ?? {};

      return deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete(ruleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteVendorRuleApiV1AccountingVendorRulesRuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete>
    >
  >;

export type DeleteVendorRuleApiV1AccountingVendorRulesRuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Vendor Rule
 */
export const useDeleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteVendorRuleApiV1AccountingVendorRulesRuleIdDelete>
  >,
  TError,
  { ruleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteVendorRuleApiV1AccountingVendorRulesRuleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Invoice Summary Report
 */
export const invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet =
  (
    params: InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/friendly-reports/invoice-summary`,
      method: 'GET',
      params,
      signal
    });
  };

export const getInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetQueryKey =
  (
    params?: InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams
  ) => {
    return [
      `/api/v1/accounting/friendly-reports/invoice-summary`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
        >
      >
    > = ({ signal }) =>
      invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
      >
    >
  >;
export type InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetQueryError =
  HTTPValidationError;

export function useInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Invoice Summary Report
 */

export function useInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: InvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof invoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getInvoiceSummaryReportApiV1AccountingFriendlyReportsInvoiceSummaryGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Bill Summary Report
 */
export const billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet = (
  params: BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/friendly-reports/bill-summary`,
    method: 'GET',
    params,
    signal
  });
};

export const getBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetQueryKey =
  (
    params?: BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams
  ) => {
    return [
      `/api/v1/accounting/friendly-reports/bill-summary`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
        >
      >
    > = ({ signal }) =>
      billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
      >
    >
  >;
export type BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetQueryError =
  HTTPValidationError;

export function useBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Bill Summary Report
 */

export function useBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: BillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof billSummaryReportApiV1AccountingFriendlyReportsBillSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getBillSummaryReportApiV1AccountingFriendlyReportsBillSummaryGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Profit Loss Report
 */
export const profitLossReportApiV1AccountingFriendlyReportsProfitLossGet = (
  params: ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/friendly-reports/profit-loss`,
    method: 'GET',
    params,
    signal
  });
};

export const getProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetQueryKey =
  (
    params?: ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams
  ) => {
    return [
      `/api/v1/accounting/friendly-reports/profit-loss`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
        >
      >
    > = ({ signal }) =>
      profitLossReportApiV1AccountingFriendlyReportsProfitLossGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
      >
    >
  >;
export type ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetQueryError =
  HTTPValidationError;

export function useProfitLossReportApiV1AccountingFriendlyReportsProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useProfitLossReportApiV1AccountingFriendlyReportsProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProfitLossReportApiV1AccountingFriendlyReportsProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Profit Loss Report
 */

export function useProfitLossReportApiV1AccountingFriendlyReportsProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLossReportApiV1AccountingFriendlyReportsProfitLossGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getProfitLossReportApiV1AccountingFriendlyReportsProfitLossGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Period x dimension matrix powering the reports Chart view (bar/line charts).

Stacked breakdown by customer (invoices), vendor/category (bills), or
revenue-vs-expenses + net line (profit_loss). Amounts in dollars.
 * @summary Report Trend
 */
export const reportTrendApiV1AccountingFriendlyReportsTrendGet = (
  params: ReportTrendApiV1AccountingFriendlyReportsTrendGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/friendly-reports/trend`,
    method: 'GET',
    params,
    signal
  });
};

export const getReportTrendApiV1AccountingFriendlyReportsTrendGetQueryKey = (
  params?: ReportTrendApiV1AccountingFriendlyReportsTrendGetParams
) => {
  return [
    `/api/v1/accounting/friendly-reports/trend`,
    ...(params ? [params] : [])
  ] as const;
};

export const getReportTrendApiV1AccountingFriendlyReportsTrendGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
    >,
    TError = HTTPValidationError
  >(
    params: ReportTrendApiV1AccountingFriendlyReportsTrendGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getReportTrendApiV1AccountingFriendlyReportsTrendGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
      >
    > = ({ signal }) =>
      reportTrendApiV1AccountingFriendlyReportsTrendGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ReportTrendApiV1AccountingFriendlyReportsTrendGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
    >
  >;
export type ReportTrendApiV1AccountingFriendlyReportsTrendGetQueryError =
  HTTPValidationError;

export function useReportTrendApiV1AccountingFriendlyReportsTrendGet<
  TData = Awaited<
    ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
  >,
  TError = HTTPValidationError
>(
  params: ReportTrendApiV1AccountingFriendlyReportsTrendGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useReportTrendApiV1AccountingFriendlyReportsTrendGet<
  TData = Awaited<
    ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
  >,
  TError = HTTPValidationError
>(
  params: ReportTrendApiV1AccountingFriendlyReportsTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useReportTrendApiV1AccountingFriendlyReportsTrendGet<
  TData = Awaited<
    ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
  >,
  TError = HTTPValidationError
>(
  params: ReportTrendApiV1AccountingFriendlyReportsTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Report Trend
 */

export function useReportTrendApiV1AccountingFriendlyReportsTrendGet<
  TData = Awaited<
    ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
  >,
  TError = HTTPValidationError
>(
  params: ReportTrendApiV1AccountingFriendlyReportsTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof reportTrendApiV1AccountingFriendlyReportsTrendGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getReportTrendApiV1AccountingFriendlyReportsTrendGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Monthly income breakdown across the reporting period.
 * @summary Summarized Income Report
 */
export const summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet = (
  params: SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/summarized-income`,
    method: 'GET',
    params,
    signal
  });
};

export const getSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetQueryKey =
  (
    params?: SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/summarized-income`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
        >
      >
    > = ({ signal }) =>
      summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
      >
    >
  >;
export type SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetQueryError =
  HTTPValidationError;

export function useSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Summarized Income Report
 */

export function useSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getSummarizedIncomeReportApiV1AccountingReportsSummarizedIncomeGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Expense breakdown by category and month (2D matrix).
 * @summary Summarized Expenses Report
 */
export const summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet =
  (
    params: SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/summarized-expenses`,
      method: 'GET',
      params,
      signal
    });
  };

export const getSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetQueryKey =
  (
    params?: SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/summarized-expenses`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
        >
      >
    > = ({ signal }) =>
      summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
      >
    >
  >;
export type SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetQueryError =
  HTTPValidationError;

export function useSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Summarized Expenses Report
 */

export function useSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet<
  TData = Awaited<
    ReturnType<
      typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: SummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof summarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getSummarizedExpensesReportApiV1AccountingReportsSummarizedExpensesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Total income per customer for a period.
 * @summary Income By Customer Report
 */
export const incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet = (
  params: IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/income-by-customer`,
    method: 'GET',
    params,
    signal
  });
};

export const getIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetQueryKey =
  (
    params?: IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/income-by-customer`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
        >
      >
    > = ({ signal }) =>
      incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
      >
    >
  >;
export type IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetQueryError =
  HTTPValidationError;

export function useIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet<
  TData = Awaited<
    ReturnType<
      typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
    >
  >,
  TError = HTTPValidationError
>(
  params: IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet<
  TData = Awaited<
    ReturnType<
      typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
    >
  >,
  TError = HTTPValidationError
>(
  params: IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet<
  TData = Awaited<
    ReturnType<
      typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
    >
  >,
  TError = HTTPValidationError
>(
  params: IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Income By Customer Report
 */

export function useIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet<
  TData = Awaited<
    ReturnType<
      typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
    >
  >,
  TError = HTTPValidationError
>(
  params: IncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof incomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getIncomeByCustomerReportApiV1AccountingReportsIncomeByCustomerGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Total expenses per vendor for a period.
 * @summary Expenses By Vendor Report
 */
export const expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet = (
  params: ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/expenses-by-vendor`,
    method: 'GET',
    params,
    signal
  });
};

export const getExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetQueryKey =
  (
    params?: ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/expenses-by-vendor`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
        >
      >
    > = ({ signal }) =>
      expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
      >
    >
  >;
export type ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetQueryError =
  HTTPValidationError;

export function useExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Expenses By Vendor Report
 */

export function useExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesByVendorReportApiV1AccountingReportsExpensesByVendorGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExpensesByVendorReportApiV1AccountingReportsExpensesByVendorGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Expenses + payments + outstanding balance per vendor.
 * @summary Expenses And Payments By Vendor Report
 */
export const expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet =
  (
    params: ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/expenses-and-payments-by-vendor`,
      method: 'GET',
      params,
      signal
    });
  };

export const getExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetQueryKey =
  (
    params?: ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/expenses-and-payments-by-vendor`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
        >
      >
    > = ({ signal }) =>
      expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
      >
    >
  >;
export type ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetQueryError =
  HTTPValidationError;

export function useExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Expenses And Payments By Vendor Report
 */

export function useExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet<
  TData = Awaited<
    ReturnType<
      typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExpensesAndPaymentsByVendorReportApiV1AccountingReportsExpensesAndPaymentsByVendorGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Open/unpaid invoices with customer balances. Set show_summary_only=true for aggregated view.
 * @summary Collection Report
 */
export const collectionReportApiV1AccountingReportsCollectionGet = (
  params?: CollectionReportApiV1AccountingReportsCollectionGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/collection`,
    method: 'GET',
    params,
    signal
  });
};

export const getCollectionReportApiV1AccountingReportsCollectionGetQueryKey = (
  params?: CollectionReportApiV1AccountingReportsCollectionGetParams
) => {
  return [
    `/api/v1/accounting/reports/collection`,
    ...(params ? [params] : [])
  ] as const;
};

export const getCollectionReportApiV1AccountingReportsCollectionGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
    >,
    TError = HTTPValidationError
  >(
    params?: CollectionReportApiV1AccountingReportsCollectionGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof collectionReportApiV1AccountingReportsCollectionGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCollectionReportApiV1AccountingReportsCollectionGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
      >
    > = ({ signal }) =>
      collectionReportApiV1AccountingReportsCollectionGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type CollectionReportApiV1AccountingReportsCollectionGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
    >
  >;
export type CollectionReportApiV1AccountingReportsCollectionGetQueryError =
  HTTPValidationError;

export function useCollectionReportApiV1AccountingReportsCollectionGet<
  TData = Awaited<
    ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | CollectionReportApiV1AccountingReportsCollectionGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof collectionReportApiV1AccountingReportsCollectionGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof collectionReportApiV1AccountingReportsCollectionGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCollectionReportApiV1AccountingReportsCollectionGet<
  TData = Awaited<
    ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
  >,
  TError = HTTPValidationError
>(
  params?: CollectionReportApiV1AccountingReportsCollectionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof collectionReportApiV1AccountingReportsCollectionGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof collectionReportApiV1AccountingReportsCollectionGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionReportApiV1AccountingReportsCollectionGet<
  TData = Awaited<
    ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
  >,
  TError = HTTPValidationError
>(
  params?: CollectionReportApiV1AccountingReportsCollectionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Collection Report
 */

export function useCollectionReportApiV1AccountingReportsCollectionGet<
  TData = Awaited<
    ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
  >,
  TError = HTTPValidationError
>(
  params?: CollectionReportApiV1AccountingReportsCollectionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof collectionReportApiV1AccountingReportsCollectionGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getCollectionReportApiV1AccountingReportsCollectionGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Side-by-side P&L comparison. YoY or month-by-month.
 * @summary Comparative Profit Loss Report
 */
export const comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet =
  (
    params?: ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/comparative-profit-loss`,
      method: 'GET',
      params,
      signal
    });
  };

export const getComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetQueryKey =
  (
    params?: ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/comparative-profit-loss`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
        >
      >
    > = ({ signal }) =>
      comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
      >
    >
  >;
export type ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetQueryError =
  HTTPValidationError;

export function useComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Comparative Profit Loss Report
 */

export function useComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet<
  TData = Awaited<
    ReturnType<
      typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof comparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getComparativeProfitLossReportApiV1AccountingReportsComparativeProfitLossGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * VAT collected vs paid by period, with net liability.
 * @summary Vat Report
 */
export const vatReportApiV1AccountingReportsVatGet = (
  params: VatReportApiV1AccountingReportsVatGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/vat`,
    method: 'GET',
    params,
    signal
  });
};

export const getVatReportApiV1AccountingReportsVatGetQueryKey = (
  params?: VatReportApiV1AccountingReportsVatGetParams
) => {
  return [
    `/api/v1/accounting/reports/vat`,
    ...(params ? [params] : [])
  ] as const;
};

export const getVatReportApiV1AccountingReportsVatGetQueryOptions = <
  TData = Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
  TError = HTTPValidationError
>(
  params: VatReportApiV1AccountingReportsVatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getVatReportApiV1AccountingReportsVatGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>
  > = ({ signal }) => vatReportApiV1AccountingReportsVatGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type VatReportApiV1AccountingReportsVatGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>
>;
export type VatReportApiV1AccountingReportsVatGetQueryError =
  HTTPValidationError;

export function useVatReportApiV1AccountingReportsVatGet<
  TData = Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
  TError = HTTPValidationError
>(
  params: VatReportApiV1AccountingReportsVatGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
          TError,
          Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useVatReportApiV1AccountingReportsVatGet<
  TData = Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
  TError = HTTPValidationError
>(
  params: VatReportApiV1AccountingReportsVatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
          TError,
          Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useVatReportApiV1AccountingReportsVatGet<
  TData = Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
  TError = HTTPValidationError
>(
  params: VatReportApiV1AccountingReportsVatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Vat Report
 */

export function useVatReportApiV1AccountingReportsVatGet<
  TData = Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
  TError = HTTPValidationError
>(
  params: VatReportApiV1AccountingReportsVatGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof vatReportApiV1AccountingReportsVatGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getVatReportApiV1AccountingReportsVatGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Withholding tax deducted by customers on payments received.
 * @summary Withholding Tax From Customers Report
 */
export const withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet =
  (
    params: WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/withholding-tax-customers`,
      method: 'GET',
      params,
      signal
    });
  };

export const getWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetQueryKey =
  (
    params?: WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/withholding-tax-customers`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
        >
      >
    > = ({ signal }) =>
      withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
      >
    >
  >;
export type WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetQueryError =
  HTTPValidationError;

export function useWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Withholding Tax From Customers Report
 */

export function useWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getWithholdingTaxFromCustomersReportApiV1AccountingReportsWithholdingTaxCustomersGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Withholding tax deducted when paying vendors.
 * @summary Withholding Tax From Vendors Report
 */
export const withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet =
  (
    params: WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/withholding-tax-vendors`,
      method: 'GET',
      params,
      signal
    });
  };

export const getWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetQueryKey =
  (
    params?: WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/withholding-tax-vendors`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
        >
      >
    > = ({ signal }) =>
      withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
      >
    >
  >;
export type WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetQueryError =
  HTTPValidationError;

export function useWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Withholding Tax From Vendors Report
 */

export function useWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: WithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof withholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getWithholdingTaxFromVendorsReportApiV1AccountingReportsWithholdingTaxVendorsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Combined expense and withholding tax summary per vendor.
 * @summary Expense And Withholding Summary Report
 */
export const expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet =
  (
    params: ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/expense-withholding-summary`,
      method: 'GET',
      params,
      signal
    });
  };

export const getExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetQueryKey =
  (
    params?: ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/expense-withholding-summary`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
        >
      >
    > = ({ signal }) =>
      expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
      >
    >
  >;
export type ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetQueryError =
  HTTPValidationError;

export function useExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Expense And Withholding Summary Report
 */

export function useExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof expenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExpenseAndWithholdingSummaryReportApiV1AccountingReportsExpenseWithholdingSummaryGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * P&L in Israeli Tax Authority Form 6111 structure.
 * @summary Profit Loss 6111 Report
 */
export const profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get = (
  params: ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/profit-loss-6111`,
    method: 'GET',
    params,
    signal
  });
};

export const getProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetQueryKey =
  (
    params?: ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams
  ) => {
    return [
      `/api/v1/accounting/reports/profit-loss-6111`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
      >
    >,
    TError = HTTPValidationError
  >(
    params: ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
        >
      >
    > = ({ signal }) =>
      profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
      >
    >
  >;
export type ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetQueryError =
  HTTPValidationError;

export function useProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get<
  TData = Awaited<
    ReturnType<
      typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get<
  TData = Awaited<
    ReturnType<
      typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get<
  TData = Awaited<
    ReturnType<
      typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Profit Loss 6111 Report
 */

export function useProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get<
  TData = Awaited<
    ReturnType<
      typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
    >
  >,
  TError = HTTPValidationError
>(
  params: ProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof profitLoss6111ReportApiV1AccountingReportsProfitLoss6111Get
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getProfitLoss6111ReportApiV1AccountingReportsProfitLoss6111GetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Indirect-method cash flow statement: operating / investing / financing.
 * @summary Cash Flow Statement Report
 */
export const cashFlowStatementReportApiV1AccountingReportsCashFlowGet = (
  params: CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/cash-flow`,
    method: 'GET',
    params,
    signal
  });
};

export const getCashFlowStatementReportApiV1AccountingReportsCashFlowGetQueryKey =
  (params?: CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams) => {
    return [
      `/api/v1/accounting/reports/cash-flow`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getCashFlowStatementReportApiV1AccountingReportsCashFlowGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCashFlowStatementReportApiV1AccountingReportsCashFlowGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
        >
      >
    > = ({ signal }) =>
      cashFlowStatementReportApiV1AccountingReportsCashFlowGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type CashFlowStatementReportApiV1AccountingReportsCashFlowGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
      >
    >
  >;
export type CashFlowStatementReportApiV1AccountingReportsCashFlowGetQueryError =
  HTTPValidationError;

export function useCashFlowStatementReportApiV1AccountingReportsCashFlowGet<
  TData = Awaited<
    ReturnType<typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet>
  >,
  TError = HTTPValidationError
>(
  params: CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCashFlowStatementReportApiV1AccountingReportsCashFlowGet<
  TData = Awaited<
    ReturnType<typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet>
  >,
  TError = HTTPValidationError
>(
  params: CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCashFlowStatementReportApiV1AccountingReportsCashFlowGet<
  TData = Awaited<
    ReturnType<typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet>
  >,
  TError = HTTPValidationError
>(
  params: CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Cash Flow Statement Report
 */

export function useCashFlowStatementReportApiV1AccountingReportsCashFlowGet<
  TData = Awaited<
    ReturnType<typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet>
  >,
  TError = HTTPValidationError
>(
  params: CashFlowStatementReportApiV1AccountingReportsCashFlowGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowStatementReportApiV1AccountingReportsCashFlowGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getCashFlowStatementReportApiV1AccountingReportsCashFlowGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bucketed cash flows for the period — direct-method chart data.

Granularity is auto-selected from the range length (day/week/month/quarter).
Returns per-bucket operating/investing/financing flows plus a running cash
balance to overlay on top of the stacked bars.
 * @summary Cash Flow Timeseries Report
 */
export const cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet =
  (
    params: CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/reports/cash-flow-timeseries`,
      method: 'GET',
      params,
      signal
    });
  };

export const getCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetQueryKey =
  (
    params?: CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/cash-flow-timeseries`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
        >
      >
    > = ({ signal }) =>
      cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
      >
    >
  >;
export type CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetQueryError =
  HTTPValidationError;

export function useCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet<
  TData = Awaited<
    ReturnType<
      typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet<
  TData = Awaited<
    ReturnType<
      typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet<
  TData = Awaited<
    ReturnType<
      typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Cash Flow Timeseries Report
 */

export function useCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet<
  TData = Awaited<
    ReturnType<
      typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: CashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getCashFlowTimeseriesReportApiV1AccountingReportsCashFlowTimeseriesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export any advanced report as PDF, XLSX, or CSV.
 * @summary Export Report
 */
export const exportReportApiV1AccountingReportsReportNameExportGet = (
  reportName: string,
  params: ExportReportApiV1AccountingReportsReportNameExportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/reports/${reportName}/export`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportReportApiV1AccountingReportsReportNameExportGetQueryKey =
  (
    reportName?: string,
    params?: ExportReportApiV1AccountingReportsReportNameExportGetParams
  ) => {
    return [
      `/api/v1/accounting/reports/${reportName}/export`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExportReportApiV1AccountingReportsReportNameExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
    >,
    TError = HTTPValidationError
  >(
    reportName: string,
    params: ExportReportApiV1AccountingReportsReportNameExportGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportReportApiV1AccountingReportsReportNameExportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportReportApiV1AccountingReportsReportNameExportGetQueryKey(
        reportName,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
      >
    > = ({ signal }) =>
      exportReportApiV1AccountingReportsReportNameExportGet(
        reportName,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!reportName,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportReportApiV1AccountingReportsReportNameExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
    >
  >;
export type ExportReportApiV1AccountingReportsReportNameExportGetQueryError =
  HTTPValidationError;

export function useExportReportApiV1AccountingReportsReportNameExportGet<
  TData = Awaited<
    ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
  >,
  TError = HTTPValidationError
>(
  reportName: string,
  params: ExportReportApiV1AccountingReportsReportNameExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportReportApiV1AccountingReportsReportNameExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportReportApiV1AccountingReportsReportNameExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportReportApiV1AccountingReportsReportNameExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportReportApiV1AccountingReportsReportNameExportGet<
  TData = Awaited<
    ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
  >,
  TError = HTTPValidationError
>(
  reportName: string,
  params: ExportReportApiV1AccountingReportsReportNameExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportReportApiV1AccountingReportsReportNameExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportReportApiV1AccountingReportsReportNameExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportReportApiV1AccountingReportsReportNameExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportReportApiV1AccountingReportsReportNameExportGet<
  TData = Awaited<
    ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
  >,
  TError = HTTPValidationError
>(
  reportName: string,
  params: ExportReportApiV1AccountingReportsReportNameExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportReportApiV1AccountingReportsReportNameExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Report
 */

export function useExportReportApiV1AccountingReportsReportNameExportGet<
  TData = Awaited<
    ReturnType<typeof exportReportApiV1AccountingReportsReportNameExportGet>
  >,
  TError = HTTPValidationError
>(
  reportName: string,
  params: ExportReportApiV1AccountingReportsReportNameExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportReportApiV1AccountingReportsReportNameExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportReportApiV1AccountingReportsReportNameExportGetQueryOptions(
      reportName,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Use AI to suggest the best chart-of-accounts entry for a company.
 * @summary Suggest Account
 */
export const suggestAccountApiV1AccountingSuggestAccountPost = (
  suggestAccountRequest: SuggestAccountRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/suggest-account`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: suggestAccountRequest,
    signal
  });
};

export const getSuggestAccountApiV1AccountingSuggestAccountPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof suggestAccountApiV1AccountingSuggestAccountPost>
      >,
      TError,
      { data: SuggestAccountRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof suggestAccountApiV1AccountingSuggestAccountPost>>,
    TError,
    { data: SuggestAccountRequest },
    TContext
  > => {
    const mutationKey = ['suggestAccountApiV1AccountingSuggestAccountPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof suggestAccountApiV1AccountingSuggestAccountPost>
      >,
      { data: SuggestAccountRequest }
    > = (props) => {
      const { data } = props ?? {};

      return suggestAccountApiV1AccountingSuggestAccountPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type SuggestAccountApiV1AccountingSuggestAccountPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof suggestAccountApiV1AccountingSuggestAccountPost>>
  >;
export type SuggestAccountApiV1AccountingSuggestAccountPostMutationBody =
  SuggestAccountRequest;
export type SuggestAccountApiV1AccountingSuggestAccountPostMutationError =
  HTTPValidationError;

/**
 * @summary Suggest Account
 */
export const useSuggestAccountApiV1AccountingSuggestAccountPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof suggestAccountApiV1AccountingSuggestAccountPost>
      >,
      TError,
      { data: SuggestAccountRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof suggestAccountApiV1AccountingSuggestAccountPost>>,
  TError,
  { data: SuggestAccountRequest },
  TContext
> => {
  const mutationOptions =
    getSuggestAccountApiV1AccountingSuggestAccountPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * One-call AI expense-account suggestion for the smart Create Account dialog:
decide reuse-vs-create, the category + a GAAP-normed name, a couple of
alternatives, and nearby existing accounts to reuse. Numbers for every 'create'
suggestion are allocated deterministically (never by the model). Degrades to a
deterministic suggestion when AI is unavailable, so a usable number always
returns.
 * @summary Suggest Expense Account
 */
export const suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost =
  (
    suggestExpenseAccountRequest: SuggestExpenseAccountRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/accounts/suggest-expense-account`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: suggestExpenseAccountRequest,
      signal
    });
  };

export const getSuggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost
        >
      >,
      TError,
      { data: SuggestExpenseAccountRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost
      >
    >,
    TError,
    { data: SuggestExpenseAccountRequest },
    TContext
  > => {
    const mutationKey = [
      'suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost
        >
      >,
      { data: SuggestExpenseAccountRequest }
    > = (props) => {
      const { data } = props ?? {};

      return suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SuggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost
      >
    >
  >;
export type SuggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPostMutationBody =
  SuggestExpenseAccountRequest;
export type SuggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPostMutationError =
  HTTPValidationError;

/**
 * @summary Suggest Expense Account
 */
export const useSuggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost
          >
        >,
        TError,
        { data: SuggestExpenseAccountRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof suggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPost
      >
    >,
    TError,
    { data: SuggestExpenseAccountRequest },
    TContext
  > => {
    const mutationOptions =
      getSuggestExpenseAccountApiV1AccountingAccountsSuggestExpenseAccountPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Revenue Category Rules
 */
export const listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet = (
  params?: ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet200>(
    {
      url: `/api/v1/accounting/revenue-category-rules`,
      method: 'GET',
      params,
      signal
    }
  );
};

export const getListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetQueryKey =
  (
    params?: ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams
  ) => {
    return [
      `/api/v1/accounting/revenue-category-rules`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
        >
      >
    > = ({ signal }) =>
      listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
      >
    >
  >;
export type ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetQueryError =
  HTTPValidationError;

export function useListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Revenue Category Rules
 */

export function useListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Revenue Category Rule
 */
export const createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost =
  (
    revenueCategoryRuleRequest: RevenueCategoryRuleRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<CreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost201>(
      {
        url: `/api/v1/accounting/revenue-category-rules`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: revenueCategoryRuleRequest,
        signal
      }
    );
  };

export const getCreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost
        >
      >,
      TError,
      { data: RevenueCategoryRuleRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost
      >
    >,
    TError,
    { data: RevenueCategoryRuleRequest },
    TContext
  > => {
    const mutationKey = [
      'createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost
        >
      >,
      { data: RevenueCategoryRuleRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost
      >
    >
  >;
export type CreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPostMutationBody =
  RevenueCategoryRuleRequest;
export type CreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Revenue Category Rule
 */
export const useCreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost
          >
        >,
        TError,
        { data: RevenueCategoryRuleRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPost
      >
    >,
    TError,
    { data: RevenueCategoryRuleRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Bulk Upsert Revenue Category Rules
 */
export const bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost =
  (
    revenueCategoryBulkRequest: RevenueCategoryBulkRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost201>(
      {
        url: `/api/v1/accounting/revenue-category-rules/bulk`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: revenueCategoryBulkRequest,
        signal
      }
    );
  };

export const getBulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost
        >
      >,
      TError,
      { data: RevenueCategoryBulkRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost
      >
    >,
    TError,
    { data: RevenueCategoryBulkRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost
        >
      >,
      { data: RevenueCategoryBulkRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost
      >
    >
  >;
export type BulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPostMutationBody =
  RevenueCategoryBulkRequest;
export type BulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Upsert Revenue Category Rules
 */
export const useBulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost
          >
        >,
        TError,
        { data: RevenueCategoryBulkRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPost
      >
    >,
    TError,
    { data: RevenueCategoryBulkRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkUpsertRevenueCategoryRulesApiV1AccountingRevenueCategoryRulesBulkPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Delete Revenue Category Rule
 */
export const deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete =
  (ruleId: string) => {
    return customInstance<DeleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete200>(
      {
        url: `/api/v1/accounting/revenue-category-rules/${ruleId}`,
        method: 'DELETE'
      }
    );
  };

export const getDeleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete
        >
      >,
      { ruleId: string }
    > = (props) => {
      const { ruleId } = props ?? {};

      return deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete(
        ruleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete
      >
    >
  >;

export type DeleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Revenue Category Rule
 */
export const useDeleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete
          >
        >,
        TError,
        { ruleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteRevenueCategoryRuleApiV1AccountingRevenueCategoryRulesRuleIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Resolve the correct revenue account for an invoice line using the cascade.
 * @summary Resolve Revenue Account
 */
export const resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost =
  (
    resolveRevenueAccountRequest: ResolveRevenueAccountRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost200>(
      {
        url: `/api/v1/accounting/revenue-category-rules/resolve`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: resolveRevenueAccountRequest,
        signal
      }
    );
  };

export const getResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost
        >
      >,
      TError,
      { data: ResolveRevenueAccountRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost
      >
    >,
    TError,
    { data: ResolveRevenueAccountRequest },
    TContext
  > => {
    const mutationKey = [
      'resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost
        >
      >,
      { data: ResolveRevenueAccountRequest }
    > = (props) => {
      const { data } = props ?? {};

      return resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost
      >
    >
  >;
export type ResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePostMutationBody =
  ResolveRevenueAccountRequest;
export type ResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePostMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Revenue Account
 */
export const useResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost
          >
        >,
        TError,
        { data: ResolveRevenueAccountRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePost
      >
    >,
    TError,
    { data: ResolveRevenueAccountRequest },
    TContext
  > => {
    const mutationOptions =
      getResolveRevenueAccountApiV1AccountingRevenueCategoryRulesResolvePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Expense Category Rules
 */
export const listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet = (
  params?: ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet200>(
    {
      url: `/api/v1/accounting/expense-category-rules`,
      method: 'GET',
      params,
      signal
    }
  );
};

export const getListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetQueryKey =
  (
    params?: ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams
  ) => {
    return [
      `/api/v1/accounting/expense-category-rules`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
        >
      >
    > = ({ signal }) =>
      listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
      >
    >
  >;
export type ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetQueryError =
  HTTPValidationError;

export function useListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Expense Category Rules
 */

export function useListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Expense Category Rule
 */
export const createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost =
  (
    expenseCategoryRuleRequest: ExpenseCategoryRuleRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<CreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost201>(
      {
        url: `/api/v1/accounting/expense-category-rules`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: expenseCategoryRuleRequest,
        signal
      }
    );
  };

export const getCreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost
        >
      >,
      TError,
      { data: ExpenseCategoryRuleRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost
      >
    >,
    TError,
    { data: ExpenseCategoryRuleRequest },
    TContext
  > => {
    const mutationKey = [
      'createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost
        >
      >,
      { data: ExpenseCategoryRuleRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost
      >
    >
  >;
export type CreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPostMutationBody =
  ExpenseCategoryRuleRequest;
export type CreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Expense Category Rule
 */
export const useCreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost
          >
        >,
        TError,
        { data: ExpenseCategoryRuleRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPost
      >
    >,
    TError,
    { data: ExpenseCategoryRuleRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Bulk Upsert Expense Category Rules
 */
export const bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost =
  (
    expenseCategoryBulkRequest: ExpenseCategoryBulkRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost201>(
      {
        url: `/api/v1/accounting/expense-category-rules/bulk`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: expenseCategoryBulkRequest,
        signal
      }
    );
  };

export const getBulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost
        >
      >,
      TError,
      { data: ExpenseCategoryBulkRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost
      >
    >,
    TError,
    { data: ExpenseCategoryBulkRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost
        >
      >,
      { data: ExpenseCategoryBulkRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost
      >
    >
  >;
export type BulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPostMutationBody =
  ExpenseCategoryBulkRequest;
export type BulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Upsert Expense Category Rules
 */
export const useBulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost
          >
        >,
        TError,
        { data: ExpenseCategoryBulkRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPost
      >
    >,
    TError,
    { data: ExpenseCategoryBulkRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkUpsertExpenseCategoryRulesApiV1AccountingExpenseCategoryRulesBulkPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Delete Expense Category Rule
 */
export const deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete =
  (ruleId: string) => {
    return customInstance<DeleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete200>(
      {
        url: `/api/v1/accounting/expense-category-rules/${ruleId}`,
        method: 'DELETE'
      }
    );
  };

export const getDeleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete
        >
      >,
      { ruleId: string }
    > = (props) => {
      const { ruleId } = props ?? {};

      return deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete(
        ruleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete
      >
    >
  >;

export type DeleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Expense Category Rule
 */
export const useDeleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete
          >
        >,
        TError,
        { ruleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteExpenseCategoryRuleApiV1AccountingExpenseCategoryRulesRuleIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Resolve the correct expense account for a bill line using the cascade.
 * @summary Resolve Expense Account
 */
export const resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost =
  (
    resolveExpenseAccountRequest: ResolveExpenseAccountRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost200>(
      {
        url: `/api/v1/accounting/expense-category-rules/resolve`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: resolveExpenseAccountRequest,
        signal
      }
    );
  };

export const getResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost
        >
      >,
      TError,
      { data: ResolveExpenseAccountRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost
      >
    >,
    TError,
    { data: ResolveExpenseAccountRequest },
    TContext
  > => {
    const mutationKey = [
      'resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost
        >
      >,
      { data: ResolveExpenseAccountRequest }
    > = (props) => {
      const { data } = props ?? {};

      return resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost
      >
    >
  >;
export type ResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePostMutationBody =
  ResolveExpenseAccountRequest;
export type ResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePostMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Expense Account
 */
export const useResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost
          >
        >,
        TError,
        { data: ResolveExpenseAccountRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePost
      >
    >,
    TError,
    { data: ResolveExpenseAccountRequest },
    TContext
  > => {
    const mutationOptions =
      getResolveExpenseAccountApiV1AccountingExpenseCategoryRulesResolvePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Tax Determination Rules
 */
export const listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet =
  (
    params?: ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/tax-determination-rules`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetQueryKey =
  (
    params?: ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams
  ) => {
    return [
      `/api/v1/accounting/tax-determination-rules`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
        >
      >
    > = ({ signal }) =>
      listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
      >
    >
  >;
export type ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetQueryError =
  HTTPValidationError;

export function useListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tax Determination Rules
 */

export function useListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTaxDeterminationRulesApiV1AccountingTaxDeterminationRulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Tax Determination Rule
 */
export const createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost =
  (
    taxDeterminationRuleCreateRequest: TaxDeterminationRuleCreateRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/tax-determination-rules`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: taxDeterminationRuleCreateRequest,
      signal
    });
  };

export const getCreateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost
        >
      >,
      TError,
      { data: TaxDeterminationRuleCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost
      >
    >,
    TError,
    { data: TaxDeterminationRuleCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost
        >
      >,
      { data: TaxDeterminationRuleCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost
      >
    >
  >;
export type CreateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPostMutationBody =
  TaxDeterminationRuleCreateRequest;
export type CreateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Tax Determination Rule
 */
export const useCreateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost
          >
        >,
        TError,
        { data: TaxDeterminationRuleCreateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPost
      >
    >,
    TError,
    { data: TaxDeterminationRuleCreateRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Tax Determination Rule
 */
export const getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet =
  (ruleId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/tax-determination-rules/${ruleId}`,
      method: 'GET',
      signal
    });
  };

export const getGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGetQueryKey =
  (ruleId?: string) => {
    return [`/api/v1/accounting/tax-determination-rules/${ruleId}`] as const;
  };

export const getGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    ruleId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGetQueryKey(
        ruleId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
        >
      >
    > = ({ signal }) =>
      getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet(
        ruleId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!ruleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
      >
    >
  >;
export type GetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGetQueryError =
  HTTPValidationError;

export function useGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tax Determination Rule
 */

export function useGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdGetQueryOptions(
      ruleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Tax Determination Rule
 */
export const updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut =
  (
    ruleId: string,
    taxDeterminationRuleUpdateRequest: TaxDeterminationRuleUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/tax-determination-rules/${ruleId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: taxDeterminationRuleUpdateRequest
    });
  };

export const getUpdateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut
        >
      >,
      TError,
      { ruleId: string; data: TaxDeterminationRuleUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut
      >
    >,
    TError,
    { ruleId: string; data: TaxDeterminationRuleUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut
        >
      >,
      { ruleId: string; data: TaxDeterminationRuleUpdateRequest }
    > = (props) => {
      const { ruleId, data } = props ?? {};

      return updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut(
        ruleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut
      >
    >
  >;
export type UpdateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPutMutationBody =
  TaxDeterminationRuleUpdateRequest;
export type UpdateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tax Determination Rule
 */
export const useUpdateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut
          >
        >,
        TError,
        { ruleId: string; data: TaxDeterminationRuleUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPut
      >
    >,
    TError,
    { ruleId: string; data: TaxDeterminationRuleUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Delete Tax Determination Rule
 */
export const deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete =
  (ruleId: string) => {
    return customInstance<void>({
      url: `/api/v1/accounting/tax-determination-rules/${ruleId}`,
      method: 'DELETE'
    });
  };

export const getDeleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete
        >
      >,
      { ruleId: string }
    > = (props) => {
      const { ruleId } = props ?? {};

      return deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete(
        ruleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete
      >
    >
  >;

export type DeleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Tax Determination Rule
 */
export const useDeleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete
          >
        >,
        TError,
        { ruleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteTaxDeterminationRuleApiV1AccountingTaxDeterminationRulesRuleIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Preview the tax rate that would be applied for a given line context.
 * @summary Resolve Tax Determination
 */
export const resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost =
  (
    taxDeterminationResolveRequest: TaxDeterminationResolveRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/tax-determination/resolve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: taxDeterminationResolveRequest,
      signal
    });
  };

export const getResolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost
        >
      >,
      TError,
      { data: TaxDeterminationResolveRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost
      >
    >,
    TError,
    { data: TaxDeterminationResolveRequest },
    TContext
  > => {
    const mutationKey = [
      'resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost
        >
      >,
      { data: TaxDeterminationResolveRequest }
    > = (props) => {
      const { data } = props ?? {};

      return resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost
      >
    >
  >;
export type ResolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePostMutationBody =
  TaxDeterminationResolveRequest;
export type ResolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePostMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Tax Determination
 */
export const useResolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost
          >
        >,
        TError,
        { data: TaxDeterminationResolveRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePost
      >
    >,
    TError,
    { data: TaxDeterminationResolveRequest },
    TContext
  > => {
    const mutationOptions =
      getResolveTaxDeterminationApiV1AccountingTaxDeterminationResolvePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Accounting dashboard KPIs: cash/receivables/payables balances, the trailing
12-month net-profit series, the dominant-currency AR-aging breakdown, and the
recent journal-entries feed.

Served through the shared KPI substrate (schema-first ``response_model`` +
``cached_kpi``); see docs/platform/dashboard-kpi-endpoints.md. The two governed-type
scopes (``accounting.invoice`` / ``accounting.bill``, set-based ``SELECT id``) and
the active-company scope are resolved HERE, outside ``cached_kpi``, per the ordering
invariant — resolving the scopes per request is what writes the bounded
``admin_override_read`` audit row for a Full-Access admin's universal read (a cache
hit must not skip it) and what 403s a forged ``X-Active-Company-Id``. In a restricted
visibility mode every invoice/bill money aggregate (receivables, payables, P&L, AR
aging) is scoped and the payload is per-viewer; in everyone mode / for tenant admins
the scopes are None and the numbers are byte-identical to today.
 * @summary Get Accounting Dashboard
 */
export const getAccountingDashboardApiV1AccountingDashboardGet = (
  params?: GetAccountingDashboardApiV1AccountingDashboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<AccountingDashboard>({
    url: `/api/v1/accounting/dashboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetAccountingDashboardApiV1AccountingDashboardGetQueryKey = (
  params?: GetAccountingDashboardApiV1AccountingDashboardGetParams
) => {
  return [`/api/v1/accounting/dashboard`, ...(params ? [params] : [])] as const;
};

export const getGetAccountingDashboardApiV1AccountingDashboardGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetAccountingDashboardApiV1AccountingDashboardGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAccountingDashboardApiV1AccountingDashboardGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
      >
    > = ({ signal }) =>
      getAccountingDashboardApiV1AccountingDashboardGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAccountingDashboardApiV1AccountingDashboardGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
    >
  >;
export type GetAccountingDashboardApiV1AccountingDashboardGetQueryError =
  HTTPValidationError;

export function useGetAccountingDashboardApiV1AccountingDashboardGet<
  TData = Awaited<
    ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetAccountingDashboardApiV1AccountingDashboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAccountingDashboardApiV1AccountingDashboardGet<
  TData = Awaited<
    ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetAccountingDashboardApiV1AccountingDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAccountingDashboardApiV1AccountingDashboardGet<
  TData = Awaited<
    ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetAccountingDashboardApiV1AccountingDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Accounting Dashboard
 */

export function useGetAccountingDashboardApiV1AccountingDashboardGet<
  TData = Awaited<
    ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetAccountingDashboardApiV1AccountingDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAccountingDashboardApiV1AccountingDashboardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAccountingDashboardApiV1AccountingDashboardGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return P&L grouped by office for the period (forwarder-only).
 * @summary Get Pnl By Office
 */
export const getPnlByOfficeApiV1AccountingPnlByOfficeGet = (
  params: GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PnlByOfficeResponse>({
    url: `/api/v1/accounting/pnl-by-office`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPnlByOfficeApiV1AccountingPnlByOfficeGetQueryKey = (
  params?: GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams
) => {
  return [
    `/api/v1/accounting/pnl-by-office`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetPnlByOfficeApiV1AccountingPnlByOfficeGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPnlByOfficeApiV1AccountingPnlByOfficeGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>
  > = ({ signal }) =>
    getPnlByOfficeApiV1AccountingPnlByOfficeGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPnlByOfficeApiV1AccountingPnlByOfficeGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>
  >;
export type GetPnlByOfficeApiV1AccountingPnlByOfficeGetQueryError =
  HTTPValidationError;

export function useGetPnlByOfficeApiV1AccountingPnlByOfficeGet<
  TData = Awaited<
    ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPnlByOfficeApiV1AccountingPnlByOfficeGet<
  TData = Awaited<
    ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPnlByOfficeApiV1AccountingPnlByOfficeGet<
  TData = Awaited<
    ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pnl By Office
 */

export function useGetPnlByOfficeApiV1AccountingPnlByOfficeGet<
  TData = Awaited<
    ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlByOfficeApiV1AccountingPnlByOfficeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPnlByOfficeApiV1AccountingPnlByOfficeGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPnlByOfficeApiV1AccountingPnlByOfficeGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One page of the source-currency documents behind an office's P&L.
 * @summary Get Pnl Office Details
 */
export const getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet = (
  params: GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PnlOfficeDetailsResponse>({
    url: `/api/v1/accounting/pnl-by-office/details`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetQueryKey =
  (params?: GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams) => {
    return [
      `/api/v1/accounting/pnl-by-office/details`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet>
    >,
    TError = HTTPValidationError
  >(
    params: GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
        >
      >
    > = ({ signal }) =>
      getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet>
    >
  >;
export type GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetQueryError =
  HTTPValidationError;

export function useGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet<
  TData = Awaited<
    ReturnType<typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet<
  TData = Awaited<
    ReturnType<typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet<
  TData = Awaited<
    ReturnType<typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pnl Office Details
 */

export function useGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet<
  TData = Awaited<
    ReturnType<typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet>
  >,
  TError = HTTPValidationError
>(
  params: GetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPnlOfficeDetailsApiV1AccountingPnlByOfficeDetailsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List analytic dimensions for the tenant.
 * @summary List Dimensions
 */
export const listDimensionsApiV1AccountingDimensionsGet = (
  params?: ListDimensionsApiV1AccountingDimensionsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/dimensions`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDimensionsApiV1AccountingDimensionsGetQueryKey = (
  params?: ListDimensionsApiV1AccountingDimensionsGetParams
) => {
  return [
    `/api/v1/accounting/dimensions`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListDimensionsApiV1AccountingDimensionsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDimensionsApiV1AccountingDimensionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDimensionsApiV1AccountingDimensionsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>
  > = ({ signal }) =>
    listDimensionsApiV1AccountingDimensionsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDimensionsApiV1AccountingDimensionsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>
>;
export type ListDimensionsApiV1AccountingDimensionsGetQueryError =
  HTTPValidationError;

export function useListDimensionsApiV1AccountingDimensionsGet<
  TData = Awaited<
    ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListDimensionsApiV1AccountingDimensionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDimensionsApiV1AccountingDimensionsGet<
  TData = Awaited<
    ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDimensionsApiV1AccountingDimensionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDimensionsApiV1AccountingDimensionsGet<
  TData = Awaited<
    ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDimensionsApiV1AccountingDimensionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dimensions
 */

export function useListDimensionsApiV1AccountingDimensionsGet<
  TData = Awaited<
    ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDimensionsApiV1AccountingDimensionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDimensionsApiV1AccountingDimensionsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDimensionsApiV1AccountingDimensionsGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a tenant analytic dimension (axis).
 * @summary Create Dimension
 */
export const createDimensionApiV1AccountingDimensionsPost = (
  dimensionCreate: DimensionCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/dimensions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dimensionCreate,
    signal
  });
};

export const getCreateDimensionApiV1AccountingDimensionsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDimensionApiV1AccountingDimensionsPost>>,
    TError,
    { data: DimensionCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDimensionApiV1AccountingDimensionsPost>>,
  TError,
  { data: DimensionCreate },
  TContext
> => {
  const mutationKey = ['createDimensionApiV1AccountingDimensionsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDimensionApiV1AccountingDimensionsPost>>,
    { data: DimensionCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createDimensionApiV1AccountingDimensionsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDimensionApiV1AccountingDimensionsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createDimensionApiV1AccountingDimensionsPost>>
  >;
export type CreateDimensionApiV1AccountingDimensionsPostMutationBody =
  DimensionCreate;
export type CreateDimensionApiV1AccountingDimensionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Dimension
 */
export const useCreateDimensionApiV1AccountingDimensionsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDimensionApiV1AccountingDimensionsPost>>,
      TError,
      { data: DimensionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDimensionApiV1AccountingDimensionsPost>>,
  TError,
  { data: DimensionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateDimensionApiV1AccountingDimensionsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Dimension
 */
export const getDimensionApiV1AccountingDimensionsDimensionIdGet = (
  dimensionId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/dimensions/${dimensionId}`,
    method: 'GET',
    signal
  });
};

export const getGetDimensionApiV1AccountingDimensionsDimensionIdGetQueryKey = (
  dimensionId?: string
) => {
  return [`/api/v1/accounting/dimensions/${dimensionId}`] as const;
};

export const getGetDimensionApiV1AccountingDimensionsDimensionIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
    >,
    TError = HTTPValidationError
  >(
    dimensionId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDimensionApiV1AccountingDimensionsDimensionIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDimensionApiV1AccountingDimensionsDimensionIdGetQueryKey(
        dimensionId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
      >
    > = ({ signal }) =>
      getDimensionApiV1AccountingDimensionsDimensionIdGet(dimensionId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!dimensionId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDimensionApiV1AccountingDimensionsDimensionIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
    >
  >;
export type GetDimensionApiV1AccountingDimensionsDimensionIdGetQueryError =
  HTTPValidationError;

export function useGetDimensionApiV1AccountingDimensionsDimensionIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDimensionApiV1AccountingDimensionsDimensionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDimensionApiV1AccountingDimensionsDimensionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDimensionApiV1AccountingDimensionsDimensionIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDimensionApiV1AccountingDimensionsDimensionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDimensionApiV1AccountingDimensionsDimensionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDimensionApiV1AccountingDimensionsDimensionIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dimension
 */

export function useGetDimensionApiV1AccountingDimensionsDimensionIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDimensionApiV1AccountingDimensionsDimensionIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDimensionApiV1AccountingDimensionsDimensionIdGetQueryOptions(
      dimensionId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Dimension
 */
export const updateDimensionApiV1AccountingDimensionsDimensionIdPut = (
  dimensionId: string,
  dimensionUpdate: DimensionUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/dimensions/${dimensionId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dimensionUpdate
  });
};

export const getUpdateDimensionApiV1AccountingDimensionsDimensionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDimensionApiV1AccountingDimensionsDimensionIdPut
        >
      >,
      TError,
      { dimensionId: string; data: DimensionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateDimensionApiV1AccountingDimensionsDimensionIdPut>
    >,
    TError,
    { dimensionId: string; data: DimensionUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDimensionApiV1AccountingDimensionsDimensionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDimensionApiV1AccountingDimensionsDimensionIdPut
        >
      >,
      { dimensionId: string; data: DimensionUpdate }
    > = (props) => {
      const { dimensionId, data } = props ?? {};

      return updateDimensionApiV1AccountingDimensionsDimensionIdPut(
        dimensionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDimensionApiV1AccountingDimensionsDimensionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateDimensionApiV1AccountingDimensionsDimensionIdPut>
    >
  >;
export type UpdateDimensionApiV1AccountingDimensionsDimensionIdPutMutationBody =
  DimensionUpdate;
export type UpdateDimensionApiV1AccountingDimensionsDimensionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dimension
 */
export const useUpdateDimensionApiV1AccountingDimensionsDimensionIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDimensionApiV1AccountingDimensionsDimensionIdPut
        >
      >,
      TError,
      { dimensionId: string; data: DimensionUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateDimensionApiV1AccountingDimensionsDimensionIdPut>
  >,
  TError,
  { dimensionId: string; data: DimensionUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateDimensionApiV1AccountingDimensionsDimensionIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Dimension
 */
export const deleteDimensionApiV1AccountingDimensionsDimensionIdDelete = (
  dimensionId: string
) => {
  return customInstance<void>({
    url: `/api/v1/accounting/dimensions/${dimensionId}`,
    method: 'DELETE'
  });
};

export const getDeleteDimensionApiV1AccountingDimensionsDimensionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDimensionApiV1AccountingDimensionsDimensionIdDelete
        >
      >,
      TError,
      { dimensionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDimensionApiV1AccountingDimensionsDimensionIdDelete
      >
    >,
    TError,
    { dimensionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDimensionApiV1AccountingDimensionsDimensionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDimensionApiV1AccountingDimensionsDimensionIdDelete
        >
      >,
      { dimensionId: string }
    > = (props) => {
      const { dimensionId } = props ?? {};

      return deleteDimensionApiV1AccountingDimensionsDimensionIdDelete(
        dimensionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDimensionApiV1AccountingDimensionsDimensionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDimensionApiV1AccountingDimensionsDimensionIdDelete
      >
    >
  >;

export type DeleteDimensionApiV1AccountingDimensionsDimensionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Dimension
 */
export const useDeleteDimensionApiV1AccountingDimensionsDimensionIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDimensionApiV1AccountingDimensionsDimensionIdDelete
        >
      >,
      TError,
      { dimensionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteDimensionApiV1AccountingDimensionsDimensionIdDelete>
  >,
  TError,
  { dimensionId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteDimensionApiV1AccountingDimensionsDimensionIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List values within a dimension, ordered by hierarchy path.
 * @summary List Dimension Values
 */
export const listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet =
  (
    dimensionId: string,
    params?: ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/dimensions/${dimensionId}/values`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetQueryKey =
  (
    dimensionId?: string,
    params?: ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams
  ) => {
    return [
      `/api/v1/accounting/dimensions/${dimensionId}/values`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
      >
    >,
    TError = HTTPValidationError
  >(
    dimensionId: string,
    params?: ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetQueryKey(
        dimensionId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
        >
      >
    > = ({ signal }) =>
      listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet(
        dimensionId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!dimensionId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
      >
    >
  >;
export type ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetQueryError =
  HTTPValidationError;

export function useListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  params:
    | undefined
    | ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  params?: ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  params?: ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dimension Values
 */

export function useListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  dimensionId: string,
  params?: ListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDimensionValuesApiV1AccountingDimensionsDimensionIdValuesGetQueryOptions(
      dimensionId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Dimension Value
 */
export const createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost =
  (
    dimensionId: string,
    dimensionValueCreate: DimensionValueCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/dimensions/${dimensionId}/values`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dimensionValueCreate,
      signal
    });
  };

export const getCreateDimensionValueApiV1AccountingDimensionsDimensionIdValuesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost
        >
      >,
      TError,
      { dimensionId: string; data: DimensionValueCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost
      >
    >,
    TError,
    { dimensionId: string; data: DimensionValueCreate },
    TContext
  > => {
    const mutationKey = [
      'createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost
        >
      >,
      { dimensionId: string; data: DimensionValueCreate }
    > = (props) => {
      const { dimensionId, data } = props ?? {};

      return createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost(
        dimensionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDimensionValueApiV1AccountingDimensionsDimensionIdValuesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost
      >
    >
  >;
export type CreateDimensionValueApiV1AccountingDimensionsDimensionIdValuesPostMutationBody =
  DimensionValueCreate;
export type CreateDimensionValueApiV1AccountingDimensionsDimensionIdValuesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Dimension Value
 */
export const useCreateDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost
          >
        >,
        TError,
        { dimensionId: string; data: DimensionValueCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createDimensionValueApiV1AccountingDimensionsDimensionIdValuesPost
      >
    >,
    TError,
    { dimensionId: string; data: DimensionValueCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateDimensionValueApiV1AccountingDimensionsDimensionIdValuesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Dimension Value
 */
export const getDimensionValueApiV1AccountingDimensionValuesValueIdGet = (
  valueId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/dimension-values/${valueId}`,
    method: 'GET',
    signal
  });
};

export const getGetDimensionValueApiV1AccountingDimensionValuesValueIdGetQueryKey =
  (valueId?: string) => {
    return [`/api/v1/accounting/dimension-values/${valueId}`] as const;
  };

export const getGetDimensionValueApiV1AccountingDimensionValuesValueIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    valueId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDimensionValueApiV1AccountingDimensionValuesValueIdGetQueryKey(
        valueId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
        >
      >
    > = ({ signal }) =>
      getDimensionValueApiV1AccountingDimensionValuesValueIdGet(
        valueId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!valueId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDimensionValueApiV1AccountingDimensionValuesValueIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
      >
    >
  >;
export type GetDimensionValueApiV1AccountingDimensionValuesValueIdGetQueryError =
  HTTPValidationError;

export function useGetDimensionValueApiV1AccountingDimensionValuesValueIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet>
  >,
  TError = HTTPValidationError
>(
  valueId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDimensionValueApiV1AccountingDimensionValuesValueIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet>
  >,
  TError = HTTPValidationError
>(
  valueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDimensionValueApiV1AccountingDimensionValuesValueIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet>
  >,
  TError = HTTPValidationError
>(
  valueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dimension Value
 */

export function useGetDimensionValueApiV1AccountingDimensionValuesValueIdGet<
  TData = Awaited<
    ReturnType<typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet>
  >,
  TError = HTTPValidationError
>(
  valueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionValueApiV1AccountingDimensionValuesValueIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDimensionValueApiV1AccountingDimensionValuesValueIdGetQueryOptions(
      valueId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Dimension Value
 */
export const updateDimensionValueApiV1AccountingDimensionValuesValueIdPut = (
  valueId: string,
  dimensionValueUpdate: DimensionValueUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/dimension-values/${valueId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dimensionValueUpdate
  });
};

export const getUpdateDimensionValueApiV1AccountingDimensionValuesValueIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDimensionValueApiV1AccountingDimensionValuesValueIdPut
        >
      >,
      TError,
      { valueId: string; data: DimensionValueUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDimensionValueApiV1AccountingDimensionValuesValueIdPut
      >
    >,
    TError,
    { valueId: string; data: DimensionValueUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDimensionValueApiV1AccountingDimensionValuesValueIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDimensionValueApiV1AccountingDimensionValuesValueIdPut
        >
      >,
      { valueId: string; data: DimensionValueUpdate }
    > = (props) => {
      const { valueId, data } = props ?? {};

      return updateDimensionValueApiV1AccountingDimensionValuesValueIdPut(
        valueId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDimensionValueApiV1AccountingDimensionValuesValueIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDimensionValueApiV1AccountingDimensionValuesValueIdPut
      >
    >
  >;
export type UpdateDimensionValueApiV1AccountingDimensionValuesValueIdPutMutationBody =
  DimensionValueUpdate;
export type UpdateDimensionValueApiV1AccountingDimensionValuesValueIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dimension Value
 */
export const useUpdateDimensionValueApiV1AccountingDimensionValuesValueIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDimensionValueApiV1AccountingDimensionValuesValueIdPut
        >
      >,
      TError,
      { valueId: string; data: DimensionValueUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateDimensionValueApiV1AccountingDimensionValuesValueIdPut
    >
  >,
  TError,
  { valueId: string; data: DimensionValueUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateDimensionValueApiV1AccountingDimensionValuesValueIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Dimension Value
 */
export const deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete = (
  valueId: string
) => {
  return customInstance<void>({
    url: `/api/v1/accounting/dimension-values/${valueId}`,
    method: 'DELETE'
  });
};

export const getDeleteDimensionValueApiV1AccountingDimensionValuesValueIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete
        >
      >,
      TError,
      { valueId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete
      >
    >,
    TError,
    { valueId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete
        >
      >,
      { valueId: string }
    > = (props) => {
      const { valueId } = props ?? {};

      return deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete(
        valueId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDimensionValueApiV1AccountingDimensionValuesValueIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete
      >
    >
  >;

export type DeleteDimensionValueApiV1AccountingDimensionValuesValueIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Dimension Value
 */
export const useDeleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete
          >
        >,
        TError,
        { valueId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDimensionValueApiV1AccountingDimensionValuesValueIdDelete
      >
    >,
    TError,
    { valueId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDimensionValueApiV1AccountingDimensionValuesValueIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List default-dimension rules for the tenant, enriched with the dimension
and value display names (batch-loaded, N+1-safe) for the management table.
 * @summary List Dimension Default Rules
 */
export const listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet =
  (
    params?: ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/dimension-default-rules`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetQueryKey =
  (
    params?: ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams
  ) => {
    return [
      `/api/v1/accounting/dimension-default-rules`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
        >
      >
    > = ({ signal }) =>
      listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
      >
    >
  >;
export type ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetQueryError =
  HTTPValidationError;

export function useListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dimension Default Rules
 */

export function useListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDimensionDefaultRulesApiV1AccountingDimensionDefaultRulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a default-dimension rule.
 * @summary Create Dimension Default Rule
 */
export const createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost =
  (
    dimensionDefaultRuleCreate: DimensionDefaultRuleCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/dimension-default-rules`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dimensionDefaultRuleCreate,
      signal
    });
  };

export const getCreateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost
        >
      >,
      TError,
      { data: DimensionDefaultRuleCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost
      >
    >,
    TError,
    { data: DimensionDefaultRuleCreate },
    TContext
  > => {
    const mutationKey = [
      'createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost
        >
      >,
      { data: DimensionDefaultRuleCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost
      >
    >
  >;
export type CreateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPostMutationBody =
  DimensionDefaultRuleCreate;
export type CreateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Dimension Default Rule
 */
export const useCreateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost
          >
        >,
        TError,
        { data: DimensionDefaultRuleCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPost
      >
    >,
    TError,
    { data: DimensionDefaultRuleCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Dimension Default Rule
 */
export const getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet =
  (ruleId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/dimension-default-rules/${ruleId}`,
      method: 'GET',
      signal
    });
  };

export const getGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGetQueryKey =
  (ruleId?: string) => {
    return [`/api/v1/accounting/dimension-default-rules/${ruleId}`] as const;
  };

export const getGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    ruleId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGetQueryKey(
        ruleId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
        >
      >
    > = ({ signal }) =>
      getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet(
        ruleId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!ruleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
      >
    >
  >;
export type GetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGetQueryError =
  HTTPValidationError;

export function useGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dimension Default Rule
 */

export function useGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdGetQueryOptions(
      ruleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Dimension Default Rule
 */
export const updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut =
  (ruleId: string, dimensionDefaultRuleUpdate: DimensionDefaultRuleUpdate) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/dimension-default-rules/${ruleId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dimensionDefaultRuleUpdate
    });
  };

export const getUpdateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut
        >
      >,
      TError,
      { ruleId: string; data: DimensionDefaultRuleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut
      >
    >,
    TError,
    { ruleId: string; data: DimensionDefaultRuleUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut
        >
      >,
      { ruleId: string; data: DimensionDefaultRuleUpdate }
    > = (props) => {
      const { ruleId, data } = props ?? {};

      return updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut(
        ruleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut
      >
    >
  >;
export type UpdateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPutMutationBody =
  DimensionDefaultRuleUpdate;
export type UpdateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dimension Default Rule
 */
export const useUpdateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut
          >
        >,
        TError,
        { ruleId: string; data: DimensionDefaultRuleUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPut
      >
    >,
    TError,
    { ruleId: string; data: DimensionDefaultRuleUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Delete Dimension Default Rule
 */
export const deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete =
  (ruleId: string) => {
    return customInstance<void>({
      url: `/api/v1/accounting/dimension-default-rules/${ruleId}`,
      method: 'DELETE'
    });
  };

export const getDeleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete
        >
      >,
      { ruleId: string }
    > = (props) => {
      const { ruleId } = props ?? {};

      return deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete(
        ruleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete
      >
    >
  >;

export type DeleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Dimension Default Rule
 */
export const useDeleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete
          >
        >,
        TError,
        { ruleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDimensionDefaultRuleApiV1AccountingDimensionDefaultRulesRuleIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
